var map = {
	"./obs_spei12_1950_na_na_na_10_eobs.png": 695016,
	"./obs_spei12_1950_na_na_na_11_eobs.png": 31964,
	"./obs_spei12_1950_na_na_na_12_eobs.png": 433228,
	"./obs_spei12_1950_na_na_na_1_eobs.png": 454168,
	"./obs_spei12_1950_na_na_na_2_eobs.png": 342756,
	"./obs_spei12_1950_na_na_na_3_eobs.png": 409400,
	"./obs_spei12_1950_na_na_na_4_eobs.png": 535628,
	"./obs_spei12_1950_na_na_na_5_eobs.png": 861912,
	"./obs_spei12_1950_na_na_na_6_eobs.png": 52804,
	"./obs_spei12_1950_na_na_na_7_eobs.png": 19012,
	"./obs_spei12_1950_na_na_na_8_eobs.png": 989712,
	"./obs_spei12_1950_na_na_na_9_eobs.png": 898312,
	"./obs_spei12_1951_na_na_na_10_eobs.png": 306412,
	"./obs_spei12_1951_na_na_na_11_eobs.png": 119796,
	"./obs_spei12_1951_na_na_na_12_eobs.png": 255368,
	"./obs_spei12_1951_na_na_na_1_eobs.png": 35400,
	"./obs_spei12_1951_na_na_na_2_eobs.png": 696056,
	"./obs_spei12_1951_na_na_na_3_eobs.png": 113772,
	"./obs_spei12_1951_na_na_na_4_eobs.png": 555240,
	"./obs_spei12_1951_na_na_na_5_eobs.png": 815328,
	"./obs_spei12_1951_na_na_na_6_eobs.png": 249980,
	"./obs_spei12_1951_na_na_na_7_eobs.png": 225344,
	"./obs_spei12_1951_na_na_na_8_eobs.png": 875324,
	"./obs_spei12_1951_na_na_na_9_eobs.png": 999284,
	"./obs_spei12_1952_na_na_na_10_eobs.png": 268556,
	"./obs_spei12_1952_na_na_na_11_eobs.png": 917188,
	"./obs_spei12_1952_na_na_na_12_eobs.png": 42932,
	"./obs_spei12_1952_na_na_na_1_eobs.png": 401240,
	"./obs_spei12_1952_na_na_na_2_eobs.png": 220948,
	"./obs_spei12_1952_na_na_na_3_eobs.png": 986744,
	"./obs_spei12_1952_na_na_na_4_eobs.png": 19048,
	"./obs_spei12_1952_na_na_na_5_eobs.png": 242948,
	"./obs_spei12_1952_na_na_na_6_eobs.png": 158689,
	"./obs_spei12_1952_na_na_na_7_eobs.png": 923080,
	"./obs_spei12_1952_na_na_na_8_eobs.png": 136076,
	"./obs_spei12_1952_na_na_na_9_eobs.png": 205748,
	"./obs_spei12_1953_na_na_na_10_eobs.png": 936620,
	"./obs_spei12_1953_na_na_na_11_eobs.png": 158412,
	"./obs_spei12_1953_na_na_na_12_eobs.png": 233700,
	"./obs_spei12_1953_na_na_na_1_eobs.png": 252876,
	"./obs_spei12_1953_na_na_na_2_eobs.png": 140288,
	"./obs_spei12_1953_na_na_na_3_eobs.png": 16092,
	"./obs_spei12_1953_na_na_na_4_eobs.png": 824316,
	"./obs_spei12_1953_na_na_na_5_eobs.png": 988076,
	"./obs_spei12_1953_na_na_na_6_eobs.png": 716925,
	"./obs_spei12_1953_na_na_na_7_eobs.png": 683460,
	"./obs_spei12_1953_na_na_na_8_eobs.png": 437540,
	"./obs_spei12_1953_na_na_na_9_eobs.png": 158668,
	"./obs_spei12_1954_na_na_na_10_eobs.png": 220660,
	"./obs_spei12_1954_na_na_na_11_eobs.png": 601504,
	"./obs_spei12_1954_na_na_na_12_eobs.png": 439036,
	"./obs_spei12_1954_na_na_na_1_eobs.png": 139260,
	"./obs_spei12_1954_na_na_na_2_eobs.png": 450048,
	"./obs_spei12_1954_na_na_na_3_eobs.png": 196588,
	"./obs_spei12_1954_na_na_na_4_eobs.png": 856356,
	"./obs_spei12_1954_na_na_na_5_eobs.png": 195884,
	"./obs_spei12_1954_na_na_na_6_eobs.png": 19244,
	"./obs_spei12_1954_na_na_na_7_eobs.png": 634908,
	"./obs_spei12_1954_na_na_na_8_eobs.png": 847800,
	"./obs_spei12_1954_na_na_na_9_eobs.png": 967092,
	"./obs_spei12_1955_na_na_na_10_eobs.png": 312700,
	"./obs_spei12_1955_na_na_na_11_eobs.png": 304164,
	"./obs_spei12_1955_na_na_na_12_eobs.png": 671964,
	"./obs_spei12_1955_na_na_na_1_eobs.png": 425896,
	"./obs_spei12_1955_na_na_na_2_eobs.png": 778956,
	"./obs_spei12_1955_na_na_na_3_eobs.png": 847332,
	"./obs_spei12_1955_na_na_na_4_eobs.png": 478972,
	"./obs_spei12_1955_na_na_na_5_eobs.png": 176548,
	"./obs_spei12_1955_na_na_na_6_eobs.png": 193004,
	"./obs_spei12_1955_na_na_na_7_eobs.png": 354992,
	"./obs_spei12_1955_na_na_na_8_eobs.png": 835732,
	"./obs_spei12_1955_na_na_na_9_eobs.png": 482384,
	"./obs_spei12_1956_na_na_na_10_eobs.png": 461592,
	"./obs_spei12_1956_na_na_na_11_eobs.png": 851888,
	"./obs_spei12_1956_na_na_na_12_eobs.png": 434364,
	"./obs_spei12_1956_na_na_na_1_eobs.png": 63412,
	"./obs_spei12_1956_na_na_na_2_eobs.png": 683728,
	"./obs_spei12_1956_na_na_na_3_eobs.png": 286376,
	"./obs_spei12_1956_na_na_na_4_eobs.png": 959644,
	"./obs_spei12_1956_na_na_na_5_eobs.png": 216920,
	"./obs_spei12_1956_na_na_na_6_eobs.png": 102180,
	"./obs_spei12_1956_na_na_na_7_eobs.png": 93511,
	"./obs_spei12_1956_na_na_na_8_eobs.png": 163560,
	"./obs_spei12_1956_na_na_na_9_eobs.png": 152512,
	"./obs_spei12_1957_na_na_na_10_eobs.png": 812648,
	"./obs_spei12_1957_na_na_na_11_eobs.png": 900247,
	"./obs_spei12_1957_na_na_na_12_eobs.png": 821680,
	"./obs_spei12_1957_na_na_na_1_eobs.png": 630000,
	"./obs_spei12_1957_na_na_na_2_eobs.png": 594632,
	"./obs_spei12_1957_na_na_na_3_eobs.png": 662079,
	"./obs_spei12_1957_na_na_na_4_eobs.png": 130100,
	"./obs_spei12_1957_na_na_na_5_eobs.png": 413036,
	"./obs_spei12_1957_na_na_na_6_eobs.png": 88736,
	"./obs_spei12_1957_na_na_na_7_eobs.png": 80892,
	"./obs_spei12_1957_na_na_na_8_eobs.png": 243180,
	"./obs_spei12_1957_na_na_na_9_eobs.png": 21648,
	"./obs_spei12_1958_na_na_na_10_eobs.png": 37980,
	"./obs_spei12_1958_na_na_na_11_eobs.png": 133416,
	"./obs_spei12_1958_na_na_na_12_eobs.png": 994236,
	"./obs_spei12_1958_na_na_na_1_eobs.png": 433172,
	"./obs_spei12_1958_na_na_na_2_eobs.png": 838580,
	"./obs_spei12_1958_na_na_na_3_eobs.png": 153304,
	"./obs_spei12_1958_na_na_na_4_eobs.png": 82656,
	"./obs_spei12_1958_na_na_na_5_eobs.png": 867064,
	"./obs_spei12_1958_na_na_na_6_eobs.png": 187268,
	"./obs_spei12_1958_na_na_na_7_eobs.png": 976532,
	"./obs_spei12_1958_na_na_na_8_eobs.png": 677328,
	"./obs_spei12_1958_na_na_na_9_eobs.png": 383520,
	"./obs_spei12_1959_na_na_na_10_eobs.png": 678956,
	"./obs_spei12_1959_na_na_na_11_eobs.png": 660560,
	"./obs_spei12_1959_na_na_na_12_eobs.png": 871468,
	"./obs_spei12_1959_na_na_na_1_eobs.png": 941376,
	"./obs_spei12_1959_na_na_na_2_eobs.png": 450060,
	"./obs_spei12_1959_na_na_na_3_eobs.png": 124312,
	"./obs_spei12_1959_na_na_na_4_eobs.png": 580903,
	"./obs_spei12_1959_na_na_na_5_eobs.png": 590224,
	"./obs_spei12_1959_na_na_na_6_eobs.png": 27076,
	"./obs_spei12_1959_na_na_na_7_eobs.png": 399740,
	"./obs_spei12_1959_na_na_na_8_eobs.png": 310772,
	"./obs_spei12_1959_na_na_na_9_eobs.png": 476340,
	"./obs_spei12_1960_na_na_na_10_eobs.png": 573996,
	"./obs_spei12_1960_na_na_na_11_eobs.png": 225404,
	"./obs_spei12_1960_na_na_na_12_eobs.png": 469384,
	"./obs_spei12_1960_na_na_na_1_eobs.png": 246976,
	"./obs_spei12_1960_na_na_na_2_eobs.png": 193044,
	"./obs_spei12_1960_na_na_na_3_eobs.png": 5212,
	"./obs_spei12_1960_na_na_na_4_eobs.png": 925604,
	"./obs_spei12_1960_na_na_na_5_eobs.png": 654916,
	"./obs_spei12_1960_na_na_na_6_eobs.png": 689632,
	"./obs_spei12_1960_na_na_na_7_eobs.png": 701204,
	"./obs_spei12_1960_na_na_na_8_eobs.png": 774768,
	"./obs_spei12_1960_na_na_na_9_eobs.png": 706748,
	"./obs_spei12_1961_na_na_na_10_eobs.png": 500672,
	"./obs_spei12_1961_na_na_na_11_eobs.png": 740024,
	"./obs_spei12_1961_na_na_na_12_eobs.png": 649092,
	"./obs_spei12_1961_na_na_na_1_eobs.png": 326784,
	"./obs_spei12_1961_na_na_na_2_eobs.png": 141136,
	"./obs_spei12_1961_na_na_na_3_eobs.png": 17576,
	"./obs_spei12_1961_na_na_na_4_eobs.png": 227660,
	"./obs_spei12_1961_na_na_na_5_eobs.png": 786872,
	"./obs_spei12_1961_na_na_na_6_eobs.png": 6476,
	"./obs_spei12_1961_na_na_na_7_eobs.png": 256452,
	"./obs_spei12_1961_na_na_na_8_eobs.png": 115956,
	"./obs_spei12_1961_na_na_na_9_eobs.png": 831024,
	"./obs_spei12_1962_na_na_na_10_eobs.png": 803024,
	"./obs_spei12_1962_na_na_na_11_eobs.png": 355528,
	"./obs_spei12_1962_na_na_na_12_eobs.png": 567740,
	"./obs_spei12_1962_na_na_na_1_eobs.png": 161944,
	"./obs_spei12_1962_na_na_na_2_eobs.png": 775496,
	"./obs_spei12_1962_na_na_na_3_eobs.png": 245448,
	"./obs_spei12_1962_na_na_na_4_eobs.png": 320176,
	"./obs_spei12_1962_na_na_na_5_eobs.png": 834240,
	"./obs_spei12_1962_na_na_na_6_eobs.png": 877756,
	"./obs_spei12_1962_na_na_na_7_eobs.png": 200584,
	"./obs_spei12_1962_na_na_na_8_eobs.png": 564636,
	"./obs_spei12_1962_na_na_na_9_eobs.png": 810884,
	"./obs_spei12_1963_na_na_na_10_eobs.png": 647108,
	"./obs_spei12_1963_na_na_na_11_eobs.png": 713628,
	"./obs_spei12_1963_na_na_na_12_eobs.png": 940948,
	"./obs_spei12_1963_na_na_na_1_eobs.png": 318696,
	"./obs_spei12_1963_na_na_na_2_eobs.png": 612351,
	"./obs_spei12_1963_na_na_na_3_eobs.png": 682200,
	"./obs_spei12_1963_na_na_na_4_eobs.png": 788288,
	"./obs_spei12_1963_na_na_na_5_eobs.png": 268820,
	"./obs_spei12_1963_na_na_na_6_eobs.png": 727352,
	"./obs_spei12_1963_na_na_na_7_eobs.png": 473432,
	"./obs_spei12_1963_na_na_na_8_eobs.png": 572008,
	"./obs_spei12_1963_na_na_na_9_eobs.png": 552832,
	"./obs_spei12_1964_na_na_na_10_eobs.png": 499580,
	"./obs_spei12_1964_na_na_na_11_eobs.png": 249284,
	"./obs_spei12_1964_na_na_na_12_eobs.png": 780384,
	"./obs_spei12_1964_na_na_na_1_eobs.png": 349480,
	"./obs_spei12_1964_na_na_na_2_eobs.png": 39668,
	"./obs_spei12_1964_na_na_na_3_eobs.png": 293292,
	"./obs_spei12_1964_na_na_na_4_eobs.png": 884656,
	"./obs_spei12_1964_na_na_na_5_eobs.png": 738700,
	"./obs_spei12_1964_na_na_na_6_eobs.png": 984696,
	"./obs_spei12_1964_na_na_na_7_eobs.png": 235316,
	"./obs_spei12_1964_na_na_na_8_eobs.png": 113016,
	"./obs_spei12_1964_na_na_na_9_eobs.png": 674864,
	"./obs_spei12_1965_na_na_na_10_eobs.png": 744912,
	"./obs_spei12_1965_na_na_na_11_eobs.png": 852464,
	"./obs_spei12_1965_na_na_na_12_eobs.png": 641676,
	"./obs_spei12_1965_na_na_na_1_eobs.png": 41800,
	"./obs_spei12_1965_na_na_na_2_eobs.png": 61341,
	"./obs_spei12_1965_na_na_na_3_eobs.png": 750912,
	"./obs_spei12_1965_na_na_na_4_eobs.png": 689416,
	"./obs_spei12_1965_na_na_na_5_eobs.png": 972076,
	"./obs_spei12_1965_na_na_na_6_eobs.png": 965724,
	"./obs_spei12_1965_na_na_na_7_eobs.png": 214352,
	"./obs_spei12_1965_na_na_na_8_eobs.png": 454568,
	"./obs_spei12_1965_na_na_na_9_eobs.png": 547888,
	"./obs_spei12_1966_na_na_na_10_eobs.png": 649232,
	"./obs_spei12_1966_na_na_na_11_eobs.png": 601324,
	"./obs_spei12_1966_na_na_na_12_eobs.png": 368168,
	"./obs_spei12_1966_na_na_na_1_eobs.png": 836276,
	"./obs_spei12_1966_na_na_na_2_eobs.png": 753800,
	"./obs_spei12_1966_na_na_na_3_eobs.png": 418244,
	"./obs_spei12_1966_na_na_na_4_eobs.png": 609488,
	"./obs_spei12_1966_na_na_na_5_eobs.png": 955444,
	"./obs_spei12_1966_na_na_na_6_eobs.png": 194808,
	"./obs_spei12_1966_na_na_na_7_eobs.png": 192212,
	"./obs_spei12_1966_na_na_na_8_eobs.png": 896088,
	"./obs_spei12_1966_na_na_na_9_eobs.png": 586824,
	"./obs_spei12_1967_na_na_na_10_eobs.png": 730839,
	"./obs_spei12_1967_na_na_na_11_eobs.png": 540047,
	"./obs_spei12_1967_na_na_na_12_eobs.png": 452960,
	"./obs_spei12_1967_na_na_na_1_eobs.png": 105252,
	"./obs_spei12_1967_na_na_na_2_eobs.png": 499568,
	"./obs_spei12_1967_na_na_na_3_eobs.png": 433433,
	"./obs_spei12_1967_na_na_na_4_eobs.png": 805180,
	"./obs_spei12_1967_na_na_na_5_eobs.png": 954416,
	"./obs_spei12_1967_na_na_na_6_eobs.png": 676828,
	"./obs_spei12_1967_na_na_na_7_eobs.png": 559828,
	"./obs_spei12_1967_na_na_na_8_eobs.png": 43928,
	"./obs_spei12_1967_na_na_na_9_eobs.png": 609292,
	"./obs_spei12_1968_na_na_na_10_eobs.png": 371960,
	"./obs_spei12_1968_na_na_na_11_eobs.png": 366916,
	"./obs_spei12_1968_na_na_na_12_eobs.png": 240008,
	"./obs_spei12_1968_na_na_na_1_eobs.png": 903968,
	"./obs_spei12_1968_na_na_na_2_eobs.png": 133412,
	"./obs_spei12_1968_na_na_na_3_eobs.png": 159220,
	"./obs_spei12_1968_na_na_na_4_eobs.png": 231956,
	"./obs_spei12_1968_na_na_na_5_eobs.png": 974192,
	"./obs_spei12_1968_na_na_na_6_eobs.png": 508652,
	"./obs_spei12_1968_na_na_na_7_eobs.png": 810332,
	"./obs_spei12_1968_na_na_na_8_eobs.png": 140752,
	"./obs_spei12_1968_na_na_na_9_eobs.png": 857132,
	"./obs_spei12_1969_na_na_na_10_eobs.png": 727612,
	"./obs_spei12_1969_na_na_na_11_eobs.png": 530428,
	"./obs_spei12_1969_na_na_na_12_eobs.png": 742072,
	"./obs_spei12_1969_na_na_na_1_eobs.png": 551668,
	"./obs_spei12_1969_na_na_na_2_eobs.png": 528348,
	"./obs_spei12_1969_na_na_na_3_eobs.png": 169724,
	"./obs_spei12_1969_na_na_na_4_eobs.png": 411496,
	"./obs_spei12_1969_na_na_na_5_eobs.png": 18744,
	"./obs_spei12_1969_na_na_na_6_eobs.png": 990112,
	"./obs_spei12_1969_na_na_na_7_eobs.png": 92068,
	"./obs_spei12_1969_na_na_na_8_eobs.png": 914624,
	"./obs_spei12_1969_na_na_na_9_eobs.png": 648140,
	"./obs_spei12_1970_na_na_na_10_eobs.png": 939756,
	"./obs_spei12_1970_na_na_na_11_eobs.png": 887764,
	"./obs_spei12_1970_na_na_na_12_eobs.png": 268084,
	"./obs_spei12_1970_na_na_na_1_eobs.png": 784836,
	"./obs_spei12_1970_na_na_na_2_eobs.png": 992464,
	"./obs_spei12_1970_na_na_na_3_eobs.png": 630296,
	"./obs_spei12_1970_na_na_na_4_eobs.png": 897724,
	"./obs_spei12_1970_na_na_na_5_eobs.png": 502804,
	"./obs_spei12_1970_na_na_na_6_eobs.png": 654092,
	"./obs_spei12_1970_na_na_na_7_eobs.png": 879532,
	"./obs_spei12_1970_na_na_na_8_eobs.png": 768805,
	"./obs_spei12_1970_na_na_na_9_eobs.png": 574916,
	"./obs_spei12_1971_na_na_na_10_eobs.png": 671524,
	"./obs_spei12_1971_na_na_na_11_eobs.png": 411724,
	"./obs_spei12_1971_na_na_na_12_eobs.png": 420008,
	"./obs_spei12_1971_na_na_na_1_eobs.png": 587852,
	"./obs_spei12_1971_na_na_na_2_eobs.png": 919892,
	"./obs_spei12_1971_na_na_na_3_eobs.png": 893096,
	"./obs_spei12_1971_na_na_na_4_eobs.png": 198352,
	"./obs_spei12_1971_na_na_na_5_eobs.png": 498156,
	"./obs_spei12_1971_na_na_na_6_eobs.png": 421084,
	"./obs_spei12_1971_na_na_na_7_eobs.png": 776108,
	"./obs_spei12_1971_na_na_na_8_eobs.png": 369592,
	"./obs_spei12_1971_na_na_na_9_eobs.png": 200060,
	"./obs_spei12_1972_na_na_na_10_eobs.png": 145384,
	"./obs_spei12_1972_na_na_na_11_eobs.png": 199088,
	"./obs_spei12_1972_na_na_na_12_eobs.png": 757804,
	"./obs_spei12_1972_na_na_na_1_eobs.png": 338896,
	"./obs_spei12_1972_na_na_na_2_eobs.png": 744248,
	"./obs_spei12_1972_na_na_na_3_eobs.png": 802056,
	"./obs_spei12_1972_na_na_na_4_eobs.png": 868832,
	"./obs_spei12_1972_na_na_na_5_eobs.png": 398208,
	"./obs_spei12_1972_na_na_na_6_eobs.png": 471180,
	"./obs_spei12_1972_na_na_na_7_eobs.png": 651648,
	"./obs_spei12_1972_na_na_na_8_eobs.png": 342400,
	"./obs_spei12_1972_na_na_na_9_eobs.png": 260360,
	"./obs_spei12_1973_na_na_na_10_eobs.png": 591869,
	"./obs_spei12_1973_na_na_na_11_eobs.png": 352368,
	"./obs_spei12_1973_na_na_na_12_eobs.png": 417056,
	"./obs_spei12_1973_na_na_na_1_eobs.png": 734488,
	"./obs_spei12_1973_na_na_na_2_eobs.png": 420908,
	"./obs_spei12_1973_na_na_na_3_eobs.png": 180700,
	"./obs_spei12_1973_na_na_na_4_eobs.png": 956568,
	"./obs_spei12_1973_na_na_na_5_eobs.png": 899716,
	"./obs_spei12_1973_na_na_na_6_eobs.png": 982604,
	"./obs_spei12_1973_na_na_na_7_eobs.png": 620656,
	"./obs_spei12_1973_na_na_na_8_eobs.png": 393572,
	"./obs_spei12_1973_na_na_na_9_eobs.png": 854620,
	"./obs_spei12_1974_na_na_na_10_eobs.png": 33168,
	"./obs_spei12_1974_na_na_na_11_eobs.png": 122700,
	"./obs_spei12_1974_na_na_na_12_eobs.png": 687924,
	"./obs_spei12_1974_na_na_na_1_eobs.png": 901452,
	"./obs_spei12_1974_na_na_na_2_eobs.png": 280340,
	"./obs_spei12_1974_na_na_na_3_eobs.png": 759156,
	"./obs_spei12_1974_na_na_na_4_eobs.png": 947080,
	"./obs_spei12_1974_na_na_na_5_eobs.png": 255788,
	"./obs_spei12_1974_na_na_na_6_eobs.png": 369344,
	"./obs_spei12_1974_na_na_na_7_eobs.png": 191964,
	"./obs_spei12_1974_na_na_na_8_eobs.png": 492365,
	"./obs_spei12_1974_na_na_na_9_eobs.png": 732220,
	"./obs_spei12_1975_na_na_na_10_eobs.png": 798808,
	"./obs_spei12_1975_na_na_na_11_eobs.png": 726084,
	"./obs_spei12_1975_na_na_na_12_eobs.png": 338976,
	"./obs_spei12_1975_na_na_na_1_eobs.png": 384148,
	"./obs_spei12_1975_na_na_na_2_eobs.png": 458800,
	"./obs_spei12_1975_na_na_na_3_eobs.png": 326724,
	"./obs_spei12_1975_na_na_na_4_eobs.png": 28484,
	"./obs_spei12_1975_na_na_na_5_eobs.png": 421628,
	"./obs_spei12_1975_na_na_na_6_eobs.png": 548696,
	"./obs_spei12_1975_na_na_na_7_eobs.png": 300368,
	"./obs_spei12_1975_na_na_na_8_eobs.png": 444549,
	"./obs_spei12_1975_na_na_na_9_eobs.png": 638596,
	"./obs_spei12_1976_na_na_na_10_eobs.png": 602941,
	"./obs_spei12_1976_na_na_na_11_eobs.png": 489188,
	"./obs_spei12_1976_na_na_na_12_eobs.png": 22423,
	"./obs_spei12_1976_na_na_na_1_eobs.png": 445548,
	"./obs_spei12_1976_na_na_na_2_eobs.png": 817916,
	"./obs_spei12_1976_na_na_na_3_eobs.png": 720631,
	"./obs_spei12_1976_na_na_na_4_eobs.png": 271212,
	"./obs_spei12_1976_na_na_na_5_eobs.png": 922620,
	"./obs_spei12_1976_na_na_na_6_eobs.png": 802448,
	"./obs_spei12_1976_na_na_na_7_eobs.png": 304048,
	"./obs_spei12_1976_na_na_na_8_eobs.png": 102784,
	"./obs_spei12_1976_na_na_na_9_eobs.png": 200012,
	"./obs_spei12_1977_na_na_na_10_eobs.png": 186704,
	"./obs_spei12_1977_na_na_na_11_eobs.png": 916860,
	"./obs_spei12_1977_na_na_na_12_eobs.png": 295264,
	"./obs_spei12_1977_na_na_na_1_eobs.png": 914196,
	"./obs_spei12_1977_na_na_na_2_eobs.png": 507632,
	"./obs_spei12_1977_na_na_na_3_eobs.png": 597592,
	"./obs_spei12_1977_na_na_na_4_eobs.png": 419292,
	"./obs_spei12_1977_na_na_na_5_eobs.png": 113092,
	"./obs_spei12_1977_na_na_na_6_eobs.png": 142576,
	"./obs_spei12_1977_na_na_na_7_eobs.png": 548888,
	"./obs_spei12_1977_na_na_na_8_eobs.png": 255892,
	"./obs_spei12_1977_na_na_na_9_eobs.png": 30924,
	"./obs_spei12_1978_na_na_na_10_eobs.png": 573044,
	"./obs_spei12_1978_na_na_na_11_eobs.png": 686628,
	"./obs_spei12_1978_na_na_na_12_eobs.png": 229796,
	"./obs_spei12_1978_na_na_na_1_eobs.png": 370920,
	"./obs_spei12_1978_na_na_na_2_eobs.png": 291292,
	"./obs_spei12_1978_na_na_na_3_eobs.png": 968380,
	"./obs_spei12_1978_na_na_na_4_eobs.png": 587044,
	"./obs_spei12_1978_na_na_na_5_eobs.png": 849104,
	"./obs_spei12_1978_na_na_na_6_eobs.png": 257884,
	"./obs_spei12_1978_na_na_na_7_eobs.png": 428636,
	"./obs_spei12_1978_na_na_na_8_eobs.png": 407744,
	"./obs_spei12_1978_na_na_na_9_eobs.png": 516420,
	"./obs_spei12_1979_na_na_na_10_eobs.png": 579620,
	"./obs_spei12_1979_na_na_na_11_eobs.png": 459224,
	"./obs_spei12_1979_na_na_na_12_eobs.png": 718312,
	"./obs_spei12_1979_na_na_na_1_eobs.png": 107236,
	"./obs_spei12_1979_na_na_na_2_eobs.png": 70092,
	"./obs_spei12_1979_na_na_na_3_eobs.png": 828124,
	"./obs_spei12_1979_na_na_na_4_eobs.png": 355180,
	"./obs_spei12_1979_na_na_na_5_eobs.png": 628183,
	"./obs_spei12_1979_na_na_na_6_eobs.png": 900704,
	"./obs_spei12_1979_na_na_na_7_eobs.png": 970096,
	"./obs_spei12_1979_na_na_na_8_eobs.png": 720492,
	"./obs_spei12_1979_na_na_na_9_eobs.png": 44464,
	"./obs_spei12_1980_na_na_na_10_eobs.png": 492328,
	"./obs_spei12_1980_na_na_na_11_eobs.png": 157676,
	"./obs_spei12_1980_na_na_na_12_eobs.png": 313788,
	"./obs_spei12_1980_na_na_na_1_eobs.png": 688132,
	"./obs_spei12_1980_na_na_na_2_eobs.png": 157828,
	"./obs_spei12_1980_na_na_na_3_eobs.png": 770500,
	"./obs_spei12_1980_na_na_na_4_eobs.png": 64520,
	"./obs_spei12_1980_na_na_na_5_eobs.png": 440664,
	"./obs_spei12_1980_na_na_na_6_eobs.png": 286572,
	"./obs_spei12_1980_na_na_na_7_eobs.png": 154868,
	"./obs_spei12_1980_na_na_na_8_eobs.png": 281504,
	"./obs_spei12_1980_na_na_na_9_eobs.png": 361215,
	"./obs_spei12_1981_na_na_na_10_eobs.png": 539564,
	"./obs_spei12_1981_na_na_na_11_eobs.png": 73060,
	"./obs_spei12_1981_na_na_na_12_eobs.png": 451416,
	"./obs_spei12_1981_na_na_na_1_eobs.png": 810944,
	"./obs_spei12_1981_na_na_na_2_eobs.png": 656168,
	"./obs_spei12_1981_na_na_na_3_eobs.png": 627180,
	"./obs_spei12_1981_na_na_na_4_eobs.png": 61816,
	"./obs_spei12_1981_na_na_na_5_eobs.png": 852084,
	"./obs_spei12_1981_na_na_na_6_eobs.png": 898412,
	"./obs_spei12_1981_na_na_na_7_eobs.png": 998244,
	"./obs_spei12_1981_na_na_na_8_eobs.png": 250584,
	"./obs_spei12_1981_na_na_na_9_eobs.png": 654012,
	"./obs_spei12_1982_na_na_na_10_eobs.png": 145632,
	"./obs_spei12_1982_na_na_na_11_eobs.png": 860864,
	"./obs_spei12_1982_na_na_na_12_eobs.png": 35164,
	"./obs_spei12_1982_na_na_na_1_eobs.png": 306212,
	"./obs_spei12_1982_na_na_na_2_eobs.png": 906604,
	"./obs_spei12_1982_na_na_na_3_eobs.png": 284568,
	"./obs_spei12_1982_na_na_na_4_eobs.png": 631444,
	"./obs_spei12_1982_na_na_na_5_eobs.png": 331324,
	"./obs_spei12_1982_na_na_na_6_eobs.png": 638624,
	"./obs_spei12_1982_na_na_na_7_eobs.png": 698296,
	"./obs_spei12_1982_na_na_na_8_eobs.png": 184020,
	"./obs_spei12_1982_na_na_na_9_eobs.png": 167864,
	"./obs_spei12_1983_na_na_na_10_eobs.png": 65184,
	"./obs_spei12_1983_na_na_na_11_eobs.png": 958624,
	"./obs_spei12_1983_na_na_na_12_eobs.png": 82976,
	"./obs_spei12_1983_na_na_na_1_eobs.png": 366912,
	"./obs_spei12_1983_na_na_na_2_eobs.png": 897332,
	"./obs_spei12_1983_na_na_na_3_eobs.png": 112664,
	"./obs_spei12_1983_na_na_na_4_eobs.png": 608407,
	"./obs_spei12_1983_na_na_na_5_eobs.png": 451120,
	"./obs_spei12_1983_na_na_na_6_eobs.png": 111608,
	"./obs_spei12_1983_na_na_na_7_eobs.png": 9772,
	"./obs_spei12_1983_na_na_na_8_eobs.png": 817376,
	"./obs_spei12_1983_na_na_na_9_eobs.png": 776072,
	"./obs_spei12_1984_na_na_na_10_eobs.png": 69120,
	"./obs_spei12_1984_na_na_na_11_eobs.png": 151568,
	"./obs_spei12_1984_na_na_na_12_eobs.png": 477800,
	"./obs_spei12_1984_na_na_na_1_eobs.png": 28216,
	"./obs_spei12_1984_na_na_na_2_eobs.png": 755551,
	"./obs_spei12_1984_na_na_na_3_eobs.png": 997645,
	"./obs_spei12_1984_na_na_na_4_eobs.png": 901732,
	"./obs_spei12_1984_na_na_na_5_eobs.png": 719460,
	"./obs_spei12_1984_na_na_na_6_eobs.png": 359528,
	"./obs_spei12_1984_na_na_na_7_eobs.png": 129140,
	"./obs_spei12_1984_na_na_na_8_eobs.png": 339128,
	"./obs_spei12_1984_na_na_na_9_eobs.png": 385204,
	"./obs_spei12_1985_na_na_na_10_eobs.png": 520780,
	"./obs_spei12_1985_na_na_na_11_eobs.png": 304940,
	"./obs_spei12_1985_na_na_na_12_eobs.png": 291076,
	"./obs_spei12_1985_na_na_na_1_eobs.png": 684996,
	"./obs_spei12_1985_na_na_na_2_eobs.png": 820376,
	"./obs_spei12_1985_na_na_na_3_eobs.png": 357215,
	"./obs_spei12_1985_na_na_na_4_eobs.png": 151020,
	"./obs_spei12_1985_na_na_na_5_eobs.png": 207367,
	"./obs_spei12_1985_na_na_na_6_eobs.png": 963072,
	"./obs_spei12_1985_na_na_na_7_eobs.png": 761316,
	"./obs_spei12_1985_na_na_na_8_eobs.png": 400416,
	"./obs_spei12_1985_na_na_na_9_eobs.png": 628304,
	"./obs_spei12_1986_na_na_na_10_eobs.png": 155896,
	"./obs_spei12_1986_na_na_na_11_eobs.png": 591268,
	"./obs_spei12_1986_na_na_na_12_eobs.png": 446644,
	"./obs_spei12_1986_na_na_na_1_eobs.png": 404184,
	"./obs_spei12_1986_na_na_na_2_eobs.png": 603420,
	"./obs_spei12_1986_na_na_na_3_eobs.png": 899788,
	"./obs_spei12_1986_na_na_na_4_eobs.png": 42596,
	"./obs_spei12_1986_na_na_na_5_eobs.png": 183436,
	"./obs_spei12_1986_na_na_na_6_eobs.png": 295612,
	"./obs_spei12_1986_na_na_na_7_eobs.png": 226136,
	"./obs_spei12_1986_na_na_na_8_eobs.png": 711575,
	"./obs_spei12_1986_na_na_na_9_eobs.png": 689584,
	"./obs_spei12_1987_na_na_na_10_eobs.png": 291452,
	"./obs_spei12_1987_na_na_na_11_eobs.png": 217716,
	"./obs_spei12_1987_na_na_na_12_eobs.png": 895260,
	"./obs_spei12_1987_na_na_na_1_eobs.png": 650692,
	"./obs_spei12_1987_na_na_na_2_eobs.png": 230644,
	"./obs_spei12_1987_na_na_na_3_eobs.png": 431764,
	"./obs_spei12_1987_na_na_na_4_eobs.png": 501504,
	"./obs_spei12_1987_na_na_na_5_eobs.png": 907560,
	"./obs_spei12_1987_na_na_na_6_eobs.png": 671581,
	"./obs_spei12_1987_na_na_na_7_eobs.png": 481252,
	"./obs_spei12_1987_na_na_na_8_eobs.png": 792288,
	"./obs_spei12_1987_na_na_na_9_eobs.png": 187480,
	"./obs_spei12_1988_na_na_na_10_eobs.png": 882916,
	"./obs_spei12_1988_na_na_na_11_eobs.png": 866544,
	"./obs_spei12_1988_na_na_na_12_eobs.png": 643092,
	"./obs_spei12_1988_na_na_na_1_eobs.png": 300328,
	"./obs_spei12_1988_na_na_na_2_eobs.png": 809772,
	"./obs_spei12_1988_na_na_na_3_eobs.png": 867900,
	"./obs_spei12_1988_na_na_na_4_eobs.png": 169600,
	"./obs_spei12_1988_na_na_na_5_eobs.png": 866860,
	"./obs_spei12_1988_na_na_na_6_eobs.png": 311164,
	"./obs_spei12_1988_na_na_na_7_eobs.png": 799820,
	"./obs_spei12_1988_na_na_na_8_eobs.png": 66032,
	"./obs_spei12_1988_na_na_na_9_eobs.png": 422228,
	"./obs_spei12_1989_na_na_na_10_eobs.png": 231108,
	"./obs_spei12_1989_na_na_na_11_eobs.png": 229708,
	"./obs_spei12_1989_na_na_na_12_eobs.png": 790712,
	"./obs_spei12_1989_na_na_na_1_eobs.png": 115620,
	"./obs_spei12_1989_na_na_na_2_eobs.png": 987580,
	"./obs_spei12_1989_na_na_na_3_eobs.png": 568468,
	"./obs_spei12_1989_na_na_na_4_eobs.png": 304948,
	"./obs_spei12_1989_na_na_na_5_eobs.png": 380988,
	"./obs_spei12_1989_na_na_na_6_eobs.png": 47388,
	"./obs_spei12_1989_na_na_na_7_eobs.png": 967160,
	"./obs_spei12_1989_na_na_na_8_eobs.png": 490436,
	"./obs_spei12_1989_na_na_na_9_eobs.png": 872436,
	"./obs_spei12_1990_na_na_na_10_eobs.png": 306472,
	"./obs_spei12_1990_na_na_na_11_eobs.png": 265060,
	"./obs_spei12_1990_na_na_na_12_eobs.png": 761464,
	"./obs_spei12_1990_na_na_na_1_eobs.png": 828740,
	"./obs_spei12_1990_na_na_na_2_eobs.png": 324460,
	"./obs_spei12_1990_na_na_na_3_eobs.png": 360168,
	"./obs_spei12_1990_na_na_na_4_eobs.png": 495256,
	"./obs_spei12_1990_na_na_na_5_eobs.png": 964904,
	"./obs_spei12_1990_na_na_na_6_eobs.png": 846208,
	"./obs_spei12_1990_na_na_na_7_eobs.png": 139548,
	"./obs_spei12_1990_na_na_na_8_eobs.png": 852540,
	"./obs_spei12_1990_na_na_na_9_eobs.png": 792840,
	"./obs_spei12_1991_na_na_na_10_eobs.png": 698117,
	"./obs_spei12_1991_na_na_na_11_eobs.png": 715444,
	"./obs_spei12_1991_na_na_na_12_eobs.png": 433140,
	"./obs_spei12_1991_na_na_na_1_eobs.png": 999028,
	"./obs_spei12_1991_na_na_na_2_eobs.png": 502720,
	"./obs_spei12_1991_na_na_na_3_eobs.png": 761104,
	"./obs_spei12_1991_na_na_na_4_eobs.png": 311508,
	"./obs_spei12_1991_na_na_na_5_eobs.png": 850388,
	"./obs_spei12_1991_na_na_na_6_eobs.png": 377616,
	"./obs_spei12_1991_na_na_na_7_eobs.png": 509652,
	"./obs_spei12_1991_na_na_na_8_eobs.png": 94940,
	"./obs_spei12_1991_na_na_na_9_eobs.png": 545868,
	"./obs_spei12_1992_na_na_na_10_eobs.png": 6100,
	"./obs_spei12_1992_na_na_na_11_eobs.png": 700548,
	"./obs_spei12_1992_na_na_na_12_eobs.png": 860032,
	"./obs_spei12_1992_na_na_na_1_eobs.png": 658576,
	"./obs_spei12_1992_na_na_na_2_eobs.png": 999396,
	"./obs_spei12_1992_na_na_na_3_eobs.png": 295236,
	"./obs_spei12_1992_na_na_na_4_eobs.png": 210000,
	"./obs_spei12_1992_na_na_na_5_eobs.png": 171232,
	"./obs_spei12_1992_na_na_na_6_eobs.png": 316628,
	"./obs_spei12_1992_na_na_na_7_eobs.png": 728588,
	"./obs_spei12_1992_na_na_na_8_eobs.png": 479540,
	"./obs_spei12_1992_na_na_na_9_eobs.png": 440092,
	"./obs_spei12_1993_na_na_na_10_eobs.png": 777468,
	"./obs_spei12_1993_na_na_na_11_eobs.png": 571156,
	"./obs_spei12_1993_na_na_na_12_eobs.png": 848536,
	"./obs_spei12_1993_na_na_na_1_eobs.png": 647964,
	"./obs_spei12_1993_na_na_na_2_eobs.png": 215040,
	"./obs_spei12_1993_na_na_na_3_eobs.png": 102360,
	"./obs_spei12_1993_na_na_na_4_eobs.png": 288916,
	"./obs_spei12_1993_na_na_na_5_eobs.png": 929380,
	"./obs_spei12_1993_na_na_na_6_eobs.png": 524252,
	"./obs_spei12_1993_na_na_na_7_eobs.png": 108216,
	"./obs_spei12_1993_na_na_na_8_eobs.png": 695132,
	"./obs_spei12_1993_na_na_na_9_eobs.png": 615936,
	"./obs_spei12_1994_na_na_na_10_eobs.png": 652575,
	"./obs_spei12_1994_na_na_na_11_eobs.png": 820244,
	"./obs_spei12_1994_na_na_na_12_eobs.png": 459900,
	"./obs_spei12_1994_na_na_na_1_eobs.png": 634612,
	"./obs_spei12_1994_na_na_na_2_eobs.png": 105292,
	"./obs_spei12_1994_na_na_na_3_eobs.png": 806820,
	"./obs_spei12_1994_na_na_na_4_eobs.png": 413056,
	"./obs_spei12_1994_na_na_na_5_eobs.png": 881132,
	"./obs_spei12_1994_na_na_na_6_eobs.png": 562528,
	"./obs_spei12_1994_na_na_na_7_eobs.png": 588024,
	"./obs_spei12_1994_na_na_na_8_eobs.png": 796140,
	"./obs_spei12_1994_na_na_na_9_eobs.png": 630700,
	"./obs_spei12_1995_na_na_na_10_eobs.png": 787752,
	"./obs_spei12_1995_na_na_na_11_eobs.png": 439508,
	"./obs_spei12_1995_na_na_na_12_eobs.png": 103860,
	"./obs_spei12_1995_na_na_na_1_eobs.png": 412836,
	"./obs_spei12_1995_na_na_na_2_eobs.png": 75228,
	"./obs_spei12_1995_na_na_na_3_eobs.png": 875156,
	"./obs_spei12_1995_na_na_na_4_eobs.png": 723252,
	"./obs_spei12_1995_na_na_na_5_eobs.png": 44660,
	"./obs_spei12_1995_na_na_na_6_eobs.png": 10192,
	"./obs_spei12_1995_na_na_na_7_eobs.png": 590844,
	"./obs_spei12_1995_na_na_na_8_eobs.png": 361608,
	"./obs_spei12_1995_na_na_na_9_eobs.png": 231068,
	"./obs_spei12_1996_na_na_na_10_eobs.png": 189852,
	"./obs_spei12_1996_na_na_na_11_eobs.png": 864368,
	"./obs_spei12_1996_na_na_na_12_eobs.png": 36616,
	"./obs_spei12_1996_na_na_na_1_eobs.png": 35332,
	"./obs_spei12_1996_na_na_na_2_eobs.png": 141820,
	"./obs_spei12_1996_na_na_na_3_eobs.png": 893704,
	"./obs_spei12_1996_na_na_na_4_eobs.png": 799520,
	"./obs_spei12_1996_na_na_na_5_eobs.png": 972904,
	"./obs_spei12_1996_na_na_na_6_eobs.png": 841884,
	"./obs_spei12_1996_na_na_na_7_eobs.png": 363220,
	"./obs_spei12_1996_na_na_na_8_eobs.png": 195408,
	"./obs_spei12_1996_na_na_na_9_eobs.png": 600592,
	"./obs_spei12_1997_na_na_na_10_eobs.png": 419028,
	"./obs_spei12_1997_na_na_na_11_eobs.png": 949836,
	"./obs_spei12_1997_na_na_na_12_eobs.png": 526220,
	"./obs_spei12_1997_na_na_na_1_eobs.png": 94900,
	"./obs_spei12_1997_na_na_na_2_eobs.png": 131432,
	"./obs_spei12_1997_na_na_na_3_eobs.png": 726820,
	"./obs_spei12_1997_na_na_na_4_eobs.png": 161064,
	"./obs_spei12_1997_na_na_na_5_eobs.png": 214628,
	"./obs_spei12_1997_na_na_na_6_eobs.png": 2636,
	"./obs_spei12_1997_na_na_na_7_eobs.png": 914480,
	"./obs_spei12_1997_na_na_na_8_eobs.png": 217316,
	"./obs_spei12_1997_na_na_na_9_eobs.png": 313340,
	"./obs_spei12_1998_na_na_na_10_eobs.png": 584140,
	"./obs_spei12_1998_na_na_na_11_eobs.png": 538532,
	"./obs_spei12_1998_na_na_na_12_eobs.png": 432836,
	"./obs_spei12_1998_na_na_na_1_eobs.png": 329756,
	"./obs_spei12_1998_na_na_na_2_eobs.png": 325912,
	"./obs_spei12_1998_na_na_na_3_eobs.png": 992036,
	"./obs_spei12_1998_na_na_na_4_eobs.png": 248172,
	"./obs_spei12_1998_na_na_na_5_eobs.png": 288244,
	"./obs_spei12_1998_na_na_na_6_eobs.png": 148908,
	"./obs_spei12_1998_na_na_na_7_eobs.png": 910928,
	"./obs_spei12_1998_na_na_na_8_eobs.png": 389136,
	"./obs_spei12_1998_na_na_na_9_eobs.png": 741188,
	"./obs_spei12_1999_na_na_na_10_eobs.png": 604084,
	"./obs_spei12_1999_na_na_na_11_eobs.png": 389316,
	"./obs_spei12_1999_na_na_na_12_eobs.png": 991204,
	"./obs_spei12_1999_na_na_na_1_eobs.png": 29823,
	"./obs_spei12_1999_na_na_na_2_eobs.png": 808364,
	"./obs_spei12_1999_na_na_na_3_eobs.png": 258044,
	"./obs_spei12_1999_na_na_na_4_eobs.png": 868456,
	"./obs_spei12_1999_na_na_na_5_eobs.png": 895688,
	"./obs_spei12_1999_na_na_na_6_eobs.png": 209864,
	"./obs_spei12_1999_na_na_na_7_eobs.png": 796260,
	"./obs_spei12_1999_na_na_na_8_eobs.png": 466612,
	"./obs_spei12_1999_na_na_na_9_eobs.png": 463008,
	"./obs_spei12_2000_na_na_na_10_eobs.png": 999512,
	"./obs_spei12_2000_na_na_na_11_eobs.png": 235156,
	"./obs_spei12_2000_na_na_na_12_eobs.png": 398460,
	"./obs_spei12_2000_na_na_na_1_eobs.png": 542844,
	"./obs_spei12_2000_na_na_na_2_eobs.png": 439212,
	"./obs_spei12_2000_na_na_na_3_eobs.png": 711368,
	"./obs_spei12_2000_na_na_na_4_eobs.png": 142028,
	"./obs_spei12_2000_na_na_na_5_eobs.png": 921920,
	"./obs_spei12_2000_na_na_na_6_eobs.png": 374484,
	"./obs_spei12_2000_na_na_na_7_eobs.png": 879860,
	"./obs_spei12_2000_na_na_na_8_eobs.png": 785048,
	"./obs_spei12_2000_na_na_na_9_eobs.png": 999724,
	"./obs_spei12_2001_na_na_na_10_eobs.png": 151292,
	"./obs_spei12_2001_na_na_na_11_eobs.png": 835460,
	"./obs_spei12_2001_na_na_na_12_eobs.png": 729031,
	"./obs_spei12_2001_na_na_na_1_eobs.png": 479940,
	"./obs_spei12_2001_na_na_na_2_eobs.png": 291372,
	"./obs_spei12_2001_na_na_na_3_eobs.png": 210415,
	"./obs_spei12_2001_na_na_na_4_eobs.png": 842436,
	"./obs_spei12_2001_na_na_na_5_eobs.png": 195424,
	"./obs_spei12_2001_na_na_na_6_eobs.png": 79432,
	"./obs_spei12_2001_na_na_na_7_eobs.png": 463208,
	"./obs_spei12_2001_na_na_na_8_eobs.png": 993380,
	"./obs_spei12_2001_na_na_na_9_eobs.png": 545988,
	"./obs_spei12_2002_na_na_na_10_eobs.png": 228504,
	"./obs_spei12_2002_na_na_na_11_eobs.png": 107756,
	"./obs_spei12_2002_na_na_na_12_eobs.png": 922124,
	"./obs_spei12_2002_na_na_na_1_eobs.png": 779620,
	"./obs_spei12_2002_na_na_na_2_eobs.png": 227204,
	"./obs_spei12_2002_na_na_na_3_eobs.png": 954704,
	"./obs_spei12_2002_na_na_na_4_eobs.png": 48648,
	"./obs_spei12_2002_na_na_na_5_eobs.png": 279260,
	"./obs_spei12_2002_na_na_na_6_eobs.png": 725488,
	"./obs_spei12_2002_na_na_na_7_eobs.png": 608464,
	"./obs_spei12_2002_na_na_na_8_eobs.png": 417268,
	"./obs_spei12_2002_na_na_na_9_eobs.png": 625752,
	"./obs_spei12_2003_na_na_na_10_eobs.png": 492936,
	"./obs_spei12_2003_na_na_na_11_eobs.png": 184208,
	"./obs_spei12_2003_na_na_na_12_eobs.png": 117764,
	"./obs_spei12_2003_na_na_na_1_eobs.png": 736976,
	"./obs_spei12_2003_na_na_na_2_eobs.png": 789804,
	"./obs_spei12_2003_na_na_na_3_eobs.png": 946368,
	"./obs_spei12_2003_na_na_na_4_eobs.png": 319004,
	"./obs_spei12_2003_na_na_na_5_eobs.png": 348292,
	"./obs_spei12_2003_na_na_na_6_eobs.png": 478356,
	"./obs_spei12_2003_na_na_na_7_eobs.png": 322560,
	"./obs_spei12_2003_na_na_na_8_eobs.png": 31512,
	"./obs_spei12_2003_na_na_na_9_eobs.png": 161500,
	"./obs_spei12_2004_na_na_na_10_eobs.png": 990576,
	"./obs_spei12_2004_na_na_na_11_eobs.png": 988156,
	"./obs_spei12_2004_na_na_na_12_eobs.png": 17712,
	"./obs_spei12_2004_na_na_na_1_eobs.png": 806060,
	"./obs_spei12_2004_na_na_na_2_eobs.png": 238672,
	"./obs_spei12_2004_na_na_na_3_eobs.png": 412832,
	"./obs_spei12_2004_na_na_na_4_eobs.png": 448132,
	"./obs_spei12_2004_na_na_na_5_eobs.png": 835320,
	"./obs_spei12_2004_na_na_na_6_eobs.png": 623228,
	"./obs_spei12_2004_na_na_na_7_eobs.png": 949676,
	"./obs_spei12_2004_na_na_na_8_eobs.png": 998948,
	"./obs_spei12_2004_na_na_na_9_eobs.png": 817356,
	"./obs_spei12_2005_na_na_na_10_eobs.png": 60924,
	"./obs_spei12_2005_na_na_na_11_eobs.png": 586156,
	"./obs_spei12_2005_na_na_na_12_eobs.png": 876640,
	"./obs_spei12_2005_na_na_na_1_eobs.png": 34892,
	"./obs_spei12_2005_na_na_na_2_eobs.png": 703552,
	"./obs_spei12_2005_na_na_na_3_eobs.png": 355092,
	"./obs_spei12_2005_na_na_na_4_eobs.png": 312047,
	"./obs_spei12_2005_na_na_na_5_eobs.png": 49828,
	"./obs_spei12_2005_na_na_na_6_eobs.png": 466204,
	"./obs_spei12_2005_na_na_na_7_eobs.png": 697812,
	"./obs_spei12_2005_na_na_na_8_eobs.png": 989800,
	"./obs_spei12_2005_na_na_na_9_eobs.png": 387636,
	"./obs_spei12_2006_na_na_na_10_eobs.png": 947004,
	"./obs_spei12_2006_na_na_na_11_eobs.png": 4924,
	"./obs_spei12_2006_na_na_na_12_eobs.png": 815608,
	"./obs_spei12_2006_na_na_na_1_eobs.png": 998652,
	"./obs_spei12_2006_na_na_na_2_eobs.png": 711272,
	"./obs_spei12_2006_na_na_na_3_eobs.png": 834052,
	"./obs_spei12_2006_na_na_na_4_eobs.png": 15220,
	"./obs_spei12_2006_na_na_na_5_eobs.png": 897240,
	"./obs_spei12_2006_na_na_na_6_eobs.png": 286948,
	"./obs_spei12_2006_na_na_na_7_eobs.png": 547308,
	"./obs_spei12_2006_na_na_na_8_eobs.png": 338588,
	"./obs_spei12_2006_na_na_na_9_eobs.png": 674016,
	"./obs_spei12_2007_na_na_na_10_eobs.png": 466368,
	"./obs_spei12_2007_na_na_na_11_eobs.png": 994668,
	"./obs_spei12_2007_na_na_na_12_eobs.png": 512900,
	"./obs_spei12_2007_na_na_na_1_eobs.png": 17044,
	"./obs_spei12_2007_na_na_na_2_eobs.png": 500616,
	"./obs_spei12_2007_na_na_na_3_eobs.png": 13920,
	"./obs_spei12_2007_na_na_na_4_eobs.png": 465205,
	"./obs_spei12_2007_na_na_na_5_eobs.png": 937636,
	"./obs_spei12_2007_na_na_na_6_eobs.png": 636831,
	"./obs_spei12_2007_na_na_na_7_eobs.png": 88564,
	"./obs_spei12_2007_na_na_na_8_eobs.png": 707916,
	"./obs_spei12_2007_na_na_na_9_eobs.png": 476892,
	"./obs_spei12_2008_na_na_na_10_eobs.png": 180424,
	"./obs_spei12_2008_na_na_na_11_eobs.png": 951916,
	"./obs_spei12_2008_na_na_na_12_eobs.png": 624260,
	"./obs_spei12_2008_na_na_na_1_eobs.png": 57164,
	"./obs_spei12_2008_na_na_na_2_eobs.png": 72620,
	"./obs_spei12_2008_na_na_na_3_eobs.png": 683472,
	"./obs_spei12_2008_na_na_na_4_eobs.png": 42384,
	"./obs_spei12_2008_na_na_na_5_eobs.png": 846108,
	"./obs_spei12_2008_na_na_na_6_eobs.png": 734404,
	"./obs_spei12_2008_na_na_na_7_eobs.png": 716288,
	"./obs_spei12_2008_na_na_na_8_eobs.png": 818212,
	"./obs_spei12_2008_na_na_na_9_eobs.png": 44092,
	"./obs_spei12_2009_na_na_na_10_eobs.png": 814740,
	"./obs_spei12_2009_na_na_na_11_eobs.png": 101783,
	"./obs_spei12_2009_na_na_na_12_eobs.png": 918332,
	"./obs_spei12_2009_na_na_na_1_eobs.png": 72452,
	"./obs_spei12_2009_na_na_na_2_eobs.png": 204332,
	"./obs_spei12_2009_na_na_na_3_eobs.png": 37968,
	"./obs_spei12_2009_na_na_na_4_eobs.png": 485376,
	"./obs_spei12_2009_na_na_na_5_eobs.png": 367268,
	"./obs_spei12_2009_na_na_na_6_eobs.png": 754900,
	"./obs_spei12_2009_na_na_na_7_eobs.png": 945959,
	"./obs_spei12_2009_na_na_na_8_eobs.png": 178020,
	"./obs_spei12_2009_na_na_na_9_eobs.png": 929348,
	"./obs_spei12_2010_na_na_na_10_eobs.png": 270132,
	"./obs_spei12_2010_na_na_na_11_eobs.png": 742912,
	"./obs_spei12_2010_na_na_na_12_eobs.png": 265948,
	"./obs_spei12_2010_na_na_na_1_eobs.png": 68824,
	"./obs_spei12_2010_na_na_na_2_eobs.png": 186964,
	"./obs_spei12_2010_na_na_na_3_eobs.png": 568260,
	"./obs_spei12_2010_na_na_na_4_eobs.png": 809788,
	"./obs_spei12_2010_na_na_na_5_eobs.png": 157500,
	"./obs_spei12_2010_na_na_na_6_eobs.png": 41484,
	"./obs_spei12_2010_na_na_na_7_eobs.png": 516256,
	"./obs_spei12_2010_na_na_na_8_eobs.png": 149540,
	"./obs_spei12_2010_na_na_na_9_eobs.png": 20100,
	"./obs_spei12_2011_na_na_na_10_eobs.png": 578256,
	"./obs_spei12_2011_na_na_na_11_eobs.png": 769296,
	"./obs_spei12_2011_na_na_na_12_eobs.png": 926428,
	"./obs_spei12_2011_na_na_na_1_eobs.png": 656492,
	"./obs_spei12_2011_na_na_na_2_eobs.png": 802964,
	"./obs_spei12_2011_na_na_na_3_eobs.png": 470704,
	"./obs_spei12_2011_na_na_na_4_eobs.png": 505575,
	"./obs_spei12_2011_na_na_na_5_eobs.png": 274040,
	"./obs_spei12_2011_na_na_na_6_eobs.png": 610664,
	"./obs_spei12_2011_na_na_na_7_eobs.png": 707860,
	"./obs_spei12_2011_na_na_na_8_eobs.png": 910893,
	"./obs_spei12_2011_na_na_na_9_eobs.png": 660388,
	"./obs_spei12_2012_na_na_na_10_eobs.png": 785280,
	"./obs_spei12_2012_na_na_na_11_eobs.png": 144260,
	"./obs_spei12_2012_na_na_na_12_eobs.png": 155760,
	"./obs_spei12_2012_na_na_na_1_eobs.png": 321964,
	"./obs_spei12_2012_na_na_na_2_eobs.png": 105972,
	"./obs_spei12_2012_na_na_na_3_eobs.png": 498612,
	"./obs_spei12_2012_na_na_na_4_eobs.png": 132856,
	"./obs_spei12_2012_na_na_na_5_eobs.png": 647328,
	"./obs_spei12_2012_na_na_na_6_eobs.png": 699492,
	"./obs_spei12_2012_na_na_na_7_eobs.png": 864736,
	"./obs_spei12_2012_na_na_na_8_eobs.png": 745720,
	"./obs_spei12_2012_na_na_na_9_eobs.png": 522268,
	"./obs_spei12_2013_na_na_na_10_eobs.png": 178824,
	"./obs_spei12_2013_na_na_na_11_eobs.png": 620888,
	"./obs_spei12_2013_na_na_na_12_eobs.png": 934244,
	"./obs_spei12_2013_na_na_na_1_eobs.png": 659280,
	"./obs_spei12_2013_na_na_na_2_eobs.png": 615072,
	"./obs_spei12_2013_na_na_na_3_eobs.png": 414004,
	"./obs_spei12_2013_na_na_na_4_eobs.png": 286924,
	"./obs_spei12_2013_na_na_na_5_eobs.png": 90884,
	"./obs_spei12_2013_na_na_na_6_eobs.png": 165584,
	"./obs_spei12_2013_na_na_na_7_eobs.png": 382116,
	"./obs_spei12_2013_na_na_na_8_eobs.png": 298072,
	"./obs_spei12_2013_na_na_na_9_eobs.png": 210932,
	"./obs_spei12_2014_na_na_na_10_eobs.png": 929356,
	"./obs_spei12_2014_na_na_na_11_eobs.png": 299492,
	"./obs_spei12_2014_na_na_na_12_eobs.png": 919956,
	"./obs_spei12_2014_na_na_na_1_eobs.png": 77164,
	"./obs_spei12_2014_na_na_na_2_eobs.png": 319228,
	"./obs_spei12_2014_na_na_na_3_eobs.png": 655277,
	"./obs_spei12_2014_na_na_na_4_eobs.png": 360404,
	"./obs_spei12_2014_na_na_na_5_eobs.png": 647120,
	"./obs_spei12_2014_na_na_na_6_eobs.png": 919268,
	"./obs_spei12_2014_na_na_na_7_eobs.png": 646048,
	"./obs_spei12_2014_na_na_na_8_eobs.png": 585860,
	"./obs_spei12_2014_na_na_na_9_eobs.png": 751276,
	"./obs_spei12_2015_na_na_na_10_eobs.png": 322232,
	"./obs_spei12_2015_na_na_na_11_eobs.png": 924804,
	"./obs_spei12_2015_na_na_na_12_eobs.png": 599752,
	"./obs_spei12_2015_na_na_na_1_eobs.png": 388887,
	"./obs_spei12_2015_na_na_na_2_eobs.png": 377035,
	"./obs_spei12_2015_na_na_na_3_eobs.png": 806548,
	"./obs_spei12_2015_na_na_na_4_eobs.png": 379636,
	"./obs_spei12_2015_na_na_na_5_eobs.png": 715728,
	"./obs_spei12_2015_na_na_na_6_eobs.png": 842076,
	"./obs_spei12_2015_na_na_na_7_eobs.png": 21028,
	"./obs_spei12_2015_na_na_na_8_eobs.png": 499268,
	"./obs_spei12_2015_na_na_na_9_eobs.png": 3440,
	"./obs_spei12_2016_na_na_na_10_eobs.png": 4380,
	"./obs_spei12_2016_na_na_na_11_eobs.png": 804284,
	"./obs_spei12_2016_na_na_na_12_eobs.png": 872575,
	"./obs_spei12_2016_na_na_na_1_eobs.png": 862600,
	"./obs_spei12_2016_na_na_na_2_eobs.png": 839280,
	"./obs_spei12_2016_na_na_na_3_eobs.png": 71808,
	"./obs_spei12_2016_na_na_na_4_eobs.png": 15188,
	"./obs_spei12_2016_na_na_na_5_eobs.png": 178292,
	"./obs_spei12_2016_na_na_na_6_eobs.png": 532551,
	"./obs_spei12_2016_na_na_na_7_eobs.png": 439680,
	"./obs_spei12_2016_na_na_na_8_eobs.png": 363332,
	"./obs_spei12_2016_na_na_na_9_eobs.png": 368376,
	"./obs_spei12_2017_na_na_na_10_eobs.png": 740564,
	"./obs_spei12_2017_na_na_na_11_eobs.png": 842236,
	"./obs_spei12_2017_na_na_na_12_eobs.png": 415748,
	"./obs_spei12_2017_na_na_na_1_eobs.png": 190612,
	"./obs_spei12_2017_na_na_na_2_eobs.png": 880800,
	"./obs_spei12_2017_na_na_na_3_eobs.png": 514128,
	"./obs_spei12_2017_na_na_na_4_eobs.png": 623516,
	"./obs_spei12_2017_na_na_na_5_eobs.png": 880380,
	"./obs_spei12_2017_na_na_na_6_eobs.png": 731456,
	"./obs_spei12_2017_na_na_na_7_eobs.png": 593856,
	"./obs_spei12_2017_na_na_na_8_eobs.png": 677132,
	"./obs_spei12_2017_na_na_na_9_eobs.png": 900928,
	"./obs_spei12_2018_na_na_na_10_eobs.png": 199048,
	"./obs_spei12_2018_na_na_na_11_eobs.png": 619872,
	"./obs_spei12_2018_na_na_na_12_eobs.png": 103660,
	"./obs_spei12_2018_na_na_na_1_eobs.png": 187988,
	"./obs_spei12_2018_na_na_na_2_eobs.png": 978004,
	"./obs_spei12_2018_na_na_na_3_eobs.png": 563093,
	"./obs_spei12_2018_na_na_na_4_eobs.png": 996316,
	"./obs_spei12_2018_na_na_na_5_eobs.png": 530443,
	"./obs_spei12_2018_na_na_na_6_eobs.png": 718932,
	"./obs_spei12_2018_na_na_na_7_eobs.png": 604668,
	"./obs_spei12_2018_na_na_na_8_eobs.png": 892660,
	"./obs_spei12_2018_na_na_na_9_eobs.png": 328152,
	"./obs_spei12_2019_na_na_na_10_eobs.png": 620068,
	"./obs_spei12_2019_na_na_na_11_eobs.png": 376844,
	"./obs_spei12_2019_na_na_na_12_eobs.png": 227444,
	"./obs_spei12_2019_na_na_na_1_eobs.png": 915079,
	"./obs_spei12_2019_na_na_na_2_eobs.png": 578116,
	"./obs_spei12_2019_na_na_na_3_eobs.png": 225405,
	"./obs_spei12_2019_na_na_na_4_eobs.png": 795081,
	"./obs_spei12_2019_na_na_na_5_eobs.png": 877104,
	"./obs_spei12_2019_na_na_na_6_eobs.png": 306396,
	"./obs_spei12_2019_na_na_na_7_eobs.png": 113444,
	"./obs_spei12_2019_na_na_na_8_eobs.png": 545396,
	"./obs_spei12_2019_na_na_na_9_eobs.png": 919596,
	"./obs_spei12_2020_na_na_na_10_eobs.png": 987327,
	"./obs_spei12_2020_na_na_na_11_eobs.png": 494984,
	"./obs_spei12_2020_na_na_na_12_eobs.png": 865932,
	"./obs_spei12_2020_na_na_na_1_eobs.png": 939016,
	"./obs_spei12_2020_na_na_na_2_eobs.png": 763848,
	"./obs_spei12_2020_na_na_na_3_eobs.png": 234432,
	"./obs_spei12_2020_na_na_na_4_eobs.png": 242552,
	"./obs_spei12_2020_na_na_na_5_eobs.png": 251456,
	"./obs_spei12_2020_na_na_na_6_eobs.png": 71840,
	"./obs_spei12_2020_na_na_na_7_eobs.png": 852684,
	"./obs_spei12_2020_na_na_na_8_eobs.png": 53956,
	"./obs_spei12_2020_na_na_na_9_eobs.png": 90872,
	"./obs_spei12_2021_na_na_na_10_eobs.png": 599172,
	"./obs_spei12_2021_na_na_na_11_eobs.png": 101216,
	"./obs_spei12_2021_na_na_na_12_eobs.png": 22832,
	"./obs_spei12_2021_na_na_na_1_eobs.png": 551132,
	"./obs_spei12_2021_na_na_na_2_eobs.png": 730968,
	"./obs_spei12_2021_na_na_na_3_eobs.png": 963020,
	"./obs_spei12_2021_na_na_na_4_eobs.png": 2752,
	"./obs_spei12_2021_na_na_na_5_eobs.png": 998932,
	"./obs_spei12_2021_na_na_na_6_eobs.png": 23416,
	"./obs_spei12_2021_na_na_na_7_eobs.png": 340860,
	"./obs_spei12_2021_na_na_na_8_eobs.png": 186936,
	"./obs_spei12_2021_na_na_na_9_eobs.png": 507876,
	"./obs_spei12_2022_na_na_na_10_eobs.png": 832820,
	"./obs_spei12_2022_na_na_na_11_eobs.png": 747356,
	"./obs_spei12_2022_na_na_na_12_eobs.png": 425800,
	"./obs_spei12_2022_na_na_na_1_eobs.png": 280208,
	"./obs_spei12_2022_na_na_na_2_eobs.png": 370144,
	"./obs_spei12_2022_na_na_na_3_eobs.png": 145344,
	"./obs_spei12_2022_na_na_na_4_eobs.png": 962856,
	"./obs_spei12_2022_na_na_na_5_eobs.png": 286688,
	"./obs_spei12_2022_na_na_na_6_eobs.png": 226196,
	"./obs_spei12_2022_na_na_na_7_eobs.png": 981031,
	"./obs_spei12_2022_na_na_na_8_eobs.png": 356996,
	"./obs_spei12_2022_na_na_na_9_eobs.png": 423948,
	"./obs_spei12_2023_na_na_na_10_eobs.png": 754300,
	"./obs_spei12_2023_na_na_na_11_eobs.png": 527944,
	"./obs_spei12_2023_na_na_na_12_eobs.png": 967788,
	"./obs_spei12_2023_na_na_na_1_eobs.png": 556724,
	"./obs_spei12_2023_na_na_na_2_eobs.png": 55112,
	"./obs_spei12_2023_na_na_na_3_eobs.png": 205292,
	"./obs_spei12_2023_na_na_na_4_eobs.png": 816916,
	"./obs_spei12_2023_na_na_na_5_eobs.png": 33784,
	"./obs_spei12_2023_na_na_na_6_eobs.png": 580696,
	"./obs_spei12_2023_na_na_na_7_eobs.png": 955632,
	"./obs_spei12_2023_na_na_na_8_eobs.png": 347780,
	"./obs_spei12_2023_na_na_na_9_eobs.png": 62740,
	"./obs_spei3_1950_na_na_na_10_eobs.png": 441080,
	"./obs_spei3_1950_na_na_na_11_eobs.png": 516800,
	"./obs_spei3_1950_na_na_na_12_eobs.png": 391840,
	"./obs_spei3_1950_na_na_na_1_eobs.png": 143071,
	"./obs_spei3_1950_na_na_na_2_eobs.png": 177704,
	"./obs_spei3_1950_na_na_na_3_eobs.png": 481328,
	"./obs_spei3_1950_na_na_na_4_eobs.png": 593735,
	"./obs_spei3_1950_na_na_na_5_eobs.png": 878548,
	"./obs_spei3_1950_na_na_na_6_eobs.png": 416292,
	"./obs_spei3_1950_na_na_na_7_eobs.png": 306156,
	"./obs_spei3_1950_na_na_na_8_eobs.png": 128828,
	"./obs_spei3_1950_na_na_na_9_eobs.png": 537704,
	"./obs_spei3_1951_na_na_na_10_eobs.png": 389024,
	"./obs_spei3_1951_na_na_na_11_eobs.png": 788940,
	"./obs_spei3_1951_na_na_na_12_eobs.png": 954276,
	"./obs_spei3_1951_na_na_na_1_eobs.png": 113464,
	"./obs_spei3_1951_na_na_na_2_eobs.png": 229124,
	"./obs_spei3_1951_na_na_na_3_eobs.png": 426240,
	"./obs_spei3_1951_na_na_na_4_eobs.png": 107464,
	"./obs_spei3_1951_na_na_na_5_eobs.png": 16628,
	"./obs_spei3_1951_na_na_na_6_eobs.png": 435967,
	"./obs_spei3_1951_na_na_na_7_eobs.png": 126428,
	"./obs_spei3_1951_na_na_na_8_eobs.png": 482172,
	"./obs_spei3_1951_na_na_na_9_eobs.png": 746376,
	"./obs_spei3_1952_na_na_na_10_eobs.png": 573116,
	"./obs_spei3_1952_na_na_na_11_eobs.png": 863200,
	"./obs_spei3_1952_na_na_na_12_eobs.png": 287044,
	"./obs_spei3_1952_na_na_na_1_eobs.png": 513316,
	"./obs_spei3_1952_na_na_na_2_eobs.png": 882872,
	"./obs_spei3_1952_na_na_na_3_eobs.png": 262768,
	"./obs_spei3_1952_na_na_na_4_eobs.png": 366900,
	"./obs_spei3_1952_na_na_na_5_eobs.png": 739416,
	"./obs_spei3_1952_na_na_na_6_eobs.png": 533116,
	"./obs_spei3_1952_na_na_na_7_eobs.png": 526176,
	"./obs_spei3_1952_na_na_na_8_eobs.png": 655040,
	"./obs_spei3_1952_na_na_na_9_eobs.png": 900988,
	"./obs_spei3_1953_na_na_na_10_eobs.png": 668772,
	"./obs_spei3_1953_na_na_na_11_eobs.png": 388855,
	"./obs_spei3_1953_na_na_na_12_eobs.png": 317628,
	"./obs_spei3_1953_na_na_na_1_eobs.png": 209016,
	"./obs_spei3_1953_na_na_na_2_eobs.png": 639624,
	"./obs_spei3_1953_na_na_na_3_eobs.png": 508656,
	"./obs_spei3_1953_na_na_na_4_eobs.png": 885948,
	"./obs_spei3_1953_na_na_na_5_eobs.png": 953640,
	"./obs_spei3_1953_na_na_na_6_eobs.png": 945656,
	"./obs_spei3_1953_na_na_na_7_eobs.png": 595604,
	"./obs_spei3_1953_na_na_na_8_eobs.png": 445636,
	"./obs_spei3_1953_na_na_na_9_eobs.png": 587320,
	"./obs_spei3_1954_na_na_na_10_eobs.png": 104388,
	"./obs_spei3_1954_na_na_na_11_eobs.png": 486300,
	"./obs_spei3_1954_na_na_na_12_eobs.png": 500300,
	"./obs_spei3_1954_na_na_na_1_eobs.png": 364288,
	"./obs_spei3_1954_na_na_na_2_eobs.png": 393084,
	"./obs_spei3_1954_na_na_na_3_eobs.png": 962988,
	"./obs_spei3_1954_na_na_na_4_eobs.png": 819772,
	"./obs_spei3_1954_na_na_na_5_eobs.png": 834584,
	"./obs_spei3_1954_na_na_na_6_eobs.png": 185628,
	"./obs_spei3_1954_na_na_na_7_eobs.png": 683308,
	"./obs_spei3_1954_na_na_na_8_eobs.png": 538592,
	"./obs_spei3_1954_na_na_na_9_eobs.png": 131412,
	"./obs_spei3_1955_na_na_na_10_eobs.png": 721060,
	"./obs_spei3_1955_na_na_na_11_eobs.png": 268920,
	"./obs_spei3_1955_na_na_na_12_eobs.png": 758536,
	"./obs_spei3_1955_na_na_na_1_eobs.png": 213832,
	"./obs_spei3_1955_na_na_na_2_eobs.png": 62488,
	"./obs_spei3_1955_na_na_na_3_eobs.png": 892092,
	"./obs_spei3_1955_na_na_na_4_eobs.png": 211856,
	"./obs_spei3_1955_na_na_na_5_eobs.png": 136909,
	"./obs_spei3_1955_na_na_na_6_eobs.png": 904396,
	"./obs_spei3_1955_na_na_na_7_eobs.png": 385103,
	"./obs_spei3_1955_na_na_na_8_eobs.png": 602380,
	"./obs_spei3_1955_na_na_na_9_eobs.png": 11636,
	"./obs_spei3_1956_na_na_na_10_eobs.png": 454676,
	"./obs_spei3_1956_na_na_na_11_eobs.png": 568168,
	"./obs_spei3_1956_na_na_na_12_eobs.png": 58356,
	"./obs_spei3_1956_na_na_na_1_eobs.png": 980852,
	"./obs_spei3_1956_na_na_na_2_eobs.png": 269540,
	"./obs_spei3_1956_na_na_na_3_eobs.png": 193488,
	"./obs_spei3_1956_na_na_na_4_eobs.png": 777728,
	"./obs_spei3_1956_na_na_na_5_eobs.png": 633773,
	"./obs_spei3_1956_na_na_na_6_eobs.png": 439596,
	"./obs_spei3_1956_na_na_na_7_eobs.png": 335684,
	"./obs_spei3_1956_na_na_na_8_eobs.png": 76648,
	"./obs_spei3_1956_na_na_na_9_eobs.png": 23824,
	"./obs_spei3_1957_na_na_na_10_eobs.png": 88764,
	"./obs_spei3_1957_na_na_na_11_eobs.png": 716964,
	"./obs_spei3_1957_na_na_na_12_eobs.png": 680276,
	"./obs_spei3_1957_na_na_na_1_eobs.png": 4188,
	"./obs_spei3_1957_na_na_na_2_eobs.png": 629116,
	"./obs_spei3_1957_na_na_na_3_eobs.png": 141700,
	"./obs_spei3_1957_na_na_na_4_eobs.png": 970308,
	"./obs_spei3_1957_na_na_na_5_eobs.png": 843032,
	"./obs_spei3_1957_na_na_na_6_eobs.png": 292957,
	"./obs_spei3_1957_na_na_na_7_eobs.png": 923973,
	"./obs_spei3_1957_na_na_na_8_eobs.png": 58660,
	"./obs_spei3_1957_na_na_na_9_eobs.png": 841448,
	"./obs_spei3_1958_na_na_na_10_eobs.png": 571468,
	"./obs_spei3_1958_na_na_na_11_eobs.png": 894583,
	"./obs_spei3_1958_na_na_na_12_eobs.png": 118332,
	"./obs_spei3_1958_na_na_na_1_eobs.png": 647172,
	"./obs_spei3_1958_na_na_na_2_eobs.png": 591480,
	"./obs_spei3_1958_na_na_na_3_eobs.png": 287288,
	"./obs_spei3_1958_na_na_na_4_eobs.png": 106416,
	"./obs_spei3_1958_na_na_na_5_eobs.png": 51476,
	"./obs_spei3_1958_na_na_na_6_eobs.png": 10148,
	"./obs_spei3_1958_na_na_na_7_eobs.png": 219628,
	"./obs_spei3_1958_na_na_na_8_eobs.png": 756600,
	"./obs_spei3_1958_na_na_na_9_eobs.png": 21764,
	"./obs_spei3_1959_na_na_na_10_eobs.png": 329456,
	"./obs_spei3_1959_na_na_na_11_eobs.png": 458524,
	"./obs_spei3_1959_na_na_na_12_eobs.png": 776288,
	"./obs_spei3_1959_na_na_na_1_eobs.png": 835040,
	"./obs_spei3_1959_na_na_na_2_eobs.png": 46448,
	"./obs_spei3_1959_na_na_na_3_eobs.png": 18020,
	"./obs_spei3_1959_na_na_na_4_eobs.png": 861988,
	"./obs_spei3_1959_na_na_na_5_eobs.png": 21160,
	"./obs_spei3_1959_na_na_na_6_eobs.png": 939956,
	"./obs_spei3_1959_na_na_na_7_eobs.png": 799528,
	"./obs_spei3_1959_na_na_na_8_eobs.png": 781748,
	"./obs_spei3_1959_na_na_na_9_eobs.png": 766220,
	"./obs_spei3_1960_na_na_na_10_eobs.png": 999612,
	"./obs_spei3_1960_na_na_na_11_eobs.png": 894468,
	"./obs_spei3_1960_na_na_na_12_eobs.png": 423272,
	"./obs_spei3_1960_na_na_na_1_eobs.png": 164440,
	"./obs_spei3_1960_na_na_na_2_eobs.png": 769736,
	"./obs_spei3_1960_na_na_na_3_eobs.png": 46100,
	"./obs_spei3_1960_na_na_na_4_eobs.png": 622448,
	"./obs_spei3_1960_na_na_na_5_eobs.png": 175204,
	"./obs_spei3_1960_na_na_na_6_eobs.png": 168772,
	"./obs_spei3_1960_na_na_na_7_eobs.png": 204512,
	"./obs_spei3_1960_na_na_na_8_eobs.png": 380420,
	"./obs_spei3_1960_na_na_na_9_eobs.png": 370096,
	"./obs_spei3_1961_na_na_na_10_eobs.png": 34412,
	"./obs_spei3_1961_na_na_na_11_eobs.png": 547848,
	"./obs_spei3_1961_na_na_na_12_eobs.png": 351540,
	"./obs_spei3_1961_na_na_na_1_eobs.png": 426264,
	"./obs_spei3_1961_na_na_na_2_eobs.png": 635316,
	"./obs_spei3_1961_na_na_na_3_eobs.png": 117516,
	"./obs_spei3_1961_na_na_na_4_eobs.png": 883692,
	"./obs_spei3_1961_na_na_na_5_eobs.png": 77044,
	"./obs_spei3_1961_na_na_na_6_eobs.png": 744516,
	"./obs_spei3_1961_na_na_na_7_eobs.png": 473896,
	"./obs_spei3_1961_na_na_na_8_eobs.png": 860999,
	"./obs_spei3_1961_na_na_na_9_eobs.png": 84060,
	"./obs_spei3_1962_na_na_na_10_eobs.png": 123460,
	"./obs_spei3_1962_na_na_na_11_eobs.png": 738276,
	"./obs_spei3_1962_na_na_na_12_eobs.png": 330652,
	"./obs_spei3_1962_na_na_na_1_eobs.png": 384500,
	"./obs_spei3_1962_na_na_na_2_eobs.png": 38408,
	"./obs_spei3_1962_na_na_na_3_eobs.png": 209748,
	"./obs_spei3_1962_na_na_na_4_eobs.png": 590064,
	"./obs_spei3_1962_na_na_na_5_eobs.png": 81328,
	"./obs_spei3_1962_na_na_na_6_eobs.png": 417984,
	"./obs_spei3_1962_na_na_na_7_eobs.png": 770940,
	"./obs_spei3_1962_na_na_na_8_eobs.png": 79268,
	"./obs_spei3_1962_na_na_na_9_eobs.png": 195824,
	"./obs_spei3_1963_na_na_na_10_eobs.png": 65912,
	"./obs_spei3_1963_na_na_na_11_eobs.png": 271064,
	"./obs_spei3_1963_na_na_na_12_eobs.png": 68644,
	"./obs_spei3_1963_na_na_na_1_eobs.png": 308860,
	"./obs_spei3_1963_na_na_na_2_eobs.png": 823980,
	"./obs_spei3_1963_na_na_na_3_eobs.png": 13616,
	"./obs_spei3_1963_na_na_na_4_eobs.png": 708144,
	"./obs_spei3_1963_na_na_na_5_eobs.png": 731928,
	"./obs_spei3_1963_na_na_na_6_eobs.png": 176856,
	"./obs_spei3_1963_na_na_na_7_eobs.png": 423800,
	"./obs_spei3_1963_na_na_na_8_eobs.png": 558860,
	"./obs_spei3_1963_na_na_na_9_eobs.png": 40440,
	"./obs_spei3_1964_na_na_na_10_eobs.png": 911184,
	"./obs_spei3_1964_na_na_na_11_eobs.png": 899548,
	"./obs_spei3_1964_na_na_na_12_eobs.png": 277312,
	"./obs_spei3_1964_na_na_na_1_eobs.png": 773796,
	"./obs_spei3_1964_na_na_na_2_eobs.png": 26960,
	"./obs_spei3_1964_na_na_na_3_eobs.png": 544792,
	"./obs_spei3_1964_na_na_na_4_eobs.png": 396992,
	"./obs_spei3_1964_na_na_na_5_eobs.png": 555136,
	"./obs_spei3_1964_na_na_na_6_eobs.png": 174028,
	"./obs_spei3_1964_na_na_na_7_eobs.png": 545764,
	"./obs_spei3_1964_na_na_na_8_eobs.png": 739644,
	"./obs_spei3_1964_na_na_na_9_eobs.png": 685360,
	"./obs_spei3_1965_na_na_na_10_eobs.png": 535156,
	"./obs_spei3_1965_na_na_na_11_eobs.png": 212956,
	"./obs_spei3_1965_na_na_na_12_eobs.png": 368373,
	"./obs_spei3_1965_na_na_na_1_eobs.png": 729820,
	"./obs_spei3_1965_na_na_na_2_eobs.png": 50884,
	"./obs_spei3_1965_na_na_na_3_eobs.png": 673696,
	"./obs_spei3_1965_na_na_na_4_eobs.png": 12612,
	"./obs_spei3_1965_na_na_na_5_eobs.png": 861084,
	"./obs_spei3_1965_na_na_na_6_eobs.png": 115156,
	"./obs_spei3_1965_na_na_na_7_eobs.png": 827572,
	"./obs_spei3_1965_na_na_na_8_eobs.png": 237224,
	"./obs_spei3_1965_na_na_na_9_eobs.png": 901564,
	"./obs_spei3_1966_na_na_na_10_eobs.png": 275328,
	"./obs_spei3_1966_na_na_na_11_eobs.png": 662160,
	"./obs_spei3_1966_na_na_na_12_eobs.png": 109564,
	"./obs_spei3_1966_na_na_na_1_eobs.png": 73872,
	"./obs_spei3_1966_na_na_na_2_eobs.png": 101168,
	"./obs_spei3_1966_na_na_na_3_eobs.png": 421780,
	"./obs_spei3_1966_na_na_na_4_eobs.png": 663304,
	"./obs_spei3_1966_na_na_na_5_eobs.png": 73276,
	"./obs_spei3_1966_na_na_na_6_eobs.png": 292264,
	"./obs_spei3_1966_na_na_na_7_eobs.png": 814508,
	"./obs_spei3_1966_na_na_na_8_eobs.png": 190812,
	"./obs_spei3_1966_na_na_na_9_eobs.png": 727740,
	"./obs_spei3_1967_na_na_na_10_eobs.png": 483904,
	"./obs_spei3_1967_na_na_na_11_eobs.png": 888272,
	"./obs_spei3_1967_na_na_na_12_eobs.png": 508412,
	"./obs_spei3_1967_na_na_na_1_eobs.png": 802552,
	"./obs_spei3_1967_na_na_na_2_eobs.png": 364372,
	"./obs_spei3_1967_na_na_na_3_eobs.png": 415940,
	"./obs_spei3_1967_na_na_na_4_eobs.png": 656543,
	"./obs_spei3_1967_na_na_na_5_eobs.png": 85204,
	"./obs_spei3_1967_na_na_na_6_eobs.png": 738116,
	"./obs_spei3_1967_na_na_na_7_eobs.png": 197808,
	"./obs_spei3_1967_na_na_na_8_eobs.png": 578308,
	"./obs_spei3_1967_na_na_na_9_eobs.png": 840088,
	"./obs_spei3_1968_na_na_na_10_eobs.png": 470944,
	"./obs_spei3_1968_na_na_na_11_eobs.png": 433680,
	"./obs_spei3_1968_na_na_na_12_eobs.png": 602852,
	"./obs_spei3_1968_na_na_na_1_eobs.png": 267240,
	"./obs_spei3_1968_na_na_na_2_eobs.png": 469076,
	"./obs_spei3_1968_na_na_na_3_eobs.png": 156084,
	"./obs_spei3_1968_na_na_na_4_eobs.png": 524452,
	"./obs_spei3_1968_na_na_na_5_eobs.png": 672016,
	"./obs_spei3_1968_na_na_na_6_eobs.png": 772156,
	"./obs_spei3_1968_na_na_na_7_eobs.png": 971124,
	"./obs_spei3_1968_na_na_na_8_eobs.png": 578656,
	"./obs_spei3_1968_na_na_na_9_eobs.png": 814828,
	"./obs_spei3_1969_na_na_na_10_eobs.png": 684824,
	"./obs_spei3_1969_na_na_na_11_eobs.png": 354956,
	"./obs_spei3_1969_na_na_na_12_eobs.png": 190572,
	"./obs_spei3_1969_na_na_na_1_eobs.png": 380820,
	"./obs_spei3_1969_na_na_na_2_eobs.png": 493020,
	"./obs_spei3_1969_na_na_na_3_eobs.png": 952992,
	"./obs_spei3_1969_na_na_na_4_eobs.png": 203576,
	"./obs_spei3_1969_na_na_na_5_eobs.png": 18056,
	"./obs_spei3_1969_na_na_na_6_eobs.png": 246116,
	"./obs_spei3_1969_na_na_na_7_eobs.png": 898288,
	"./obs_spei3_1969_na_na_na_8_eobs.png": 235048,
	"./obs_spei3_1969_na_na_na_9_eobs.png": 786184,
	"./obs_spei3_1970_na_na_na_10_eobs.png": 398956,
	"./obs_spei3_1970_na_na_na_11_eobs.png": 154120,
	"./obs_spei3_1970_na_na_na_12_eobs.png": 466672,
	"./obs_spei3_1970_na_na_na_1_eobs.png": 730768,
	"./obs_spei3_1970_na_na_na_2_eobs.png": 291440,
	"./obs_spei3_1970_na_na_na_3_eobs.png": 565812,
	"./obs_spei3_1970_na_na_na_4_eobs.png": 753344,
	"./obs_spei3_1970_na_na_na_5_eobs.png": 407296,
	"./obs_spei3_1970_na_na_na_6_eobs.png": 11944,
	"./obs_spei3_1970_na_na_na_7_eobs.png": 455816,
	"./obs_spei3_1970_na_na_na_8_eobs.png": 430992,
	"./obs_spei3_1970_na_na_na_9_eobs.png": 422528,
	"./obs_spei3_1971_na_na_na_10_eobs.png": 730668,
	"./obs_spei3_1971_na_na_na_11_eobs.png": 934068,
	"./obs_spei3_1971_na_na_na_12_eobs.png": 299516,
	"./obs_spei3_1971_na_na_na_1_eobs.png": 825416,
	"./obs_spei3_1971_na_na_na_2_eobs.png": 631104,
	"./obs_spei3_1971_na_na_na_3_eobs.png": 780472,
	"./obs_spei3_1971_na_na_na_4_eobs.png": 934732,
	"./obs_spei3_1971_na_na_na_5_eobs.png": 199352,
	"./obs_spei3_1971_na_na_na_6_eobs.png": 12932,
	"./obs_spei3_1971_na_na_na_7_eobs.png": 426836,
	"./obs_spei3_1971_na_na_na_8_eobs.png": 886055,
	"./obs_spei3_1971_na_na_na_9_eobs.png": 340208,
	"./obs_spei3_1972_na_na_na_10_eobs.png": 714388,
	"./obs_spei3_1972_na_na_na_11_eobs.png": 3816,
	"./obs_spei3_1972_na_na_na_12_eobs.png": 723452,
	"./obs_spei3_1972_na_na_na_1_eobs.png": 140680,
	"./obs_spei3_1972_na_na_na_2_eobs.png": 369712,
	"./obs_spei3_1972_na_na_na_3_eobs.png": 314396,
	"./obs_spei3_1972_na_na_na_4_eobs.png": 982676,
	"./obs_spei3_1972_na_na_na_5_eobs.png": 501692,
	"./obs_spei3_1972_na_na_na_6_eobs.png": 13264,
	"./obs_spei3_1972_na_na_na_7_eobs.png": 399312,
	"./obs_spei3_1972_na_na_na_8_eobs.png": 771992,
	"./obs_spei3_1972_na_na_na_9_eobs.png": 995608,
	"./obs_spei3_1973_na_na_na_10_eobs.png": 381584,
	"./obs_spei3_1973_na_na_na_11_eobs.png": 162668,
	"./obs_spei3_1973_na_na_na_12_eobs.png": 596984,
	"./obs_spei3_1973_na_na_na_1_eobs.png": 796428,
	"./obs_spei3_1973_na_na_na_2_eobs.png": 621735,
	"./obs_spei3_1973_na_na_na_3_eobs.png": 89644,
	"./obs_spei3_1973_na_na_na_4_eobs.png": 691732,
	"./obs_spei3_1973_na_na_na_5_eobs.png": 187956,
	"./obs_spei3_1973_na_na_na_6_eobs.png": 226508,
	"./obs_spei3_1973_na_na_na_7_eobs.png": 241079,
	"./obs_spei3_1973_na_na_na_8_eobs.png": 353976,
	"./obs_spei3_1973_na_na_na_9_eobs.png": 973052,
	"./obs_spei3_1974_na_na_na_10_eobs.png": 408908,
	"./obs_spei3_1974_na_na_na_11_eobs.png": 582868,
	"./obs_spei3_1974_na_na_na_12_eobs.png": 702984,
	"./obs_spei3_1974_na_na_na_1_eobs.png": 422588,
	"./obs_spei3_1974_na_na_na_2_eobs.png": 829376,
	"./obs_spei3_1974_na_na_na_3_eobs.png": 750588,
	"./obs_spei3_1974_na_na_na_4_eobs.png": 690879,
	"./obs_spei3_1974_na_na_na_5_eobs.png": 354428,
	"./obs_spei3_1974_na_na_na_6_eobs.png": 924788,
	"./obs_spei3_1974_na_na_na_7_eobs.png": 485524,
	"./obs_spei3_1974_na_na_na_8_eobs.png": 915381,
	"./obs_spei3_1974_na_na_na_9_eobs.png": 192356,
	"./obs_spei3_1975_na_na_na_10_eobs.png": 939872,
	"./obs_spei3_1975_na_na_na_11_eobs.png": 639740,
	"./obs_spei3_1975_na_na_na_12_eobs.png": 8272,
	"./obs_spei3_1975_na_na_na_1_eobs.png": 950808,
	"./obs_spei3_1975_na_na_na_2_eobs.png": 584512,
	"./obs_spei3_1975_na_na_na_3_eobs.png": 936092,
	"./obs_spei3_1975_na_na_na_4_eobs.png": 574980,
	"./obs_spei3_1975_na_na_na_5_eobs.png": 814460,
	"./obs_spei3_1975_na_na_na_6_eobs.png": 443060,
	"./obs_spei3_1975_na_na_na_7_eobs.png": 98856,
	"./obs_spei3_1975_na_na_na_8_eobs.png": 862472,
	"./obs_spei3_1975_na_na_na_9_eobs.png": 630148,
	"./obs_spei3_1976_na_na_na_10_eobs.png": 979040,
	"./obs_spei3_1976_na_na_na_11_eobs.png": 709784,
	"./obs_spei3_1976_na_na_na_12_eobs.png": 7088,
	"./obs_spei3_1976_na_na_na_1_eobs.png": 476284,
	"./obs_spei3_1976_na_na_na_2_eobs.png": 219984,
	"./obs_spei3_1976_na_na_na_3_eobs.png": 265004,
	"./obs_spei3_1976_na_na_na_4_eobs.png": 391140,
	"./obs_spei3_1976_na_na_na_5_eobs.png": 79756,
	"./obs_spei3_1976_na_na_na_6_eobs.png": 165316,
	"./obs_spei3_1976_na_na_na_7_eobs.png": 845748,
	"./obs_spei3_1976_na_na_na_8_eobs.png": 269928,
	"./obs_spei3_1976_na_na_na_9_eobs.png": 304008,
	"./obs_spei3_1977_na_na_na_10_eobs.png": 738328,
	"./obs_spei3_1977_na_na_na_11_eobs.png": 200140,
	"./obs_spei3_1977_na_na_na_12_eobs.png": 739180,
	"./obs_spei3_1977_na_na_na_1_eobs.png": 587752,
	"./obs_spei3_1977_na_na_na_2_eobs.png": 90928,
	"./obs_spei3_1977_na_na_na_3_eobs.png": 426140,
	"./obs_spei3_1977_na_na_na_4_eobs.png": 445260,
	"./obs_spei3_1977_na_na_na_5_eobs.png": 65840,
	"./obs_spei3_1977_na_na_na_6_eobs.png": 521608,
	"./obs_spei3_1977_na_na_na_7_eobs.png": 229388,
	"./obs_spei3_1977_na_na_na_8_eobs.png": 715636,
	"./obs_spei3_1977_na_na_na_9_eobs.png": 842952,
	"./obs_spei3_1978_na_na_na_10_eobs.png": 565272,
	"./obs_spei3_1978_na_na_na_11_eobs.png": 599628,
	"./obs_spei3_1978_na_na_na_12_eobs.png": 278060,
	"./obs_spei3_1978_na_na_na_1_eobs.png": 923696,
	"./obs_spei3_1978_na_na_na_2_eobs.png": 670468,
	"./obs_spei3_1978_na_na_na_3_eobs.png": 213856,
	"./obs_spei3_1978_na_na_na_4_eobs.png": 848152,
	"./obs_spei3_1978_na_na_na_5_eobs.png": 91660,
	"./obs_spei3_1978_na_na_na_6_eobs.png": 816320,
	"./obs_spei3_1978_na_na_na_7_eobs.png": 745060,
	"./obs_spei3_1978_na_na_na_8_eobs.png": 786287,
	"./obs_spei3_1978_na_na_na_9_eobs.png": 486852,
	"./obs_spei3_1979_na_na_na_10_eobs.png": 847688,
	"./obs_spei3_1979_na_na_na_11_eobs.png": 610404,
	"./obs_spei3_1979_na_na_na_12_eobs.png": 484128,
	"./obs_spei3_1979_na_na_na_1_eobs.png": 180576,
	"./obs_spei3_1979_na_na_na_2_eobs.png": 453716,
	"./obs_spei3_1979_na_na_na_3_eobs.png": 151612,
	"./obs_spei3_1979_na_na_na_4_eobs.png": 762560,
	"./obs_spei3_1979_na_na_na_5_eobs.png": 844664,
	"./obs_spei3_1979_na_na_na_6_eobs.png": 640644,
	"./obs_spei3_1979_na_na_na_7_eobs.png": 438837,
	"./obs_spei3_1979_na_na_na_8_eobs.png": 715324,
	"./obs_spei3_1979_na_na_na_9_eobs.png": 824072,
	"./obs_spei3_1980_na_na_na_10_eobs.png": 660076,
	"./obs_spei3_1980_na_na_na_11_eobs.png": 932836,
	"./obs_spei3_1980_na_na_na_12_eobs.png": 782468,
	"./obs_spei3_1980_na_na_na_1_eobs.png": 129316,
	"./obs_spei3_1980_na_na_na_2_eobs.png": 588228,
	"./obs_spei3_1980_na_na_na_3_eobs.png": 317576,
	"./obs_spei3_1980_na_na_na_4_eobs.png": 399008,
	"./obs_spei3_1980_na_na_na_5_eobs.png": 102660,
	"./obs_spei3_1980_na_na_na_6_eobs.png": 117024,
	"./obs_spei3_1980_na_na_na_7_eobs.png": 690004,
	"./obs_spei3_1980_na_na_na_8_eobs.png": 198988,
	"./obs_spei3_1980_na_na_na_9_eobs.png": 495924,
	"./obs_spei3_1981_na_na_na_10_eobs.png": 972116,
	"./obs_spei3_1981_na_na_na_11_eobs.png": 434476,
	"./obs_spei3_1981_na_na_na_12_eobs.png": 53256,
	"./obs_spei3_1981_na_na_na_1_eobs.png": 849020,
	"./obs_spei3_1981_na_na_na_2_eobs.png": 182148,
	"./obs_spei3_1981_na_na_na_3_eobs.png": 167736,
	"./obs_spei3_1981_na_na_na_4_eobs.png": 545492,
	"./obs_spei3_1981_na_na_na_5_eobs.png": 222559,
	"./obs_spei3_1981_na_na_na_6_eobs.png": 566072,
	"./obs_spei3_1981_na_na_na_7_eobs.png": 699212,
	"./obs_spei3_1981_na_na_na_8_eobs.png": 2056,
	"./obs_spei3_1981_na_na_na_9_eobs.png": 547920,
	"./obs_spei3_1982_na_na_na_10_eobs.png": 346735,
	"./obs_spei3_1982_na_na_na_11_eobs.png": 909751,
	"./obs_spei3_1982_na_na_na_12_eobs.png": 414536,
	"./obs_spei3_1982_na_na_na_1_eobs.png": 570272,
	"./obs_spei3_1982_na_na_na_2_eobs.png": 717804,
	"./obs_spei3_1982_na_na_na_3_eobs.png": 952284,
	"./obs_spei3_1982_na_na_na_4_eobs.png": 226948,
	"./obs_spei3_1982_na_na_na_5_eobs.png": 396780,
	"./obs_spei3_1982_na_na_na_6_eobs.png": 9232,
	"./obs_spei3_1982_na_na_na_7_eobs.png": 579352,
	"./obs_spei3_1982_na_na_na_8_eobs.png": 229692,
	"./obs_spei3_1982_na_na_na_9_eobs.png": 484127,
	"./obs_spei3_1983_na_na_na_10_eobs.png": 57404,
	"./obs_spei3_1983_na_na_na_11_eobs.png": 154928,
	"./obs_spei3_1983_na_na_na_12_eobs.png": 650664,
	"./obs_spei3_1983_na_na_na_1_eobs.png": 682092,
	"./obs_spei3_1983_na_na_na_2_eobs.png": 765960,
	"./obs_spei3_1983_na_na_na_3_eobs.png": 172744,
	"./obs_spei3_1983_na_na_na_4_eobs.png": 882008,
	"./obs_spei3_1983_na_na_na_5_eobs.png": 173728,
	"./obs_spei3_1983_na_na_na_6_eobs.png": 858288,
	"./obs_spei3_1983_na_na_na_7_eobs.png": 195152,
	"./obs_spei3_1983_na_na_na_8_eobs.png": 394272,
	"./obs_spei3_1983_na_na_na_9_eobs.png": 260492,
	"./obs_spei3_1984_na_na_na_10_eobs.png": 23372,
	"./obs_spei3_1984_na_na_na_11_eobs.png": 863928,
	"./obs_spei3_1984_na_na_na_12_eobs.png": 735888,
	"./obs_spei3_1984_na_na_na_1_eobs.png": 207704,
	"./obs_spei3_1984_na_na_na_2_eobs.png": 571192,
	"./obs_spei3_1984_na_na_na_3_eobs.png": 724652,
	"./obs_spei3_1984_na_na_na_4_eobs.png": 595756,
	"./obs_spei3_1984_na_na_na_5_eobs.png": 925740,
	"./obs_spei3_1984_na_na_na_6_eobs.png": 132844,
	"./obs_spei3_1984_na_na_na_7_eobs.png": 174308,
	"./obs_spei3_1984_na_na_na_8_eobs.png": 590032,
	"./obs_spei3_1984_na_na_na_9_eobs.png": 890040,
	"./obs_spei3_1985_na_na_na_10_eobs.png": 464916,
	"./obs_spei3_1985_na_na_na_11_eobs.png": 300652,
	"./obs_spei3_1985_na_na_na_12_eobs.png": 398436,
	"./obs_spei3_1985_na_na_na_1_eobs.png": 495556,
	"./obs_spei3_1985_na_na_na_2_eobs.png": 824424,
	"./obs_spei3_1985_na_na_na_3_eobs.png": 389344,
	"./obs_spei3_1985_na_na_na_4_eobs.png": 784244,
	"./obs_spei3_1985_na_na_na_5_eobs.png": 349580,
	"./obs_spei3_1985_na_na_na_6_eobs.png": 499012,
	"./obs_spei3_1985_na_na_na_7_eobs.png": 866108,
	"./obs_spei3_1985_na_na_na_8_eobs.png": 950636,
	"./obs_spei3_1985_na_na_na_9_eobs.png": 564412,
	"./obs_spei3_1986_na_na_na_10_eobs.png": 801312,
	"./obs_spei3_1986_na_na_na_11_eobs.png": 887500,
	"./obs_spei3_1986_na_na_na_12_eobs.png": 4887,
	"./obs_spei3_1986_na_na_na_1_eobs.png": 307452,
	"./obs_spei3_1986_na_na_na_2_eobs.png": 744856,
	"./obs_spei3_1986_na_na_na_3_eobs.png": 311255,
	"./obs_spei3_1986_na_na_na_4_eobs.png": 492700,
	"./obs_spei3_1986_na_na_na_5_eobs.png": 699280,
	"./obs_spei3_1986_na_na_na_6_eobs.png": 698548,
	"./obs_spei3_1986_na_na_na_7_eobs.png": 962692,
	"./obs_spei3_1986_na_na_na_8_eobs.png": 429588,
	"./obs_spei3_1986_na_na_na_9_eobs.png": 928156,
	"./obs_spei3_1987_na_na_na_10_eobs.png": 823992,
	"./obs_spei3_1987_na_na_na_11_eobs.png": 567468,
	"./obs_spei3_1987_na_na_na_12_eobs.png": 656924,
	"./obs_spei3_1987_na_na_na_1_eobs.png": 616156,
	"./obs_spei3_1987_na_na_na_2_eobs.png": 304524,
	"./obs_spei3_1987_na_na_na_3_eobs.png": 261813,
	"./obs_spei3_1987_na_na_na_4_eobs.png": 25372,
	"./obs_spei3_1987_na_na_na_5_eobs.png": 316884,
	"./obs_spei3_1987_na_na_na_6_eobs.png": 106520,
	"./obs_spei3_1987_na_na_na_7_eobs.png": 152020,
	"./obs_spei3_1987_na_na_na_8_eobs.png": 180244,
	"./obs_spei3_1987_na_na_na_9_eobs.png": 710856,
	"./obs_spei3_1988_na_na_na_10_eobs.png": 615100,
	"./obs_spei3_1988_na_na_na_11_eobs.png": 157508,
	"./obs_spei3_1988_na_na_na_12_eobs.png": 361428,
	"./obs_spei3_1988_na_na_na_1_eobs.png": 91812,
	"./obs_spei3_1988_na_na_na_2_eobs.png": 599480,
	"./obs_spei3_1988_na_na_na_3_eobs.png": 449568,
	"./obs_spei3_1988_na_na_na_4_eobs.png": 412468,
	"./obs_spei3_1988_na_na_na_5_eobs.png": 328900,
	"./obs_spei3_1988_na_na_na_6_eobs.png": 594152,
	"./obs_spei3_1988_na_na_na_7_eobs.png": 76628,
	"./obs_spei3_1988_na_na_na_8_eobs.png": 990212,
	"./obs_spei3_1988_na_na_na_9_eobs.png": 308748,
	"./obs_spei3_1989_na_na_na_10_eobs.png": 140260,
	"./obs_spei3_1989_na_na_na_11_eobs.png": 528076,
	"./obs_spei3_1989_na_na_na_12_eobs.png": 637788,
	"./obs_spei3_1989_na_na_na_1_eobs.png": 316488,
	"./obs_spei3_1989_na_na_na_2_eobs.png": 384404,
	"./obs_spei3_1989_na_na_na_3_eobs.png": 874940,
	"./obs_spei3_1989_na_na_na_4_eobs.png": 911280,
	"./obs_spei3_1989_na_na_na_5_eobs.png": 478944,
	"./obs_spei3_1989_na_na_na_6_eobs.png": 991540,
	"./obs_spei3_1989_na_na_na_7_eobs.png": 235652,
	"./obs_spei3_1989_na_na_na_8_eobs.png": 439908,
	"./obs_spei3_1989_na_na_na_9_eobs.png": 603880,
	"./obs_spei3_1990_na_na_na_10_eobs.png": 445340,
	"./obs_spei3_1990_na_na_na_11_eobs.png": 486671,
	"./obs_spei3_1990_na_na_na_12_eobs.png": 885120,
	"./obs_spei3_1990_na_na_na_1_eobs.png": 429220,
	"./obs_spei3_1990_na_na_na_2_eobs.png": 826108,
	"./obs_spei3_1990_na_na_na_3_eobs.png": 99868,
	"./obs_spei3_1990_na_na_na_4_eobs.png": 509152,
	"./obs_spei3_1990_na_na_na_5_eobs.png": 95748,
	"./obs_spei3_1990_na_na_na_6_eobs.png": 306020,
	"./obs_spei3_1990_na_na_na_7_eobs.png": 798256,
	"./obs_spei3_1990_na_na_na_8_eobs.png": 609020,
	"./obs_spei3_1990_na_na_na_9_eobs.png": 67932,
	"./obs_spei3_1991_na_na_na_10_eobs.png": 458472,
	"./obs_spei3_1991_na_na_na_11_eobs.png": 320336,
	"./obs_spei3_1991_na_na_na_12_eobs.png": 436048,
	"./obs_spei3_1991_na_na_na_1_eobs.png": 640416,
	"./obs_spei3_1991_na_na_na_2_eobs.png": 576660,
	"./obs_spei3_1991_na_na_na_3_eobs.png": 361976,
	"./obs_spei3_1991_na_na_na_4_eobs.png": 639816,
	"./obs_spei3_1991_na_na_na_5_eobs.png": 90248,
	"./obs_spei3_1991_na_na_na_6_eobs.png": 902360,
	"./obs_spei3_1991_na_na_na_7_eobs.png": 674208,
	"./obs_spei3_1991_na_na_na_8_eobs.png": 154788,
	"./obs_spei3_1991_na_na_na_9_eobs.png": 325124,
	"./obs_spei3_1992_na_na_na_10_eobs.png": 955532,
	"./obs_spei3_1992_na_na_na_11_eobs.png": 883124,
	"./obs_spei3_1992_na_na_na_12_eobs.png": 238200,
	"./obs_spei3_1992_na_na_na_1_eobs.png": 264740,
	"./obs_spei3_1992_na_na_na_2_eobs.png": 302392,
	"./obs_spei3_1992_na_na_na_3_eobs.png": 789404,
	"./obs_spei3_1992_na_na_na_4_eobs.png": 318896,
	"./obs_spei3_1992_na_na_na_5_eobs.png": 755324,
	"./obs_spei3_1992_na_na_na_6_eobs.png": 266132,
	"./obs_spei3_1992_na_na_na_7_eobs.png": 556364,
	"./obs_spei3_1992_na_na_na_8_eobs.png": 555528,
	"./obs_spei3_1992_na_na_na_9_eobs.png": 277572,
	"./obs_spei3_1993_na_na_na_10_eobs.png": 647280,
	"./obs_spei3_1993_na_na_na_11_eobs.png": 958180,
	"./obs_spei3_1993_na_na_na_12_eobs.png": 745728,
	"./obs_spei3_1993_na_na_na_1_eobs.png": 670136,
	"./obs_spei3_1993_na_na_na_2_eobs.png": 527200,
	"./obs_spei3_1993_na_na_na_3_eobs.png": 607871,
	"./obs_spei3_1993_na_na_na_4_eobs.png": 820024,
	"./obs_spei3_1993_na_na_na_5_eobs.png": 971340,
	"./obs_spei3_1993_na_na_na_6_eobs.png": 956484,
	"./obs_spei3_1993_na_na_na_7_eobs.png": 172912,
	"./obs_spei3_1993_na_na_na_8_eobs.png": 642580,
	"./obs_spei3_1993_na_na_na_9_eobs.png": 916656,
	"./obs_spei3_1994_na_na_na_10_eobs.png": 627300,
	"./obs_spei3_1994_na_na_na_11_eobs.png": 777965,
	"./obs_spei3_1994_na_na_na_12_eobs.png": 356128,
	"./obs_spei3_1994_na_na_na_1_eobs.png": 384476,
	"./obs_spei3_1994_na_na_na_2_eobs.png": 533556,
	"./obs_spei3_1994_na_na_na_3_eobs.png": 818908,
	"./obs_spei3_1994_na_na_na_4_eobs.png": 953424,
	"./obs_spei3_1994_na_na_na_5_eobs.png": 752420,
	"./obs_spei3_1994_na_na_na_6_eobs.png": 870380,
	"./obs_spei3_1994_na_na_na_7_eobs.png": 990623,
	"./obs_spei3_1994_na_na_na_8_eobs.png": 546388,
	"./obs_spei3_1994_na_na_na_9_eobs.png": 82300,
	"./obs_spei3_1995_na_na_na_10_eobs.png": 146656,
	"./obs_spei3_1995_na_na_na_11_eobs.png": 507172,
	"./obs_spei3_1995_na_na_na_12_eobs.png": 218516,
	"./obs_spei3_1995_na_na_na_1_eobs.png": 456120,
	"./obs_spei3_1995_na_na_na_2_eobs.png": 295071,
	"./obs_spei3_1995_na_na_na_3_eobs.png": 111664,
	"./obs_spei3_1995_na_na_na_4_eobs.png": 432032,
	"./obs_spei3_1995_na_na_na_5_eobs.png": 292200,
	"./obs_spei3_1995_na_na_na_6_eobs.png": 813156,
	"./obs_spei3_1995_na_na_na_7_eobs.png": 295892,
	"./obs_spei3_1995_na_na_na_8_eobs.png": 813573,
	"./obs_spei3_1995_na_na_na_9_eobs.png": 304284,
	"./obs_spei3_1996_na_na_na_10_eobs.png": 841676,
	"./obs_spei3_1996_na_na_na_11_eobs.png": 479160,
	"./obs_spei3_1996_na_na_na_12_eobs.png": 836212,
	"./obs_spei3_1996_na_na_na_1_eobs.png": 519616,
	"./obs_spei3_1996_na_na_na_2_eobs.png": 877040,
	"./obs_spei3_1996_na_na_na_3_eobs.png": 847888,
	"./obs_spei3_1996_na_na_na_4_eobs.png": 420212,
	"./obs_spei3_1996_na_na_na_5_eobs.png": 293828,
	"./obs_spei3_1996_na_na_na_6_eobs.png": 785544,
	"./obs_spei3_1996_na_na_na_7_eobs.png": 637388,
	"./obs_spei3_1996_na_na_na_8_eobs.png": 204804,
	"./obs_spei3_1996_na_na_na_9_eobs.png": 313932,
	"./obs_spei3_1997_na_na_na_10_eobs.png": 949084,
	"./obs_spei3_1997_na_na_na_11_eobs.png": 612864,
	"./obs_spei3_1997_na_na_na_12_eobs.png": 432768,
	"./obs_spei3_1997_na_na_na_1_eobs.png": 106192,
	"./obs_spei3_1997_na_na_na_2_eobs.png": 597168,
	"./obs_spei3_1997_na_na_na_3_eobs.png": 212860,
	"./obs_spei3_1997_na_na_na_4_eobs.png": 216604,
	"./obs_spei3_1997_na_na_na_5_eobs.png": 751064,
	"./obs_spei3_1997_na_na_na_6_eobs.png": 477232,
	"./obs_spei3_1997_na_na_na_7_eobs.png": 275612,
	"./obs_spei3_1997_na_na_na_8_eobs.png": 539580,
	"./obs_spei3_1997_na_na_na_9_eobs.png": 386280,
	"./obs_spei3_1998_na_na_na_10_eobs.png": 626652,
	"./obs_spei3_1998_na_na_na_11_eobs.png": 118796,
	"./obs_spei3_1998_na_na_na_12_eobs.png": 562260,
	"./obs_spei3_1998_na_na_na_1_eobs.png": 823260,
	"./obs_spei3_1998_na_na_na_2_eobs.png": 989024,
	"./obs_spei3_1998_na_na_na_3_eobs.png": 487464,
	"./obs_spei3_1998_na_na_na_4_eobs.png": 324780,
	"./obs_spei3_1998_na_na_na_5_eobs.png": 409000,
	"./obs_spei3_1998_na_na_na_6_eobs.png": 635880,
	"./obs_spei3_1998_na_na_na_7_eobs.png": 524068,
	"./obs_spei3_1998_na_na_na_8_eobs.png": 299092,
	"./obs_spei3_1998_na_na_na_9_eobs.png": 341653,
	"./obs_spei3_1999_na_na_na_10_eobs.png": 864236,
	"./obs_spei3_1999_na_na_na_11_eobs.png": 657136,
	"./obs_spei3_1999_na_na_na_12_eobs.png": 77688,
	"./obs_spei3_1999_na_na_na_1_eobs.png": 545276,
	"./obs_spei3_1999_na_na_na_2_eobs.png": 653176,
	"./obs_spei3_1999_na_na_na_3_eobs.png": 860813,
	"./obs_spei3_1999_na_na_na_4_eobs.png": 753844,
	"./obs_spei3_1999_na_na_na_5_eobs.png": 487836,
	"./obs_spei3_1999_na_na_na_6_eobs.png": 448668,
	"./obs_spei3_1999_na_na_na_7_eobs.png": 684692,
	"./obs_spei3_1999_na_na_na_8_eobs.png": 112748,
	"./obs_spei3_1999_na_na_na_9_eobs.png": 177820,
	"./obs_spei3_2000_na_na_na_10_eobs.png": 326800,
	"./obs_spei3_2000_na_na_na_11_eobs.png": 595004,
	"./obs_spei3_2000_na_na_na_12_eobs.png": 500084,
	"./obs_spei3_2000_na_na_na_1_eobs.png": 490528,
	"./obs_spei3_2000_na_na_na_2_eobs.png": 642108,
	"./obs_spei3_2000_na_na_na_3_eobs.png": 867140,
	"./obs_spei3_2000_na_na_na_4_eobs.png": 589452,
	"./obs_spei3_2000_na_na_na_5_eobs.png": 553844,
	"./obs_spei3_2000_na_na_na_6_eobs.png": 230108,
	"./obs_spei3_2000_na_na_na_7_eobs.png": 957348,
	"./obs_spei3_2000_na_na_na_8_eobs.png": 41160,
	"./obs_spei3_2000_na_na_na_9_eobs.png": 690360,
	"./obs_spei3_2001_na_na_na_10_eobs.png": 389924,
	"./obs_spei3_2001_na_na_na_11_eobs.png": 594077,
	"./obs_spei3_2001_na_na_na_12_eobs.png": 750524,
	"./obs_spei3_2001_na_na_na_1_eobs.png": 765276,
	"./obs_spei3_2001_na_na_na_2_eobs.png": 155732,
	"./obs_spei3_2001_na_na_na_3_eobs.png": 732448,
	"./obs_spei3_2001_na_na_na_4_eobs.png": 970472,
	"./obs_spei3_2001_na_na_na_5_eobs.png": 629924,
	"./obs_spei3_2001_na_na_na_6_eobs.png": 112660,
	"./obs_spei3_2001_na_na_na_7_eobs.png": 397600,
	"./obs_spei3_2001_na_na_na_8_eobs.png": 756536,
	"./obs_spei3_2001_na_na_na_9_eobs.png": 145460,
	"./obs_spei3_2002_na_na_na_10_eobs.png": 833328,
	"./obs_spei3_2002_na_na_na_11_eobs.png": 830704,
	"./obs_spei3_2002_na_na_na_12_eobs.png": 688912,
	"./obs_spei3_2002_na_na_na_1_eobs.png": 640096,
	"./obs_spei3_2002_na_na_na_2_eobs.png": 719332,
	"./obs_spei3_2002_na_na_na_3_eobs.png": 471848,
	"./obs_spei3_2002_na_na_na_4_eobs.png": 228788,
	"./obs_spei3_2002_na_na_na_5_eobs.png": 15268,
	"./obs_spei3_2002_na_na_na_6_eobs.png": 657260,
	"./obs_spei3_2002_na_na_na_7_eobs.png": 641680,
	"./obs_spei3_2002_na_na_na_8_eobs.png": 236428,
	"./obs_spei3_2002_na_na_na_9_eobs.png": 282632,
	"./obs_spei3_2003_na_na_na_10_eobs.png": 879152,
	"./obs_spei3_2003_na_na_na_11_eobs.png": 495588,
	"./obs_spei3_2003_na_na_na_12_eobs.png": 940287,
	"./obs_spei3_2003_na_na_na_1_eobs.png": 604328,
	"./obs_spei3_2003_na_na_na_2_eobs.png": 897484,
	"./obs_spei3_2003_na_na_na_3_eobs.png": 38604,
	"./obs_spei3_2003_na_na_na_4_eobs.png": 34584,
	"./obs_spei3_2003_na_na_na_5_eobs.png": 486240,
	"./obs_spei3_2003_na_na_na_6_eobs.png": 163104,
	"./obs_spei3_2003_na_na_na_7_eobs.png": 59060,
	"./obs_spei3_2003_na_na_na_8_eobs.png": 528191,
	"./obs_spei3_2003_na_na_na_9_eobs.png": 294020,
	"./obs_spei3_2004_na_na_na_10_eobs.png": 320976,
	"./obs_spei3_2004_na_na_na_11_eobs.png": 291368,
	"./obs_spei3_2004_na_na_na_12_eobs.png": 452703,
	"./obs_spei3_2004_na_na_na_1_eobs.png": 48568,
	"./obs_spei3_2004_na_na_na_2_eobs.png": 93260,
	"./obs_spei3_2004_na_na_na_3_eobs.png": 651764,
	"./obs_spei3_2004_na_na_na_4_eobs.png": 280784,
	"./obs_spei3_2004_na_na_na_5_eobs.png": 564612,
	"./obs_spei3_2004_na_na_na_6_eobs.png": 80784,
	"./obs_spei3_2004_na_na_na_7_eobs.png": 76292,
	"./obs_spei3_2004_na_na_na_8_eobs.png": 340839,
	"./obs_spei3_2004_na_na_na_9_eobs.png": 679516,
	"./obs_spei3_2005_na_na_na_10_eobs.png": 986328,
	"./obs_spei3_2005_na_na_na_11_eobs.png": 719272,
	"./obs_spei3_2005_na_na_na_12_eobs.png": 187748,
	"./obs_spei3_2005_na_na_na_1_eobs.png": 759324,
	"./obs_spei3_2005_na_na_na_2_eobs.png": 507588,
	"./obs_spei3_2005_na_na_na_3_eobs.png": 684992,
	"./obs_spei3_2005_na_na_na_4_eobs.png": 347492,
	"./obs_spei3_2005_na_na_na_5_eobs.png": 533228,
	"./obs_spei3_2005_na_na_na_6_eobs.png": 349140,
	"./obs_spei3_2005_na_na_na_7_eobs.png": 616224,
	"./obs_spei3_2005_na_na_na_8_eobs.png": 863004,
	"./obs_spei3_2005_na_na_na_9_eobs.png": 32856,
	"./obs_spei3_2006_na_na_na_10_eobs.png": 84516,
	"./obs_spei3_2006_na_na_na_11_eobs.png": 244248,
	"./obs_spei3_2006_na_na_na_12_eobs.png": 963972,
	"./obs_spei3_2006_na_na_na_1_eobs.png": 646816,
	"./obs_spei3_2006_na_na_na_2_eobs.png": 645784,
	"./obs_spei3_2006_na_na_na_3_eobs.png": 92224,
	"./obs_spei3_2006_na_na_na_4_eobs.png": 317096,
	"./obs_spei3_2006_na_na_na_5_eobs.png": 475324,
	"./obs_spei3_2006_na_na_na_6_eobs.png": 301180,
	"./obs_spei3_2006_na_na_na_7_eobs.png": 205996,
	"./obs_spei3_2006_na_na_na_8_eobs.png": 585348,
	"./obs_spei3_2006_na_na_na_9_eobs.png": 485836,
	"./obs_spei3_2007_na_na_na_10_eobs.png": 726436,
	"./obs_spei3_2007_na_na_na_11_eobs.png": 164604,
	"./obs_spei3_2007_na_na_na_12_eobs.png": 700268,
	"./obs_spei3_2007_na_na_na_1_eobs.png": 70728,
	"./obs_spei3_2007_na_na_na_2_eobs.png": 49128,
	"./obs_spei3_2007_na_na_na_3_eobs.png": 987584,
	"./obs_spei3_2007_na_na_na_4_eobs.png": 893205,
	"./obs_spei3_2007_na_na_na_5_eobs.png": 240452,
	"./obs_spei3_2007_na_na_na_6_eobs.png": 82412,
	"./obs_spei3_2007_na_na_na_7_eobs.png": 272608,
	"./obs_spei3_2007_na_na_na_8_eobs.png": 733380,
	"./obs_spei3_2007_na_na_na_9_eobs.png": 239884,
	"./obs_spei3_2008_na_na_na_10_eobs.png": 910200,
	"./obs_spei3_2008_na_na_na_11_eobs.png": 344888,
	"./obs_spei3_2008_na_na_na_12_eobs.png": 769760,
	"./obs_spei3_2008_na_na_na_1_eobs.png": 151684,
	"./obs_spei3_2008_na_na_na_2_eobs.png": 738696,
	"./obs_spei3_2008_na_na_na_3_eobs.png": 670824,
	"./obs_spei3_2008_na_na_na_4_eobs.png": 492772,
	"./obs_spei3_2008_na_na_na_5_eobs.png": 881808,
	"./obs_spei3_2008_na_na_na_6_eobs.png": 868600,
	"./obs_spei3_2008_na_na_na_7_eobs.png": 51392,
	"./obs_spei3_2008_na_na_na_8_eobs.png": 679212,
	"./obs_spei3_2008_na_na_na_9_eobs.png": 816772,
	"./obs_spei3_2009_na_na_na_10_eobs.png": 1112,
	"./obs_spei3_2009_na_na_na_11_eobs.png": 874660,
	"./obs_spei3_2009_na_na_na_12_eobs.png": 798732,
	"./obs_spei3_2009_na_na_na_1_eobs.png": 1932,
	"./obs_spei3_2009_na_na_na_2_eobs.png": 459192,
	"./obs_spei3_2009_na_na_na_3_eobs.png": 643300,
	"./obs_spei3_2009_na_na_na_4_eobs.png": 238196,
	"./obs_spei3_2009_na_na_na_5_eobs.png": 458140,
	"./obs_spei3_2009_na_na_na_6_eobs.png": 707408,
	"./obs_spei3_2009_na_na_na_7_eobs.png": 112944,
	"./obs_spei3_2009_na_na_na_8_eobs.png": 453084,
	"./obs_spei3_2009_na_na_na_9_eobs.png": 635072,
	"./obs_spei3_2010_na_na_na_10_eobs.png": 657920,
	"./obs_spei3_2010_na_na_na_11_eobs.png": 413148,
	"./obs_spei3_2010_na_na_na_12_eobs.png": 592368,
	"./obs_spei3_2010_na_na_na_1_eobs.png": 367844,
	"./obs_spei3_2010_na_na_na_2_eobs.png": 348476,
	"./obs_spei3_2010_na_na_na_3_eobs.png": 928852,
	"./obs_spei3_2010_na_na_na_4_eobs.png": 370280,
	"./obs_spei3_2010_na_na_na_5_eobs.png": 180904,
	"./obs_spei3_2010_na_na_na_6_eobs.png": 214324,
	"./obs_spei3_2010_na_na_na_7_eobs.png": 869452,
	"./obs_spei3_2010_na_na_na_8_eobs.png": 924940,
	"./obs_spei3_2010_na_na_na_9_eobs.png": 333952,
	"./obs_spei3_2011_na_na_na_10_eobs.png": 108820,
	"./obs_spei3_2011_na_na_na_11_eobs.png": 977360,
	"./obs_spei3_2011_na_na_na_12_eobs.png": 556388,
	"./obs_spei3_2011_na_na_na_1_eobs.png": 790544,
	"./obs_spei3_2011_na_na_na_2_eobs.png": 496892,
	"./obs_spei3_2011_na_na_na_3_eobs.png": 627172,
	"./obs_spei3_2011_na_na_na_4_eobs.png": 534412,
	"./obs_spei3_2011_na_na_na_5_eobs.png": 222220,
	"./obs_spei3_2011_na_na_na_6_eobs.png": 35928,
	"./obs_spei3_2011_na_na_na_7_eobs.png": 507996,
	"./obs_spei3_2011_na_na_na_8_eobs.png": 491068,
	"./obs_spei3_2011_na_na_na_9_eobs.png": 625940,
	"./obs_spei3_2012_na_na_na_10_eobs.png": 404216,
	"./obs_spei3_2012_na_na_na_11_eobs.png": 188672,
	"./obs_spei3_2012_na_na_na_12_eobs.png": 829292,
	"./obs_spei3_2012_na_na_na_1_eobs.png": 46544,
	"./obs_spei3_2012_na_na_na_2_eobs.png": 725640,
	"./obs_spei3_2012_na_na_na_3_eobs.png": 805460,
	"./obs_spei3_2012_na_na_na_4_eobs.png": 433149,
	"./obs_spei3_2012_na_na_na_5_eobs.png": 854976,
	"./obs_spei3_2012_na_na_na_6_eobs.png": 664540,
	"./obs_spei3_2012_na_na_na_7_eobs.png": 106728,
	"./obs_spei3_2012_na_na_na_8_eobs.png": 243972,
	"./obs_spei3_2012_na_na_na_9_eobs.png": 354848,
	"./obs_spei3_2013_na_na_na_10_eobs.png": 692744,
	"./obs_spei3_2013_na_na_na_11_eobs.png": 183112,
	"./obs_spei3_2013_na_na_na_12_eobs.png": 980092,
	"./obs_spei3_2013_na_na_na_1_eobs.png": 951812,
	"./obs_spei3_2013_na_na_na_2_eobs.png": 480644,
	"./obs_spei3_2013_na_na_na_3_eobs.png": 844132,
	"./obs_spei3_2013_na_na_na_4_eobs.png": 602204,
	"./obs_spei3_2013_na_na_na_5_eobs.png": 346463,
	"./obs_spei3_2013_na_na_na_6_eobs.png": 342740,
	"./obs_spei3_2013_na_na_na_7_eobs.png": 990728,
	"./obs_spei3_2013_na_na_na_8_eobs.png": 801140,
	"./obs_spei3_2013_na_na_na_9_eobs.png": 761992,
	"./obs_spei3_2014_na_na_na_10_eobs.png": 247676,
	"./obs_spei3_2014_na_na_na_11_eobs.png": 605192,
	"./obs_spei3_2014_na_na_na_12_eobs.png": 239820,
	"./obs_spei3_2014_na_na_na_1_eobs.png": 125224,
	"./obs_spei3_2014_na_na_na_2_eobs.png": 61632,
	"./obs_spei3_2014_na_na_na_3_eobs.png": 195676,
	"./obs_spei3_2014_na_na_na_4_eobs.png": 877788,
	"./obs_spei3_2014_na_na_na_5_eobs.png": 37231,
	"./obs_spei3_2014_na_na_na_6_eobs.png": 577284,
	"./obs_spei3_2014_na_na_na_7_eobs.png": 39796,
	"./obs_spei3_2014_na_na_na_8_eobs.png": 112380,
	"./obs_spei3_2014_na_na_na_9_eobs.png": 845452,
	"./obs_spei3_2015_na_na_na_10_eobs.png": 2116,
	"./obs_spei3_2015_na_na_na_11_eobs.png": 596148,
	"./obs_spei3_2015_na_na_na_12_eobs.png": 479580,
	"./obs_spei3_2015_na_na_na_1_eobs.png": 381592,
	"./obs_spei3_2015_na_na_na_2_eobs.png": 981640,
	"./obs_spei3_2015_na_na_na_3_eobs.png": 566324,
	"./obs_spei3_2015_na_na_na_4_eobs.png": 124264,
	"./obs_spei3_2015_na_na_na_5_eobs.png": 808812,
	"./obs_spei3_2015_na_na_na_6_eobs.png": 136688,
	"./obs_spei3_2015_na_na_na_7_eobs.png": 364312,
	"./obs_spei3_2015_na_na_na_8_eobs.png": 611012,
	"./obs_spei3_2015_na_na_na_9_eobs.png": 786168,
	"./obs_spei3_2016_na_na_na_10_eobs.png": 256176,
	"./obs_spei3_2016_na_na_na_11_eobs.png": 288508,
	"./obs_spei3_2016_na_na_na_12_eobs.png": 497976,
	"./obs_spei3_2016_na_na_na_1_eobs.png": 527695,
	"./obs_spei3_2016_na_na_na_2_eobs.png": 800376,
	"./obs_spei3_2016_na_na_na_3_eobs.png": 457636,
	"./obs_spei3_2016_na_na_na_4_eobs.png": 422276,
	"./obs_spei3_2016_na_na_na_5_eobs.png": 945000,
	"./obs_spei3_2016_na_na_na_6_eobs.png": 174572,
	"./obs_spei3_2016_na_na_na_7_eobs.png": 948344,
	"./obs_spei3_2016_na_na_na_8_eobs.png": 451072,
	"./obs_spei3_2016_na_na_na_9_eobs.png": 973715,
	"./obs_spei3_2017_na_na_na_10_eobs.png": 933948,
	"./obs_spei3_2017_na_na_na_11_eobs.png": 417277,
	"./obs_spei3_2017_na_na_na_12_eobs.png": 997468,
	"./obs_spei3_2017_na_na_na_1_eobs.png": 127820,
	"./obs_spei3_2017_na_na_na_2_eobs.png": 452528,
	"./obs_spei3_2017_na_na_na_3_eobs.png": 899384,
	"./obs_spei3_2017_na_na_na_4_eobs.png": 224500,
	"./obs_spei3_2017_na_na_na_5_eobs.png": 230428,
	"./obs_spei3_2017_na_na_na_6_eobs.png": 530039,
	"./obs_spei3_2017_na_na_na_7_eobs.png": 495364,
	"./obs_spei3_2017_na_na_na_8_eobs.png": 297108,
	"./obs_spei3_2017_na_na_na_9_eobs.png": 86360,
	"./obs_spei3_2018_na_na_na_10_eobs.png": 120996,
	"./obs_spei3_2018_na_na_na_11_eobs.png": 131092,
	"./obs_spei3_2018_na_na_na_12_eobs.png": 540895,
	"./obs_spei3_2018_na_na_na_1_eobs.png": 442831,
	"./obs_spei3_2018_na_na_na_2_eobs.png": 570916,
	"./obs_spei3_2018_na_na_na_3_eobs.png": 26872,
	"./obs_spei3_2018_na_na_na_4_eobs.png": 68932,
	"./obs_spei3_2018_na_na_na_5_eobs.png": 222679,
	"./obs_spei3_2018_na_na_na_6_eobs.png": 268828,
	"./obs_spei3_2018_na_na_na_7_eobs.png": 91236,
	"./obs_spei3_2018_na_na_na_8_eobs.png": 533688,
	"./obs_spei3_2018_na_na_na_9_eobs.png": 955932,
	"./obs_spei3_2019_na_na_na_10_eobs.png": 951020,
	"./obs_spei3_2019_na_na_na_11_eobs.png": 345164,
	"./obs_spei3_2019_na_na_na_12_eobs.png": 684368,
	"./obs_spei3_2019_na_na_na_1_eobs.png": 428836,
	"./obs_spei3_2019_na_na_na_2_eobs.png": 357564,
	"./obs_spei3_2019_na_na_na_3_eobs.png": 799536,
	"./obs_spei3_2019_na_na_na_4_eobs.png": 385844,
	"./obs_spei3_2019_na_na_na_5_eobs.png": 108572,
	"./obs_spei3_2019_na_na_na_6_eobs.png": 584052,
	"./obs_spei3_2019_na_na_na_7_eobs.png": 491836,
	"./obs_spei3_2019_na_na_na_8_eobs.png": 871032,
	"./obs_spei3_2019_na_na_na_9_eobs.png": 343028,
	"./obs_spei3_2020_na_na_na_10_eobs.png": 407836,
	"./obs_spei3_2020_na_na_na_11_eobs.png": 401167,
	"./obs_spei3_2020_na_na_na_12_eobs.png": 276144,
	"./obs_spei3_2020_na_na_na_1_eobs.png": 684788,
	"./obs_spei3_2020_na_na_na_2_eobs.png": 424404,
	"./obs_spei3_2020_na_na_na_3_eobs.png": 272800,
	"./obs_spei3_2020_na_na_na_4_eobs.png": 395044,
	"./obs_spei3_2020_na_na_na_5_eobs.png": 287916,
	"./obs_spei3_2020_na_na_na_6_eobs.png": 484780,
	"./obs_spei3_2020_na_na_na_7_eobs.png": 633784,
	"./obs_spei3_2020_na_na_na_8_eobs.png": 885464,
	"./obs_spei3_2020_na_na_na_9_eobs.png": 760,
	"./obs_spei3_2021_na_na_na_10_eobs.png": 681224,
	"./obs_spei3_2021_na_na_na_11_eobs.png": 187732,
	"./obs_spei3_2021_na_na_na_12_eobs.png": 158132,
	"./obs_spei3_2021_na_na_na_1_eobs.png": 834328,
	"./obs_spei3_2021_na_na_na_2_eobs.png": 342004,
	"./obs_spei3_2021_na_na_na_3_eobs.png": 927940,
	"./obs_spei3_2021_na_na_na_4_eobs.png": 558472,
	"./obs_spei3_2021_na_na_na_5_eobs.png": 120324,
	"./obs_spei3_2021_na_na_na_6_eobs.png": 142068,
	"./obs_spei3_2021_na_na_na_7_eobs.png": 602980,
	"./obs_spei3_2021_na_na_na_8_eobs.png": 389808,
	"./obs_spei3_2021_na_na_na_9_eobs.png": 544860,
	"./obs_spei3_2022_na_na_na_10_eobs.png": 237015,
	"./obs_spei3_2022_na_na_na_11_eobs.png": 808836,
	"./obs_spei3_2022_na_na_na_12_eobs.png": 531812,
	"./obs_spei3_2022_na_na_na_1_eobs.png": 531224,
	"./obs_spei3_2022_na_na_na_2_eobs.png": 74452,
	"./obs_spei3_2022_na_na_na_3_eobs.png": 698340,
	"./obs_spei3_2022_na_na_na_4_eobs.png": 208344,
	"./obs_spei3_2022_na_na_na_5_eobs.png": 640604,
	"./obs_spei3_2022_na_na_na_6_eobs.png": 282304,
	"./obs_spei3_2022_na_na_na_7_eobs.png": 476488,
	"./obs_spei3_2022_na_na_na_8_eobs.png": 406040,
	"./obs_spei3_2022_na_na_na_9_eobs.png": 929725,
	"./obs_spei3_2023_na_na_na_10_eobs.png": 440532,
	"./obs_spei3_2023_na_na_na_11_eobs.png": 561588,
	"./obs_spei3_2023_na_na_na_12_eobs.png": 91244,
	"./obs_spei3_2023_na_na_na_1_eobs.png": 226180,
	"./obs_spei3_2023_na_na_na_2_eobs.png": 898508,
	"./obs_spei3_2023_na_na_na_3_eobs.png": 571784,
	"./obs_spei3_2023_na_na_na_4_eobs.png": 152840,
	"./obs_spei3_2023_na_na_na_5_eobs.png": 164156,
	"./obs_spei3_2023_na_na_na_6_eobs.png": 659192,
	"./obs_spei3_2023_na_na_na_7_eobs.png": 727096,
	"./obs_spei3_2023_na_na_na_8_eobs.png": 602004,
	"./obs_spei3_2023_na_na_na_9_eobs.png": 833340,
	"./obs_spei6_1950_na_na_na_10_eobs.png": 112684,
	"./obs_spei6_1950_na_na_na_11_eobs.png": 892172,
	"./obs_spei6_1950_na_na_na_12_eobs.png": 333588,
	"./obs_spei6_1950_na_na_na_1_eobs.png": 727277,
	"./obs_spei6_1950_na_na_na_2_eobs.png": 349292,
	"./obs_spei6_1950_na_na_na_3_eobs.png": 428884,
	"./obs_spei6_1950_na_na_na_4_eobs.png": 21936,
	"./obs_spei6_1950_na_na_na_5_eobs.png": 650788,
	"./obs_spei6_1950_na_na_na_6_eobs.png": 690408,
	"./obs_spei6_1950_na_na_na_7_eobs.png": 801412,
	"./obs_spei6_1950_na_na_na_8_eobs.png": 751289,
	"./obs_spei6_1950_na_na_na_9_eobs.png": 632020,
	"./obs_spei6_1951_na_na_na_10_eobs.png": 336448,
	"./obs_spei6_1951_na_na_na_11_eobs.png": 513476,
	"./obs_spei6_1951_na_na_na_12_eobs.png": 65988,
	"./obs_spei6_1951_na_na_na_1_eobs.png": 140900,
	"./obs_spei6_1951_na_na_na_2_eobs.png": 161904,
	"./obs_spei6_1951_na_na_na_3_eobs.png": 222140,
	"./obs_spei6_1951_na_na_na_4_eobs.png": 762639,
	"./obs_spei6_1951_na_na_na_5_eobs.png": 984048,
	"./obs_spei6_1951_na_na_na_6_eobs.png": 187916,
	"./obs_spei6_1951_na_na_na_7_eobs.png": 46728,
	"./obs_spei6_1951_na_na_na_8_eobs.png": 868624,
	"./obs_spei6_1951_na_na_na_9_eobs.png": 29508,
	"./obs_spei6_1952_na_na_na_10_eobs.png": 83416,
	"./obs_spei6_1952_na_na_na_11_eobs.png": 180876,
	"./obs_spei6_1952_na_na_na_12_eobs.png": 64140,
	"./obs_spei6_1952_na_na_na_1_eobs.png": 385584,
	"./obs_spei6_1952_na_na_na_2_eobs.png": 507592,
	"./obs_spei6_1952_na_na_na_3_eobs.png": 298028,
	"./obs_spei6_1952_na_na_na_4_eobs.png": 848764,
	"./obs_spei6_1952_na_na_na_5_eobs.png": 307460,
	"./obs_spei6_1952_na_na_na_6_eobs.png": 287756,
	"./obs_spei6_1952_na_na_na_7_eobs.png": 879764,
	"./obs_spei6_1952_na_na_na_8_eobs.png": 210461,
	"./obs_spei6_1952_na_na_na_9_eobs.png": 829588,
	"./obs_spei6_1953_na_na_na_10_eobs.png": 331544,
	"./obs_spei6_1953_na_na_na_11_eobs.png": 270280,
	"./obs_spei6_1953_na_na_na_12_eobs.png": 755188,
	"./obs_spei6_1953_na_na_na_1_eobs.png": 378744,
	"./obs_spei6_1953_na_na_na_2_eobs.png": 129708,
	"./obs_spei6_1953_na_na_na_3_eobs.png": 660788,
	"./obs_spei6_1953_na_na_na_4_eobs.png": 502424,
	"./obs_spei6_1953_na_na_na_5_eobs.png": 164264,
	"./obs_spei6_1953_na_na_na_6_eobs.png": 780084,
	"./obs_spei6_1953_na_na_na_7_eobs.png": 803476,
	"./obs_spei6_1953_na_na_na_8_eobs.png": 524552,
	"./obs_spei6_1953_na_na_na_9_eobs.png": 212088,
	"./obs_spei6_1954_na_na_na_10_eobs.png": 175032,
	"./obs_spei6_1954_na_na_na_11_eobs.png": 742176,
	"./obs_spei6_1954_na_na_na_12_eobs.png": 804876,
	"./obs_spei6_1954_na_na_na_1_eobs.png": 820192,
	"./obs_spei6_1954_na_na_na_2_eobs.png": 715456,
	"./obs_spei6_1954_na_na_na_3_eobs.png": 630028,
	"./obs_spei6_1954_na_na_na_4_eobs.png": 604524,
	"./obs_spei6_1954_na_na_na_5_eobs.png": 60284,
	"./obs_spei6_1954_na_na_na_6_eobs.png": 722788,
	"./obs_spei6_1954_na_na_na_7_eobs.png": 387560,
	"./obs_spei6_1954_na_na_na_8_eobs.png": 83324,
	"./obs_spei6_1954_na_na_na_9_eobs.png": 160024,
	"./obs_spei6_1955_na_na_na_10_eobs.png": 925664,
	"./obs_spei6_1955_na_na_na_11_eobs.png": 247972,
	"./obs_spei6_1955_na_na_na_12_eobs.png": 105084,
	"./obs_spei6_1955_na_na_na_1_eobs.png": 684660,
	"./obs_spei6_1955_na_na_na_2_eobs.png": 686708,
	"./obs_spei6_1955_na_na_na_3_eobs.png": 524028,
	"./obs_spei6_1955_na_na_na_4_eobs.png": 110876,
	"./obs_spei6_1955_na_na_na_5_eobs.png": 773972,
	"./obs_spei6_1955_na_na_na_6_eobs.png": 789320,
	"./obs_spei6_1955_na_na_na_7_eobs.png": 165580,
	"./obs_spei6_1955_na_na_na_8_eobs.png": 673048,
	"./obs_spei6_1955_na_na_na_9_eobs.png": 80052,
	"./obs_spei6_1956_na_na_na_10_eobs.png": 769124,
	"./obs_spei6_1956_na_na_na_11_eobs.png": 55428,
	"./obs_spei6_1956_na_na_na_12_eobs.png": 149508,
	"./obs_spei6_1956_na_na_na_1_eobs.png": 559248,
	"./obs_spei6_1956_na_na_na_2_eobs.png": 638399,
	"./obs_spei6_1956_na_na_na_3_eobs.png": 107960,
	"./obs_spei6_1956_na_na_na_4_eobs.png": 915132,
	"./obs_spei6_1956_na_na_na_5_eobs.png": 440116,
	"./obs_spei6_1956_na_na_na_6_eobs.png": 393748,
	"./obs_spei6_1956_na_na_na_7_eobs.png": 258752,
	"./obs_spei6_1956_na_na_na_8_eobs.png": 209600,
	"./obs_spei6_1956_na_na_na_9_eobs.png": 973864,
	"./obs_spei6_1957_na_na_na_10_eobs.png": 335888,
	"./obs_spei6_1957_na_na_na_11_eobs.png": 447236,
	"./obs_spei6_1957_na_na_na_12_eobs.png": 372512,
	"./obs_spei6_1957_na_na_na_1_eobs.png": 947196,
	"./obs_spei6_1957_na_na_na_2_eobs.png": 125108,
	"./obs_spei6_1957_na_na_na_3_eobs.png": 591036,
	"./obs_spei6_1957_na_na_na_4_eobs.png": 126768,
	"./obs_spei6_1957_na_na_na_5_eobs.png": 599148,
	"./obs_spei6_1957_na_na_na_6_eobs.png": 223560,
	"./obs_spei6_1957_na_na_na_7_eobs.png": 474008,
	"./obs_spei6_1957_na_na_na_8_eobs.png": 923840,
	"./obs_spei6_1957_na_na_na_9_eobs.png": 134980,
	"./obs_spei6_1958_na_na_na_10_eobs.png": 510184,
	"./obs_spei6_1958_na_na_na_11_eobs.png": 110143,
	"./obs_spei6_1958_na_na_na_12_eobs.png": 955900,
	"./obs_spei6_1958_na_na_na_1_eobs.png": 403700,
	"./obs_spei6_1958_na_na_na_2_eobs.png": 884136,
	"./obs_spei6_1958_na_na_na_3_eobs.png": 17916,
	"./obs_spei6_1958_na_na_na_4_eobs.png": 128472,
	"./obs_spei6_1958_na_na_na_5_eobs.png": 22944,
	"./obs_spei6_1958_na_na_na_6_eobs.png": 39836,
	"./obs_spei6_1958_na_na_na_7_eobs.png": 212828,
	"./obs_spei6_1958_na_na_na_8_eobs.png": 963536,
	"./obs_spei6_1958_na_na_na_9_eobs.png": 650052,
	"./obs_spei6_1959_na_na_na_10_eobs.png": 912991,
	"./obs_spei6_1959_na_na_na_11_eobs.png": 40932,
	"./obs_spei6_1959_na_na_na_12_eobs.png": 195792,
	"./obs_spei6_1959_na_na_na_1_eobs.png": 436568,
	"./obs_spei6_1959_na_na_na_2_eobs.png": 461876,
	"./obs_spei6_1959_na_na_na_3_eobs.png": 235760,
	"./obs_spei6_1959_na_na_na_4_eobs.png": 644300,
	"./obs_spei6_1959_na_na_na_5_eobs.png": 430588,
	"./obs_spei6_1959_na_na_na_6_eobs.png": 40280,
	"./obs_spei6_1959_na_na_na_7_eobs.png": 355056,
	"./obs_spei6_1959_na_na_na_8_eobs.png": 449692,
	"./obs_spei6_1959_na_na_na_9_eobs.png": 650857,
	"./obs_spei6_1960_na_na_na_10_eobs.png": 962344,
	"./obs_spei6_1960_na_na_na_11_eobs.png": 826444,
	"./obs_spei6_1960_na_na_na_12_eobs.png": 545732,
	"./obs_spei6_1960_na_na_na_1_eobs.png": 678140,
	"./obs_spei6_1960_na_na_na_2_eobs.png": 184608,
	"./obs_spei6_1960_na_na_na_3_eobs.png": 611124,
	"./obs_spei6_1960_na_na_na_4_eobs.png": 896792,
	"./obs_spei6_1960_na_na_na_5_eobs.png": 931504,
	"./obs_spei6_1960_na_na_na_6_eobs.png": 581336,
	"./obs_spei6_1960_na_na_na_7_eobs.png": 342944,
	"./obs_spei6_1960_na_na_na_8_eobs.png": 805512,
	"./obs_spei6_1960_na_na_na_9_eobs.png": 862916,
	"./obs_spei6_1961_na_na_na_10_eobs.png": 612104,
	"./obs_spei6_1961_na_na_na_11_eobs.png": 551768,
	"./obs_spei6_1961_na_na_na_12_eobs.png": 50620,
	"./obs_spei6_1961_na_na_na_1_eobs.png": 343948,
	"./obs_spei6_1961_na_na_na_2_eobs.png": 36460,
	"./obs_spei6_1961_na_na_na_3_eobs.png": 865352,
	"./obs_spei6_1961_na_na_na_4_eobs.png": 34292,
	"./obs_spei6_1961_na_na_na_5_eobs.png": 41396,
	"./obs_spei6_1961_na_na_na_6_eobs.png": 538308,
	"./obs_spei6_1961_na_na_na_7_eobs.png": 379076,
	"./obs_spei6_1961_na_na_na_8_eobs.png": 831264,
	"./obs_spei6_1961_na_na_na_9_eobs.png": 441120,
	"./obs_spei6_1962_na_na_na_10_eobs.png": 804908,
	"./obs_spei6_1962_na_na_na_11_eobs.png": 786900,
	"./obs_spei6_1962_na_na_na_12_eobs.png": 186076,
	"./obs_spei6_1962_na_na_na_1_eobs.png": 806172,
	"./obs_spei6_1962_na_na_na_2_eobs.png": 960508,
	"./obs_spei6_1962_na_na_na_3_eobs.png": 996036,
	"./obs_spei6_1962_na_na_na_4_eobs.png": 746816,
	"./obs_spei6_1962_na_na_na_5_eobs.png": 488388,
	"./obs_spei6_1962_na_na_na_6_eobs.png": 45932,
	"./obs_spei6_1962_na_na_na_7_eobs.png": 836616,
	"./obs_spei6_1962_na_na_na_8_eobs.png": 691240,
	"./obs_spei6_1962_na_na_na_9_eobs.png": 134340,
	"./obs_spei6_1963_na_na_na_10_eobs.png": 367556,
	"./obs_spei6_1963_na_na_na_11_eobs.png": 145341,
	"./obs_spei6_1963_na_na_na_12_eobs.png": 413844,
	"./obs_spei6_1963_na_na_na_1_eobs.png": 511744,
	"./obs_spei6_1963_na_na_na_2_eobs.png": 440564,
	"./obs_spei6_1963_na_na_na_3_eobs.png": 944808,
	"./obs_spei6_1963_na_na_na_4_eobs.png": 761812,
	"./obs_spei6_1963_na_na_na_5_eobs.png": 739248,
	"./obs_spei6_1963_na_na_na_6_eobs.png": 918260,
	"./obs_spei6_1963_na_na_na_7_eobs.png": 755864,
	"./obs_spei6_1963_na_na_na_8_eobs.png": 590400,
	"./obs_spei6_1963_na_na_na_9_eobs.png": 233384,
	"./obs_spei6_1964_na_na_na_10_eobs.png": 235020,
	"./obs_spei6_1964_na_na_na_11_eobs.png": 737504,
	"./obs_spei6_1964_na_na_na_12_eobs.png": 379376,
	"./obs_spei6_1964_na_na_na_1_eobs.png": 221324,
	"./obs_spei6_1964_na_na_na_2_eobs.png": 26576,
	"./obs_spei6_1964_na_na_na_3_eobs.png": 52288,
	"./obs_spei6_1964_na_na_na_4_eobs.png": 882220,
	"./obs_spei6_1964_na_na_na_5_eobs.png": 514752,
	"./obs_spei6_1964_na_na_na_6_eobs.png": 201732,
	"./obs_spei6_1964_na_na_na_7_eobs.png": 108004,
	"./obs_spei6_1964_na_na_na_8_eobs.png": 392556,
	"./obs_spei6_1964_na_na_na_9_eobs.png": 437940,
	"./obs_spei6_1965_na_na_na_10_eobs.png": 679696,
	"./obs_spei6_1965_na_na_na_11_eobs.png": 402808,
	"./obs_spei6_1965_na_na_na_12_eobs.png": 348064,
	"./obs_spei6_1965_na_na_na_1_eobs.png": 986980,
	"./obs_spei6_1965_na_na_na_2_eobs.png": 288476,
	"./obs_spei6_1965_na_na_na_3_eobs.png": 784588,
	"./obs_spei6_1965_na_na_na_4_eobs.png": 812024,
	"./obs_spei6_1965_na_na_na_5_eobs.png": 381452,
	"./obs_spei6_1965_na_na_na_6_eobs.png": 225516,
	"./obs_spei6_1965_na_na_na_7_eobs.png": 399991,
	"./obs_spei6_1965_na_na_na_8_eobs.png": 311280,
	"./obs_spei6_1965_na_na_na_9_eobs.png": 273000,
	"./obs_spei6_1966_na_na_na_10_eobs.png": 798648,
	"./obs_spei6_1966_na_na_na_11_eobs.png": 909276,
	"./obs_spei6_1966_na_na_na_12_eobs.png": 220976,
	"./obs_spei6_1966_na_na_na_1_eobs.png": 190220,
	"./obs_spei6_1966_na_na_na_2_eobs.png": 390160,
	"./obs_spei6_1966_na_na_na_3_eobs.png": 200057,
	"./obs_spei6_1966_na_na_na_4_eobs.png": 615988,
	"./obs_spei6_1966_na_na_na_5_eobs.png": 802536,
	"./obs_spei6_1966_na_na_na_6_eobs.png": 354632,
	"./obs_spei6_1966_na_na_na_7_eobs.png": 108864,
	"./obs_spei6_1966_na_na_na_8_eobs.png": 270676,
	"./obs_spei6_1966_na_na_na_9_eobs.png": 358824,
	"./obs_spei6_1967_na_na_na_10_eobs.png": 469924,
	"./obs_spei6_1967_na_na_na_11_eobs.png": 744592,
	"./obs_spei6_1967_na_na_na_12_eobs.png": 435188,
	"./obs_spei6_1967_na_na_na_1_eobs.png": 353892,
	"./obs_spei6_1967_na_na_na_2_eobs.png": 180728,
	"./obs_spei6_1967_na_na_na_3_eobs.png": 667232,
	"./obs_spei6_1967_na_na_na_4_eobs.png": 965352,
	"./obs_spei6_1967_na_na_na_5_eobs.png": 771916,
	"./obs_spei6_1967_na_na_na_6_eobs.png": 397984,
	"./obs_spei6_1967_na_na_na_7_eobs.png": 7856,
	"./obs_spei6_1967_na_na_na_8_eobs.png": 343068,
	"./obs_spei6_1967_na_na_na_9_eobs.png": 359087,
	"./obs_spei6_1968_na_na_na_10_eobs.png": 204048,
	"./obs_spei6_1968_na_na_na_11_eobs.png": 49136,
	"./obs_spei6_1968_na_na_na_12_eobs.png": 671540,
	"./obs_spei6_1968_na_na_na_1_eobs.png": 360468,
	"./obs_spei6_1968_na_na_na_2_eobs.png": 272068,
	"./obs_spei6_1968_na_na_na_3_eobs.png": 181552,
	"./obs_spei6_1968_na_na_na_4_eobs.png": 819728,
	"./obs_spei6_1968_na_na_na_5_eobs.png": 289732,
	"./obs_spei6_1968_na_na_na_6_eobs.png": 125727,
	"./obs_spei6_1968_na_na_na_7_eobs.png": 482128,
	"./obs_spei6_1968_na_na_na_8_eobs.png": 860007,
	"./obs_spei6_1968_na_na_na_9_eobs.png": 10956,
	"./obs_spei6_1969_na_na_na_10_eobs.png": 797616,
	"./obs_spei6_1969_na_na_na_11_eobs.png": 725404,
	"./obs_spei6_1969_na_na_na_12_eobs.png": 438092,
	"./obs_spei6_1969_na_na_na_1_eobs.png": 194508,
	"./obs_spei6_1969_na_na_na_2_eobs.png": 580356,
	"./obs_spei6_1969_na_na_na_3_eobs.png": 636380,
	"./obs_spei6_1969_na_na_na_4_eobs.png": 262876,
	"./obs_spei6_1969_na_na_na_5_eobs.png": 34192,
	"./obs_spei6_1969_na_na_na_6_eobs.png": 704820,
	"./obs_spei6_1969_na_na_na_7_eobs.png": 249232,
	"./obs_spei6_1969_na_na_na_8_eobs.png": 363368,
	"./obs_spei6_1969_na_na_na_9_eobs.png": 67380,
	"./obs_spei6_1970_na_na_na_10_eobs.png": 208456,
	"./obs_spei6_1970_na_na_na_11_eobs.png": 870572,
	"./obs_spei6_1970_na_na_na_12_eobs.png": 371068,
	"./obs_spei6_1970_na_na_na_1_eobs.png": 268592,
	"./obs_spei6_1970_na_na_na_2_eobs.png": 420604,
	"./obs_spei6_1970_na_na_na_3_eobs.png": 571332,
	"./obs_spei6_1970_na_na_na_4_eobs.png": 196444,
	"./obs_spei6_1970_na_na_na_5_eobs.png": 237892,
	"./obs_spei6_1970_na_na_na_6_eobs.png": 164248,
	"./obs_spei6_1970_na_na_na_7_eobs.png": 972192,
	"./obs_spei6_1970_na_na_na_8_eobs.png": 82864,
	"./obs_spei6_1970_na_na_na_9_eobs.png": 355360,
	"./obs_spei6_1971_na_na_na_10_eobs.png": 780572,
	"./obs_spei6_1971_na_na_na_11_eobs.png": 115424,
	"./obs_spei6_1971_na_na_na_12_eobs.png": 698568,
	"./obs_spei6_1971_na_na_na_1_eobs.png": 507684,
	"./obs_spei6_1971_na_na_na_2_eobs.png": 183900,
	"./obs_spei6_1971_na_na_na_3_eobs.png": 466652,
	"./obs_spei6_1971_na_na_na_4_eobs.png": 88140,
	"./obs_spei6_1971_na_na_na_5_eobs.png": 234308,
	"./obs_spei6_1971_na_na_na_6_eobs.png": 621248,
	"./obs_spei6_1971_na_na_na_7_eobs.png": 135888,
	"./obs_spei6_1971_na_na_na_8_eobs.png": 138911,
	"./obs_spei6_1971_na_na_na_9_eobs.png": 261556,
	"./obs_spei6_1972_na_na_na_10_eobs.png": 374292,
	"./obs_spei6_1972_na_na_na_11_eobs.png": 234695,
	"./obs_spei6_1972_na_na_na_12_eobs.png": 85692,
	"./obs_spei6_1972_na_na_na_1_eobs.png": 133612,
	"./obs_spei6_1972_na_na_na_2_eobs.png": 487624,
	"./obs_spei6_1972_na_na_na_3_eobs.png": 222972,
	"./obs_spei6_1972_na_na_na_4_eobs.png": 749796,
	"./obs_spei6_1972_na_na_na_5_eobs.png": 730500,
	"./obs_spei6_1972_na_na_na_6_eobs.png": 240340,
	"./obs_spei6_1972_na_na_na_7_eobs.png": 387076,
	"./obs_spei6_1972_na_na_na_8_eobs.png": 427404,
	"./obs_spei6_1972_na_na_na_9_eobs.png": 750916,
	"./obs_spei6_1973_na_na_na_10_eobs.png": 986076,
	"./obs_spei6_1973_na_na_na_11_eobs.png": 8652,
	"./obs_spei6_1973_na_na_na_12_eobs.png": 594220,
	"./obs_spei6_1973_na_na_na_1_eobs.png": 267784,
	"./obs_spei6_1973_na_na_na_2_eobs.png": 343500,
	"./obs_spei6_1973_na_na_na_3_eobs.png": 837500,
	"./obs_spei6_1973_na_na_na_4_eobs.png": 485748,
	"./obs_spei6_1973_na_na_na_5_eobs.png": 596004,
	"./obs_spei6_1973_na_na_na_6_eobs.png": 135248,
	"./obs_spei6_1973_na_na_na_7_eobs.png": 212840,
	"./obs_spei6_1973_na_na_na_8_eobs.png": 239572,
	"./obs_spei6_1973_na_na_na_9_eobs.png": 956668,
	"./obs_spei6_1974_na_na_na_10_eobs.png": 992653,
	"./obs_spei6_1974_na_na_na_11_eobs.png": 156856,
	"./obs_spei6_1974_na_na_na_12_eobs.png": 158016,
	"./obs_spei6_1974_na_na_na_1_eobs.png": 365256,
	"./obs_spei6_1974_na_na_na_2_eobs.png": 721912,
	"./obs_spei6_1974_na_na_na_3_eobs.png": 858908,
	"./obs_spei6_1974_na_na_na_4_eobs.png": 579432,
	"./obs_spei6_1974_na_na_na_5_eobs.png": 784367,
	"./obs_spei6_1974_na_na_na_6_eobs.png": 413436,
	"./obs_spei6_1974_na_na_na_7_eobs.png": 213852,
	"./obs_spei6_1974_na_na_na_8_eobs.png": 929292,
	"./obs_spei6_1974_na_na_na_9_eobs.png": 183452,
	"./obs_spei6_1975_na_na_na_10_eobs.png": 14192,
	"./obs_spei6_1975_na_na_na_11_eobs.png": 664212,
	"./obs_spei6_1975_na_na_na_12_eobs.png": 362284,
	"./obs_spei6_1975_na_na_na_1_eobs.png": 670808,
	"./obs_spei6_1975_na_na_na_2_eobs.png": 388996,
	"./obs_spei6_1975_na_na_na_3_eobs.png": 526592,
	"./obs_spei6_1975_na_na_na_4_eobs.png": 291124,
	"./obs_spei6_1975_na_na_na_5_eobs.png": 537804,
	"./obs_spei6_1975_na_na_na_6_eobs.png": 238284,
	"./obs_spei6_1975_na_na_na_7_eobs.png": 336892,
	"./obs_spei6_1975_na_na_na_8_eobs.png": 837423,
	"./obs_spei6_1975_na_na_na_9_eobs.png": 155020,
	"./obs_spei6_1976_na_na_na_10_eobs.png": 904327,
	"./obs_spei6_1976_na_na_na_11_eobs.png": 654548,
	"./obs_spei6_1976_na_na_na_12_eobs.png": 792092,
	"./obs_spei6_1976_na_na_na_1_eobs.png": 788184,
	"./obs_spei6_1976_na_na_na_2_eobs.png": 734860,
	"./obs_spei6_1976_na_na_na_3_eobs.png": 367400,
	"./obs_spei6_1976_na_na_na_4_eobs.png": 509853,
	"./obs_spei6_1976_na_na_na_5_eobs.png": 430456,
	"./obs_spei6_1976_na_na_na_6_eobs.png": 262196,
	"./obs_spei6_1976_na_na_na_7_eobs.png": 827488,
	"./obs_spei6_1976_na_na_na_8_eobs.png": 318296,
	"./obs_spei6_1976_na_na_na_9_eobs.png": 651832,
	"./obs_spei6_1977_na_na_na_10_eobs.png": 836564,
	"./obs_spei6_1977_na_na_na_11_eobs.png": 475096,
	"./obs_spei6_1977_na_na_na_12_eobs.png": 9935,
	"./obs_spei6_1977_na_na_na_1_eobs.png": 431352,
	"./obs_spei6_1977_na_na_na_2_eobs.png": 80972,
	"./obs_spei6_1977_na_na_na_3_eobs.png": 17640,
	"./obs_spei6_1977_na_na_na_4_eobs.png": 495956,
	"./obs_spei6_1977_na_na_na_5_eobs.png": 515708,
	"./obs_spei6_1977_na_na_na_6_eobs.png": 130924,
	"./obs_spei6_1977_na_na_na_7_eobs.png": 943388,
	"./obs_spei6_1977_na_na_na_8_eobs.png": 949924,
	"./obs_spei6_1977_na_na_na_9_eobs.png": 416124,
	"./obs_spei6_1978_na_na_na_10_eobs.png": 76712,
	"./obs_spei6_1978_na_na_na_11_eobs.png": 76116,
	"./obs_spei6_1978_na_na_na_12_eobs.png": 743364,
	"./obs_spei6_1978_na_na_na_1_eobs.png": 533988,
	"./obs_spei6_1978_na_na_na_2_eobs.png": 331956,
	"./obs_spei6_1978_na_na_na_3_eobs.png": 978144,
	"./obs_spei6_1978_na_na_na_4_eobs.png": 6260,
	"./obs_spei6_1978_na_na_na_5_eobs.png": 981476,
	"./obs_spei6_1978_na_na_na_6_eobs.png": 482912,
	"./obs_spei6_1978_na_na_na_7_eobs.png": 869424,
	"./obs_spei6_1978_na_na_na_8_eobs.png": 578568,
	"./obs_spei6_1978_na_na_na_9_eobs.png": 815448,
	"./obs_spei6_1979_na_na_na_10_eobs.png": 752533,
	"./obs_spei6_1979_na_na_na_11_eobs.png": 990016,
	"./obs_spei6_1979_na_na_na_12_eobs.png": 46708,
	"./obs_spei6_1979_na_na_na_1_eobs.png": 131076,
	"./obs_spei6_1979_na_na_na_2_eobs.png": 127911,
	"./obs_spei6_1979_na_na_na_3_eobs.png": 947268,
	"./obs_spei6_1979_na_na_na_4_eobs.png": 942284,
	"./obs_spei6_1979_na_na_na_5_eobs.png": 736452,
	"./obs_spei6_1979_na_na_na_6_eobs.png": 438372,
	"./obs_spei6_1979_na_na_na_7_eobs.png": 192052,
	"./obs_spei6_1979_na_na_na_8_eobs.png": 857164,
	"./obs_spei6_1979_na_na_na_9_eobs.png": 371223,
	"./obs_spei6_1980_na_na_na_10_eobs.png": 191232,
	"./obs_spei6_1980_na_na_na_11_eobs.png": 68876,
	"./obs_spei6_1980_na_na_na_12_eobs.png": 429560,
	"./obs_spei6_1980_na_na_na_1_eobs.png": 597404,
	"./obs_spei6_1980_na_na_na_2_eobs.png": 930704,
	"./obs_spei6_1980_na_na_na_3_eobs.png": 946392,
	"./obs_spei6_1980_na_na_na_4_eobs.png": 427880,
	"./obs_spei6_1980_na_na_na_5_eobs.png": 181448,
	"./obs_spei6_1980_na_na_na_6_eobs.png": 633660,
	"./obs_spei6_1980_na_na_na_7_eobs.png": 98396,
	"./obs_spei6_1980_na_na_na_8_eobs.png": 710016,
	"./obs_spei6_1980_na_na_na_9_eobs.png": 476063,
	"./obs_spei6_1981_na_na_na_10_eobs.png": 754732,
	"./obs_spei6_1981_na_na_na_11_eobs.png": 577692,
	"./obs_spei6_1981_na_na_na_12_eobs.png": 727804,
	"./obs_spei6_1981_na_na_na_1_eobs.png": 944020,
	"./obs_spei6_1981_na_na_na_2_eobs.png": 532300,
	"./obs_spei6_1981_na_na_na_3_eobs.png": 88712,
	"./obs_spei6_1981_na_na_na_4_eobs.png": 882248,
	"./obs_spei6_1981_na_na_na_5_eobs.png": 211504,
	"./obs_spei6_1981_na_na_na_6_eobs.png": 594464,
	"./obs_spei6_1981_na_na_na_7_eobs.png": 235948,
	"./obs_spei6_1981_na_na_na_8_eobs.png": 64512,
	"./obs_spei6_1981_na_na_na_9_eobs.png": 206276,
	"./obs_spei6_1982_na_na_na_10_eobs.png": 879976,
	"./obs_spei6_1982_na_na_na_11_eobs.png": 948196,
	"./obs_spei6_1982_na_na_na_12_eobs.png": 521180,
	"./obs_spei6_1982_na_na_na_1_eobs.png": 678732,
	"./obs_spei6_1982_na_na_na_2_eobs.png": 371404,
	"./obs_spei6_1982_na_na_na_3_eobs.png": 15324,
	"./obs_spei6_1982_na_na_na_4_eobs.png": 310484,
	"./obs_spei6_1982_na_na_na_5_eobs.png": 574492,
	"./obs_spei6_1982_na_na_na_6_eobs.png": 145648,
	"./obs_spei6_1982_na_na_na_7_eobs.png": 506352,
	"./obs_spei6_1982_na_na_na_8_eobs.png": 230412,
	"./obs_spei6_1982_na_na_na_9_eobs.png": 962628,
	"./obs_spei6_1983_na_na_na_10_eobs.png": 641768,
	"./obs_spei6_1983_na_na_na_11_eobs.png": 231440,
	"./obs_spei6_1983_na_na_na_12_eobs.png": 724620,
	"./obs_spei6_1983_na_na_na_1_eobs.png": 472080,
	"./obs_spei6_1983_na_na_na_2_eobs.png": 158428,
	"./obs_spei6_1983_na_na_na_3_eobs.png": 613087,
	"./obs_spei6_1983_na_na_na_4_eobs.png": 895284,
	"./obs_spei6_1983_na_na_na_5_eobs.png": 283160,
	"./obs_spei6_1983_na_na_na_6_eobs.png": 790540,
	"./obs_spei6_1983_na_na_na_7_eobs.png": 356060,
	"./obs_spei6_1983_na_na_na_8_eobs.png": 681416,
	"./obs_spei6_1983_na_na_na_9_eobs.png": 472712,
	"./obs_spei6_1984_na_na_na_10_eobs.png": 982148,
	"./obs_spei6_1984_na_na_na_11_eobs.png": 622748,
	"./obs_spei6_1984_na_na_na_12_eobs.png": 761192,
	"./obs_spei6_1984_na_na_na_1_eobs.png": 695796,
	"./obs_spei6_1984_na_na_na_2_eobs.png": 594419,
	"./obs_spei6_1984_na_na_na_3_eobs.png": 111592,
	"./obs_spei6_1984_na_na_na_4_eobs.png": 937972,
	"./obs_spei6_1984_na_na_na_5_eobs.png": 364088,
	"./obs_spei6_1984_na_na_na_6_eobs.png": 895148,
	"./obs_spei6_1984_na_na_na_7_eobs.png": 83796,
	"./obs_spei6_1984_na_na_na_8_eobs.png": 5040,
	"./obs_spei6_1984_na_na_na_9_eobs.png": 293272,
	"./obs_spei6_1985_na_na_na_10_eobs.png": 440556,
	"./obs_spei6_1985_na_na_na_11_eobs.png": 726596,
	"./obs_spei6_1985_na_na_na_12_eobs.png": 683288,
	"./obs_spei6_1985_na_na_na_1_eobs.png": 110636,
	"./obs_spei6_1985_na_na_na_2_eobs.png": 653820,
	"./obs_spei6_1985_na_na_na_3_eobs.png": 845964,
	"./obs_spei6_1985_na_na_na_4_eobs.png": 986056,
	"./obs_spei6_1985_na_na_na_5_eobs.png": 612180,
	"./obs_spei6_1985_na_na_na_6_eobs.png": 584648,
	"./obs_spei6_1985_na_na_na_7_eobs.png": 584312,
	"./obs_spei6_1985_na_na_na_8_eobs.png": 762144,
	"./obs_spei6_1985_na_na_na_9_eobs.png": 383964,
	"./obs_spei6_1986_na_na_na_10_eobs.png": 41224,
	"./obs_spei6_1986_na_na_na_11_eobs.png": 194772,
	"./obs_spei6_1986_na_na_na_12_eobs.png": 284028,
	"./obs_spei6_1986_na_na_na_1_eobs.png": 895180,
	"./obs_spei6_1986_na_na_na_2_eobs.png": 104856,
	"./obs_spei6_1986_na_na_na_3_eobs.png": 694268,
	"./obs_spei6_1986_na_na_na_4_eobs.png": 989648,
	"./obs_spei6_1986_na_na_na_5_eobs.png": 398780,
	"./obs_spei6_1986_na_na_na_6_eobs.png": 591004,
	"./obs_spei6_1986_na_na_na_7_eobs.png": 746768,
	"./obs_spei6_1986_na_na_na_8_eobs.png": 122352,
	"./obs_spei6_1986_na_na_na_9_eobs.png": 855864,
	"./obs_spei6_1987_na_na_na_10_eobs.png": 535744,
	"./obs_spei6_1987_na_na_na_11_eobs.png": 802348,
	"./obs_spei6_1987_na_na_na_12_eobs.png": 41832,
	"./obs_spei6_1987_na_na_na_1_eobs.png": 92396,
	"./obs_spei6_1987_na_na_na_2_eobs.png": 505936,
	"./obs_spei6_1987_na_na_na_3_eobs.png": 96920,
	"./obs_spei6_1987_na_na_na_4_eobs.png": 21060,
	"./obs_spei6_1987_na_na_na_5_eobs.png": 63036,
	"./obs_spei6_1987_na_na_na_6_eobs.png": 901144,
	"./obs_spei6_1987_na_na_na_7_eobs.png": 189916,
	"./obs_spei6_1987_na_na_na_8_eobs.png": 612500,
	"./obs_spei6_1987_na_na_na_9_eobs.png": 297248,
	"./obs_spei6_1988_na_na_na_10_eobs.png": 458016,
	"./obs_spei6_1988_na_na_na_11_eobs.png": 225788,
	"./obs_spei6_1988_na_na_na_12_eobs.png": 879199,
	"./obs_spei6_1988_na_na_na_1_eobs.png": 591416,
	"./obs_spei6_1988_na_na_na_2_eobs.png": 877828,
	"./obs_spei6_1988_na_na_na_3_eobs.png": 534759,
	"./obs_spei6_1988_na_na_na_4_eobs.png": 583360,
	"./obs_spei6_1988_na_na_na_5_eobs.png": 596484,
	"./obs_spei6_1988_na_na_na_6_eobs.png": 763076,
	"./obs_spei6_1988_na_na_na_7_eobs.png": 88280,
	"./obs_spei6_1988_na_na_na_8_eobs.png": 669464,
	"./obs_spei6_1988_na_na_na_9_eobs.png": 799140,
	"./obs_spei6_1989_na_na_na_10_eobs.png": 478460,
	"./obs_spei6_1989_na_na_na_11_eobs.png": 560061,
	"./obs_spei6_1989_na_na_na_12_eobs.png": 196044,
	"./obs_spei6_1989_na_na_na_1_eobs.png": 786656,
	"./obs_spei6_1989_na_na_na_2_eobs.png": 891004,
	"./obs_spei6_1989_na_na_na_3_eobs.png": 65332,
	"./obs_spei6_1989_na_na_na_4_eobs.png": 197288,
	"./obs_spei6_1989_na_na_na_5_eobs.png": 203116,
	"./obs_spei6_1989_na_na_na_6_eobs.png": 575168,
	"./obs_spei6_1989_na_na_na_7_eobs.png": 933828,
	"./obs_spei6_1989_na_na_na_8_eobs.png": 364520,
	"./obs_spei6_1989_na_na_na_9_eobs.png": 861820,
	"./obs_spei6_1990_na_na_na_10_eobs.png": 628132,
	"./obs_spei6_1990_na_na_na_11_eobs.png": 113816,
	"./obs_spei6_1990_na_na_na_12_eobs.png": 455144,
	"./obs_spei6_1990_na_na_na_1_eobs.png": 823212,
	"./obs_spei6_1990_na_na_na_2_eobs.png": 764292,
	"./obs_spei6_1990_na_na_na_3_eobs.png": 641076,
	"./obs_spei6_1990_na_na_na_4_eobs.png": 201240,
	"./obs_spei6_1990_na_na_na_5_eobs.png": 926840,
	"./obs_spei6_1990_na_na_na_6_eobs.png": 446552,
	"./obs_spei6_1990_na_na_na_7_eobs.png": 406548,
	"./obs_spei6_1990_na_na_na_8_eobs.png": 648664,
	"./obs_spei6_1990_na_na_na_9_eobs.png": 273344,
	"./obs_spei6_1991_na_na_na_10_eobs.png": 762564,
	"./obs_spei6_1991_na_na_na_11_eobs.png": 72343,
	"./obs_spei6_1991_na_na_na_12_eobs.png": 976768,
	"./obs_spei6_1991_na_na_na_1_eobs.png": 188168,
	"./obs_spei6_1991_na_na_na_2_eobs.png": 274608,
	"./obs_spei6_1991_na_na_na_3_eobs.png": 53092,
	"./obs_spei6_1991_na_na_na_4_eobs.png": 500796,
	"./obs_spei6_1991_na_na_na_5_eobs.png": 174772,
	"./obs_spei6_1991_na_na_na_6_eobs.png": 69768,
	"./obs_spei6_1991_na_na_na_7_eobs.png": 755740,
	"./obs_spei6_1991_na_na_na_8_eobs.png": 444093,
	"./obs_spei6_1991_na_na_na_9_eobs.png": 466964,
	"./obs_spei6_1992_na_na_na_10_eobs.png": 530280,
	"./obs_spei6_1992_na_na_na_11_eobs.png": 377068,
	"./obs_spei6_1992_na_na_na_12_eobs.png": 653268,
	"./obs_spei6_1992_na_na_na_1_eobs.png": 659764,
	"./obs_spei6_1992_na_na_na_2_eobs.png": 232072,
	"./obs_spei6_1992_na_na_na_3_eobs.png": 252100,
	"./obs_spei6_1992_na_na_na_4_eobs.png": 375504,
	"./obs_spei6_1992_na_na_na_5_eobs.png": 1884,
	"./obs_spei6_1992_na_na_na_6_eobs.png": 480744,
	"./obs_spei6_1992_na_na_na_7_eobs.png": 792352,
	"./obs_spei6_1992_na_na_na_8_eobs.png": 948984,
	"./obs_spei6_1992_na_na_na_9_eobs.png": 705920,
	"./obs_spei6_1993_na_na_na_10_eobs.png": 785456,
	"./obs_spei6_1993_na_na_na_11_eobs.png": 741488,
	"./obs_spei6_1993_na_na_na_12_eobs.png": 183256,
	"./obs_spei6_1993_na_na_na_1_eobs.png": 237072,
	"./obs_spei6_1993_na_na_na_2_eobs.png": 734312,
	"./obs_spei6_1993_na_na_na_3_eobs.png": 655496,
	"./obs_spei6_1993_na_na_na_4_eobs.png": 298696,
	"./obs_spei6_1993_na_na_na_5_eobs.png": 769908,
	"./obs_spei6_1993_na_na_na_6_eobs.png": 983116,
	"./obs_spei6_1993_na_na_na_7_eobs.png": 207428,
	"./obs_spei6_1993_na_na_na_8_eobs.png": 768244,
	"./obs_spei6_1993_na_na_na_9_eobs.png": 260412,
	"./obs_spei6_1994_na_na_na_10_eobs.png": 27936,
	"./obs_spei6_1994_na_na_na_11_eobs.png": 320852,
	"./obs_spei6_1994_na_na_na_12_eobs.png": 457749,
	"./obs_spei6_1994_na_na_na_1_eobs.png": 326144,
	"./obs_spei6_1994_na_na_na_2_eobs.png": 135688,
	"./obs_spei6_1994_na_na_na_3_eobs.png": 656780,
	"./obs_spei6_1994_na_na_na_4_eobs.png": 622485,
	"./obs_spei6_1994_na_na_na_5_eobs.png": 338100,
	"./obs_spei6_1994_na_na_na_6_eobs.png": 755903,
	"./obs_spei6_1994_na_na_na_7_eobs.png": 451436,
	"./obs_spei6_1994_na_na_na_8_eobs.png": 993476,
	"./obs_spei6_1994_na_na_na_9_eobs.png": 713456,
	"./obs_spei6_1995_na_na_na_10_eobs.png": 85680,
	"./obs_spei6_1995_na_na_na_11_eobs.png": 431800,
	"./obs_spei6_1995_na_na_na_12_eobs.png": 340260,
	"./obs_spei6_1995_na_na_na_1_eobs.png": 382236,
	"./obs_spei6_1995_na_na_na_2_eobs.png": 905488,
	"./obs_spei6_1995_na_na_na_3_eobs.png": 530680,
	"./obs_spei6_1995_na_na_na_4_eobs.png": 135884,
	"./obs_spei6_1995_na_na_na_5_eobs.png": 853300,
	"./obs_spei6_1995_na_na_na_6_eobs.png": 161780,
	"./obs_spei6_1995_na_na_na_7_eobs.png": 67356,
	"./obs_spei6_1995_na_na_na_8_eobs.png": 252780,
	"./obs_spei6_1995_na_na_na_9_eobs.png": 576752,
	"./obs_spei6_1996_na_na_na_10_eobs.png": 993288,
	"./obs_spei6_1996_na_na_na_11_eobs.png": 237848,
	"./obs_spei6_1996_na_na_na_12_eobs.png": 80912,
	"./obs_spei6_1996_na_na_na_1_eobs.png": 22352,
	"./obs_spei6_1996_na_na_na_2_eobs.png": 11284,
	"./obs_spei6_1996_na_na_na_3_eobs.png": 194120,
	"./obs_spei6_1996_na_na_na_4_eobs.png": 308000,
	"./obs_spei6_1996_na_na_na_5_eobs.png": 34484,
	"./obs_spei6_1996_na_na_na_6_eobs.png": 261188,
	"./obs_spei6_1996_na_na_na_7_eobs.png": 616028,
	"./obs_spei6_1996_na_na_na_8_eobs.png": 174500,
	"./obs_spei6_1996_na_na_na_9_eobs.png": 390044,
	"./obs_spei6_1997_na_na_na_10_eobs.png": 490036,
	"./obs_spei6_1997_na_na_na_11_eobs.png": 389368,
	"./obs_spei6_1997_na_na_na_12_eobs.png": 87976,
	"./obs_spei6_1997_na_na_na_1_eobs.png": 417700,
	"./obs_spei6_1997_na_na_na_2_eobs.png": 966168,
	"./obs_spei6_1997_na_na_na_3_eobs.png": 357064,
	"./obs_spei6_1997_na_na_na_4_eobs.png": 962424,
	"./obs_spei6_1997_na_na_na_5_eobs.png": 289199,
	"./obs_spei6_1997_na_na_na_6_eobs.png": 470484,
	"./obs_spei6_1997_na_na_na_7_eobs.png": 84924,
	"./obs_spei6_1997_na_na_na_8_eobs.png": 413672,
	"./obs_spei6_1997_na_na_na_9_eobs.png": 299696,
	"./obs_spei6_1998_na_na_na_10_eobs.png": 788028,
	"./obs_spei6_1998_na_na_na_11_eobs.png": 581548,
	"./obs_spei6_1998_na_na_na_12_eobs.png": 702320,
	"./obs_spei6_1998_na_na_na_1_eobs.png": 88756,
	"./obs_spei6_1998_na_na_na_2_eobs.png": 126032,
	"./obs_spei6_1998_na_na_na_3_eobs.png": 312068,
	"./obs_spei6_1998_na_na_na_4_eobs.png": 356668,
	"./obs_spei6_1998_na_na_na_5_eobs.png": 331020,
	"./obs_spei6_1998_na_na_na_6_eobs.png": 187540,
	"./obs_spei6_1998_na_na_na_7_eobs.png": 174725,
	"./obs_spei6_1998_na_na_na_8_eobs.png": 609076,
	"./obs_spei6_1998_na_na_na_9_eobs.png": 677168,
	"./obs_spei6_1999_na_na_na_10_eobs.png": 804252,
	"./obs_spei6_1999_na_na_na_11_eobs.png": 370036,
	"./obs_spei6_1999_na_na_na_12_eobs.png": 373724,
	"./obs_spei6_1999_na_na_na_1_eobs.png": 120100,
	"./obs_spei6_1999_na_na_na_2_eobs.png": 21244,
	"./obs_spei6_1999_na_na_na_3_eobs.png": 273832,
	"./obs_spei6_1999_na_na_na_4_eobs.png": 811156,
	"./obs_spei6_1999_na_na_na_5_eobs.png": 865804,
	"./obs_spei6_1999_na_na_na_6_eobs.png": 110196,
	"./obs_spei6_1999_na_na_na_7_eobs.png": 732616,
	"./obs_spei6_1999_na_na_na_8_eobs.png": 690352,
	"./obs_spei6_1999_na_na_na_9_eobs.png": 265084,
	"./obs_spei6_2000_na_na_na_10_eobs.png": 458504,
	"./obs_spei6_2000_na_na_na_11_eobs.png": 300480,
	"./obs_spei6_2000_na_na_na_12_eobs.png": 211040,
	"./obs_spei6_2000_na_na_na_1_eobs.png": 457076,
	"./obs_spei6_2000_na_na_na_2_eobs.png": 643776,
	"./obs_spei6_2000_na_na_na_3_eobs.png": 544484,
	"./obs_spei6_2000_na_na_na_4_eobs.png": 148916,
	"./obs_spei6_2000_na_na_na_5_eobs.png": 793796,
	"./obs_spei6_2000_na_na_na_6_eobs.png": 758768,
	"./obs_spei6_2000_na_na_na_7_eobs.png": 494840,
	"./obs_spei6_2000_na_na_na_8_eobs.png": 310580,
	"./obs_spei6_2000_na_na_na_9_eobs.png": 456348,
	"./obs_spei6_2001_na_na_na_10_eobs.png": 668548,
	"./obs_spei6_2001_na_na_na_11_eobs.png": 627144,
	"./obs_spei6_2001_na_na_na_12_eobs.png": 649516,
	"./obs_spei6_2001_na_na_na_1_eobs.png": 531364,
	"./obs_spei6_2001_na_na_na_2_eobs.png": 712808,
	"./obs_spei6_2001_na_na_na_3_eobs.png": 581732,
	"./obs_spei6_2001_na_na_na_4_eobs.png": 419160,
	"./obs_spei6_2001_na_na_na_5_eobs.png": 94504,
	"./obs_spei6_2001_na_na_na_6_eobs.png": 156296,
	"./obs_spei6_2001_na_na_na_7_eobs.png": 276660,
	"./obs_spei6_2001_na_na_na_8_eobs.png": 434532,
	"./obs_spei6_2001_na_na_na_9_eobs.png": 14920,
	"./obs_spei6_2002_na_na_na_10_eobs.png": 387536,
	"./obs_spei6_2002_na_na_na_11_eobs.png": 579252,
	"./obs_spei6_2002_na_na_na_12_eobs.png": 332188,
	"./obs_spei6_2002_na_na_na_1_eobs.png": 973520,
	"./obs_spei6_2002_na_na_na_2_eobs.png": 146800,
	"./obs_spei6_2002_na_na_na_3_eobs.png": 257540,
	"./obs_spei6_2002_na_na_na_4_eobs.png": 752564,
	"./obs_spei6_2002_na_na_na_5_eobs.png": 727836,
	"./obs_spei6_2002_na_na_na_6_eobs.png": 105172,
	"./obs_spei6_2002_na_na_na_7_eobs.png": 55708,
	"./obs_spei6_2002_na_na_na_8_eobs.png": 973956,
	"./obs_spei6_2002_na_na_na_9_eobs.png": 610812,
	"./obs_spei6_2003_na_na_na_10_eobs.png": 321976,
	"./obs_spei6_2003_na_na_na_11_eobs.png": 783792,
	"./obs_spei6_2003_na_na_na_12_eobs.png": 685592,
	"./obs_spei6_2003_na_na_na_1_eobs.png": 630032,
	"./obs_spei6_2003_na_na_na_2_eobs.png": 213404,
	"./obs_spei6_2003_na_na_na_3_eobs.png": 390132,
	"./obs_spei6_2003_na_na_na_4_eobs.png": 955728,
	"./obs_spei6_2003_na_na_na_5_eobs.png": 694396,
	"./obs_spei6_2003_na_na_na_6_eobs.png": 92348,
	"./obs_spei6_2003_na_na_na_7_eobs.png": 378176,
	"./obs_spei6_2003_na_na_na_8_eobs.png": 125620,
	"./obs_spei6_2003_na_na_na_9_eobs.png": 853820,
	"./obs_spei6_2004_na_na_na_10_eobs.png": 27972,
	"./obs_spei6_2004_na_na_na_11_eobs.png": 966900,
	"./obs_spei6_2004_na_na_na_12_eobs.png": 458044,
	"./obs_spei6_2004_na_na_na_1_eobs.png": 441916,
	"./obs_spei6_2004_na_na_na_2_eobs.png": 470532,
	"./obs_spei6_2004_na_na_na_3_eobs.png": 461072,
	"./obs_spei6_2004_na_na_na_4_eobs.png": 888344,
	"./obs_spei6_2004_na_na_na_5_eobs.png": 720576,
	"./obs_spei6_2004_na_na_na_6_eobs.png": 44560,
	"./obs_spei6_2004_na_na_na_7_eobs.png": 932204,
	"./obs_spei6_2004_na_na_na_8_eobs.png": 404552,
	"./obs_spei6_2004_na_na_na_9_eobs.png": 311124,
	"./obs_spei6_2005_na_na_na_10_eobs.png": 707256,
	"./obs_spei6_2005_na_na_na_11_eobs.png": 319344,
	"./obs_spei6_2005_na_na_na_12_eobs.png": 670928,
	"./obs_spei6_2005_na_na_na_1_eobs.png": 689400,
	"./obs_spei6_2005_na_na_na_2_eobs.png": 327436,
	"./obs_spei6_2005_na_na_na_3_eobs.png": 129536,
	"./obs_spei6_2005_na_na_na_4_eobs.png": 958756,
	"./obs_spei6_2005_na_na_na_5_eobs.png": 655592,
	"./obs_spei6_2005_na_na_na_6_eobs.png": 569340,
	"./obs_spei6_2005_na_na_na_7_eobs.png": 272168,
	"./obs_spei6_2005_na_na_na_8_eobs.png": 23299,
	"./obs_spei6_2005_na_na_na_9_eobs.png": 943856,
	"./obs_spei6_2006_na_na_na_10_eobs.png": 386540,
	"./obs_spei6_2006_na_na_na_11_eobs.png": 893412,
	"./obs_spei6_2006_na_na_na_12_eobs.png": 544288,
	"./obs_spei6_2006_na_na_na_1_eobs.png": 313676,
	"./obs_spei6_2006_na_na_na_2_eobs.png": 924124,
	"./obs_spei6_2006_na_na_na_3_eobs.png": 714060,
	"./obs_spei6_2006_na_na_na_4_eobs.png": 735396,
	"./obs_spei6_2006_na_na_na_5_eobs.png": 233792,
	"./obs_spei6_2006_na_na_na_6_eobs.png": 603008,
	"./obs_spei6_2006_na_na_na_7_eobs.png": 871560,
	"./obs_spei6_2006_na_na_na_8_eobs.png": 465888,
	"./obs_spei6_2006_na_na_na_9_eobs.png": 692280,
	"./obs_spei6_2007_na_na_na_10_eobs.png": 439140,
	"./obs_spei6_2007_na_na_na_11_eobs.png": 132392,
	"./obs_spei6_2007_na_na_na_12_eobs.png": 236388,
	"./obs_spei6_2007_na_na_na_1_eobs.png": 463640,
	"./obs_spei6_2007_na_na_na_2_eobs.png": 425384,
	"./obs_spei6_2007_na_na_na_3_eobs.png": 244524,
	"./obs_spei6_2007_na_na_na_4_eobs.png": 575484,
	"./obs_spei6_2007_na_na_na_5_eobs.png": 299789,
	"./obs_spei6_2007_na_na_na_6_eobs.png": 319384,
	"./obs_spei6_2007_na_na_na_7_eobs.png": 777199,
	"./obs_spei6_2007_na_na_na_8_eobs.png": 431960,
	"./obs_spei6_2007_na_na_na_9_eobs.png": 867684,
	"./obs_spei6_2008_na_na_na_10_eobs.png": 884588,
	"./obs_spei6_2008_na_na_na_11_eobs.png": 788404,
	"./obs_spei6_2008_na_na_na_12_eobs.png": 664912,
	"./obs_spei6_2008_na_na_na_1_eobs.png": 753896,
	"./obs_spei6_2008_na_na_na_2_eobs.png": 786272,
	"./obs_spei6_2008_na_na_na_3_eobs.png": 251424,
	"./obs_spei6_2008_na_na_na_4_eobs.png": 278428,
	"./obs_spei6_2008_na_na_na_5_eobs.png": 808688,
	"./obs_spei6_2008_na_na_na_6_eobs.png": 400356,
	"./obs_spei6_2008_na_na_na_7_eobs.png": 492508,
	"./obs_spei6_2008_na_na_na_8_eobs.png": 416540,
	"./obs_spei6_2008_na_na_na_9_eobs.png": 265840,
	"./obs_spei6_2009_na_na_na_10_eobs.png": 222412,
	"./obs_spei6_2009_na_na_na_11_eobs.png": 902956,
	"./obs_spei6_2009_na_na_na_12_eobs.png": 864872,
	"./obs_spei6_2009_na_na_na_1_eobs.png": 454052,
	"./obs_spei6_2009_na_na_na_2_eobs.png": 231205,
	"./obs_spei6_2009_na_na_na_3_eobs.png": 872428,
	"./obs_spei6_2009_na_na_na_4_eobs.png": 521308,
	"./obs_spei6_2009_na_na_na_5_eobs.png": 919176,
	"./obs_spei6_2009_na_na_na_6_eobs.png": 994396,
	"./obs_spei6_2009_na_na_na_7_eobs.png": 938724,
	"./obs_spei6_2009_na_na_na_8_eobs.png": 317236,
	"./obs_spei6_2009_na_na_na_9_eobs.png": 261844,
	"./obs_spei6_2010_na_na_na_10_eobs.png": 1900,
	"./obs_spei6_2010_na_na_na_11_eobs.png": 823652,
	"./obs_spei6_2010_na_na_na_12_eobs.png": 754380,
	"./obs_spei6_2010_na_na_na_1_eobs.png": 10661,
	"./obs_spei6_2010_na_na_na_2_eobs.png": 642816,
	"./obs_spei6_2010_na_na_na_3_eobs.png": 926140,
	"./obs_spei6_2010_na_na_na_4_eobs.png": 493972,
	"./obs_spei6_2010_na_na_na_5_eobs.png": 374124,
	"./obs_spei6_2010_na_na_na_6_eobs.png": 399488,
	"./obs_spei6_2010_na_na_na_7_eobs.png": 635616,
	"./obs_spei6_2010_na_na_na_8_eobs.png": 108608,
	"./obs_spei6_2010_na_na_na_9_eobs.png": 286148,
	"./obs_spei6_2011_na_na_na_10_eobs.png": 862716,
	"./obs_spei6_2011_na_na_na_11_eobs.png": 18252,
	"./obs_spei6_2011_na_na_na_12_eobs.png": 463860,
	"./obs_spei6_2011_na_na_na_1_eobs.png": 905164,
	"./obs_spei6_2011_na_na_na_2_eobs.png": 497588,
	"./obs_spei6_2011_na_na_na_3_eobs.png": 973336,
	"./obs_spei6_2011_na_na_na_4_eobs.png": 860908,
	"./obs_spei6_2011_na_na_na_5_eobs.png": 920044,
	"./obs_spei6_2011_na_na_na_6_eobs.png": 203399,
	"./obs_spei6_2011_na_na_na_7_eobs.png": 815004,
	"./obs_spei6_2011_na_na_na_8_eobs.png": 185604,
	"./obs_spei6_2011_na_na_na_9_eobs.png": 283796,
	"./obs_spei6_2012_na_na_na_10_eobs.png": 312776,
	"./obs_spei6_2012_na_na_na_11_eobs.png": 309692,
	"./obs_spei6_2012_na_na_na_12_eobs.png": 850144,
	"./obs_spei6_2012_na_na_na_1_eobs.png": 913628,
	"./obs_spei6_2012_na_na_na_2_eobs.png": 318196,
	"./obs_spei6_2012_na_na_na_3_eobs.png": 751668,
	"./obs_spei6_2012_na_na_na_4_eobs.png": 15684,
	"./obs_spei6_2012_na_na_na_5_eobs.png": 492064,
	"./obs_spei6_2012_na_na_na_6_eobs.png": 534272,
	"./obs_spei6_2012_na_na_na_7_eobs.png": 294968,
	"./obs_spei6_2012_na_na_na_8_eobs.png": 430996,
	"./obs_spei6_2012_na_na_na_9_eobs.png": 321040,
	"./obs_spei6_2013_na_na_na_10_eobs.png": 385028,
	"./obs_spei6_2013_na_na_na_11_eobs.png": 798992,
	"./obs_spei6_2013_na_na_na_12_eobs.png": 252108,
	"./obs_spei6_2013_na_na_na_1_eobs.png": 240564,
	"./obs_spei6_2013_na_na_na_2_eobs.png": 706900,
	"./obs_spei6_2013_na_na_na_3_eobs.png": 50588,
	"./obs_spei6_2013_na_na_na_4_eobs.png": 712252,
	"./obs_spei6_2013_na_na_na_5_eobs.png": 94724,
	"./obs_spei6_2013_na_na_na_6_eobs.png": 544192,
	"./obs_spei6_2013_na_na_na_7_eobs.png": 691192,
	"./obs_spei6_2013_na_na_na_8_eobs.png": 206196,
	"./obs_spei6_2013_na_na_na_9_eobs.png": 176404,
	"./obs_spei6_2014_na_na_na_10_eobs.png": 820976,
	"./obs_spei6_2014_na_na_na_11_eobs.png": 98120,
	"./obs_spei6_2014_na_na_na_12_eobs.png": 409748,
	"./obs_spei6_2014_na_na_na_1_eobs.png": 732440,
	"./obs_spei6_2014_na_na_na_2_eobs.png": 243564,
	"./obs_spei6_2014_na_na_na_3_eobs.png": 240127,
	"./obs_spei6_2014_na_na_na_4_eobs.png": 647524,
	"./obs_spei6_2014_na_na_na_5_eobs.png": 555668,
	"./obs_spei6_2014_na_na_na_6_eobs.png": 171080,
	"./obs_spei6_2014_na_na_na_7_eobs.png": 493456,
	"./obs_spei6_2014_na_na_na_8_eobs.png": 662988,
	"./obs_spei6_2014_na_na_na_9_eobs.png": 462712,
	"./obs_spei6_2015_na_na_na_10_eobs.png": 409224,
	"./obs_spei6_2015_na_na_na_11_eobs.png": 672024,
	"./obs_spei6_2015_na_na_na_12_eobs.png": 666669,
	"./obs_spei6_2015_na_na_na_1_eobs.png": 360676,
	"./obs_spei6_2015_na_na_na_2_eobs.png": 758140,
	"./obs_spei6_2015_na_na_na_3_eobs.png": 413964,
	"./obs_spei6_2015_na_na_na_4_eobs.png": 944444,
	"./obs_spei6_2015_na_na_na_5_eobs.png": 265112,
	"./obs_spei6_2015_na_na_na_6_eobs.png": 148496,
	"./obs_spei6_2015_na_na_na_7_eobs.png": 333212,
	"./obs_spei6_2015_na_na_na_8_eobs.png": 454940,
	"./obs_spei6_2015_na_na_na_9_eobs.png": 544680,
	"./obs_spei6_2016_na_na_na_10_eobs.png": 425940,
	"./obs_spei6_2016_na_na_na_11_eobs.png": 659624,
	"./obs_spei6_2016_na_na_na_12_eobs.png": 42604,
	"./obs_spei6_2016_na_na_na_1_eobs.png": 444976,
	"./obs_spei6_2016_na_na_na_2_eobs.png": 130144,
	"./obs_spei6_2016_na_na_na_3_eobs.png": 522540,
	"./obs_spei6_2016_na_na_na_4_eobs.png": 252996,
	"./obs_spei6_2016_na_na_na_5_eobs.png": 347856,
	"./obs_spei6_2016_na_na_na_6_eobs.png": 219928,
	"./obs_spei6_2016_na_na_na_7_eobs.png": 291509,
	"./obs_spei6_2016_na_na_na_8_eobs.png": 224719,
	"./obs_spei6_2016_na_na_na_9_eobs.png": 851765,
	"./obs_spei6_2017_na_na_na_10_eobs.png": 998288,
	"./obs_spei6_2017_na_na_na_11_eobs.png": 878932,
	"./obs_spei6_2017_na_na_na_12_eobs.png": 563837,
	"./obs_spei6_2017_na_na_na_1_eobs.png": 275408,
	"./obs_spei6_2017_na_na_na_2_eobs.png": 971172,
	"./obs_spei6_2017_na_na_na_3_eobs.png": 953244,
	"./obs_spei6_2017_na_na_na_4_eobs.png": 83776,
	"./obs_spei6_2017_na_na_na_5_eobs.png": 120740,
	"./obs_spei6_2017_na_na_na_6_eobs.png": 738064,
	"./obs_spei6_2017_na_na_na_7_eobs.png": 140024,
	"./obs_spei6_2017_na_na_na_8_eobs.png": 351360,
	"./obs_spei6_2017_na_na_na_9_eobs.png": 751856,
	"./obs_spei6_2018_na_na_na_10_eobs.png": 738440,
	"./obs_spei6_2018_na_na_na_11_eobs.png": 534244,
	"./obs_spei6_2018_na_na_na_12_eobs.png": 932924,
	"./obs_spei6_2018_na_na_na_1_eobs.png": 398036,
	"./obs_spei6_2018_na_na_na_2_eobs.png": 500440,
	"./obs_spei6_2018_na_na_na_3_eobs.png": 546660,
	"./obs_spei6_2018_na_na_na_4_eobs.png": 293768,
	"./obs_spei6_2018_na_na_na_5_eobs.png": 206183,
	"./obs_spei6_2018_na_na_na_6_eobs.png": 824576,
	"./obs_spei6_2018_na_na_na_7_eobs.png": 937384,
	"./obs_spei6_2018_na_na_na_8_eobs.png": 275776,
	"./obs_spei6_2018_na_na_na_9_eobs.png": 877588,
	"./obs_spei6_2019_na_na_na_10_eobs.png": 372008,
	"./obs_spei6_2019_na_na_na_11_eobs.png": 925044,
	"./obs_spei6_2019_na_na_na_12_eobs.png": 362132,
	"./obs_spei6_2019_na_na_na_1_eobs.png": 293684,
	"./obs_spei6_2019_na_na_na_2_eobs.png": 94888,
	"./obs_spei6_2019_na_na_na_3_eobs.png": 192292,
	"./obs_spei6_2019_na_na_na_4_eobs.png": 120244,
	"./obs_spei6_2019_na_na_na_5_eobs.png": 579900,
	"./obs_spei6_2019_na_na_na_6_eobs.png": 532607,
	"./obs_spei6_2019_na_na_na_7_eobs.png": 882288,
	"./obs_spei6_2019_na_na_na_8_eobs.png": 357548,
	"./obs_spei6_2019_na_na_na_9_eobs.png": 392292,
	"./obs_spei6_2020_na_na_na_10_eobs.png": 849096,
	"./obs_spei6_2020_na_na_na_11_eobs.png": 245524,
	"./obs_spei6_2020_na_na_na_12_eobs.png": 98860,
	"./obs_spei6_2020_na_na_na_1_eobs.png": 500120,
	"./obs_spei6_2020_na_na_na_2_eobs.png": 681724,
	"./obs_spei6_2020_na_na_na_3_eobs.png": 466308,
	"./obs_spei6_2020_na_na_na_4_eobs.png": 595200,
	"./obs_spei6_2020_na_na_na_5_eobs.png": 236768,
	"./obs_spei6_2020_na_na_na_6_eobs.png": 208332,
	"./obs_spei6_2020_na_na_na_7_eobs.png": 659852,
	"./obs_spei6_2020_na_na_na_8_eobs.png": 765576,
	"./obs_spei6_2020_na_na_na_9_eobs.png": 326500,
	"./obs_spei6_2021_na_na_na_10_eobs.png": 99520,
	"./obs_spei6_2021_na_na_na_11_eobs.png": 461520,
	"./obs_spei6_2021_na_na_na_12_eobs.png": 57324,
	"./obs_spei6_2021_na_na_na_1_eobs.png": 820428,
	"./obs_spei6_2021_na_na_na_2_eobs.png": 47284,
	"./obs_spei6_2021_na_na_na_3_eobs.png": 669312,
	"./obs_spei6_2021_na_na_na_4_eobs.png": 682048,
	"./obs_spei6_2021_na_na_na_5_eobs.png": 316240,
	"./obs_spei6_2021_na_na_na_6_eobs.png": 14300,
	"./obs_spei6_2021_na_na_na_7_eobs.png": 663060,
	"./obs_spei6_2021_na_na_na_8_eobs.png": 255992,
	"./obs_spei6_2021_na_na_na_9_eobs.png": 18664,
	"./obs_spei6_2022_na_na_na_10_eobs.png": 857872,
	"./obs_spei6_2022_na_na_na_11_eobs.png": 601691,
	"./obs_spei6_2022_na_na_na_12_eobs.png": 956000,
	"./obs_spei6_2022_na_na_na_1_eobs.png": 418476,
	"./obs_spei6_2022_na_na_na_2_eobs.png": 382104,
	"./obs_spei6_2022_na_na_na_3_eobs.png": 161508,
	"./obs_spei6_2022_na_na_na_4_eobs.png": 712512,
	"./obs_spei6_2022_na_na_na_5_eobs.png": 399664,
	"./obs_spei6_2022_na_na_na_6_eobs.png": 597472,
	"./obs_spei6_2022_na_na_na_7_eobs.png": 565016,
	"./obs_spei6_2022_na_na_na_8_eobs.png": 463880,
	"./obs_spei6_2022_na_na_na_9_eobs.png": 681232,
	"./obs_spei6_2023_na_na_na_10_eobs.png": 175240,
	"./obs_spei6_2023_na_na_na_11_eobs.png": 126332,
	"./obs_spei6_2023_na_na_na_12_eobs.png": 464520,
	"./obs_spei6_2023_na_na_na_1_eobs.png": 454964,
	"./obs_spei6_2023_na_na_na_2_eobs.png": 906380,
	"./obs_spei6_2023_na_na_na_3_eobs.png": 282232,
	"./obs_spei6_2023_na_na_na_4_eobs.png": 654200,
	"./obs_spei6_2023_na_na_na_5_eobs.png": 730388,
	"./obs_spei6_2023_na_na_na_6_eobs.png": 235204,
	"./obs_spei6_2023_na_na_na_7_eobs.png": 7188,
	"./obs_spei6_2023_na_na_na_8_eobs.png": 785952,
	"./obs_spei6_2023_na_na_na_9_eobs.png": 33572,
	"./spei12_10_1950.png": 934932,
	"./spei12_10_1951.png": 292040,
	"./spei12_10_1952.png": 539064,
	"./spei12_10_1953.png": 987047,
	"./spei12_10_1954.png": 4912,
	"./spei12_10_1955.png": 957940,
	"./spei12_10_1956.png": 858724,
	"./spei12_10_1957.png": 537112,
	"./spei12_10_1958.png": 166316,
	"./spei12_10_1959.png": 622324,
	"./spei12_10_1960.png": 815512,
	"./spei12_10_1961.png": 537623,
	"./spei12_10_1962.png": 113940,
	"./spei12_10_1963.png": 284440,
	"./spei12_10_1964.png": 134656,
	"./spei12_10_1965.png": 492964,
	"./spei12_10_1966.png": 677140,
	"./spei12_10_1967.png": 60424,
	"./spei12_10_1968.png": 791472,
	"./spei12_10_1969.png": 765136,
	"./spei12_10_1970.png": 657968,
	"./spei12_10_1971.png": 251028,
	"./spei12_10_1972.png": 229572,
	"./spei12_10_1973.png": 197764,
	"./spei12_10_1974.png": 624512,
	"./spei12_10_1975.png": 288200,
	"./spei12_10_1976.png": 437764,
	"./spei12_10_1977.png": 880508,
	"./spei12_10_1978.png": 189928,
	"./spei12_10_1979.png": 743680,
	"./spei12_10_1980.png": 33180,
	"./spei12_10_1981.png": 562084,
	"./spei12_10_1982.png": 994688,
	"./spei12_10_1983.png": 531120,
	"./spei12_10_1984.png": 485028,
	"./spei12_10_1985.png": 4604,
	"./spei12_10_1986.png": 824320,
	"./spei12_10_1987.png": 725088,
	"./spei12_10_1988.png": 57220,
	"./spei12_10_1989.png": 779332,
	"./spei12_10_1990.png": 209256,
	"./spei12_10_1991.png": 985388,
	"./spei12_10_1992.png": 801564,
	"./spei12_10_1993.png": 705872,
	"./spei12_10_1994.png": 740000,
	"./spei12_10_1995.png": 389677,
	"./spei12_10_1996.png": 105008,
	"./spei12_10_1997.png": 843212,
	"./spei12_10_1998.png": 677296,
	"./spei12_10_1999.png": 47975,
	"./spei12_10_2000.png": 21124,
	"./spei12_10_2001.png": 766936,
	"./spei12_10_2002.png": 730344,
	"./spei12_10_2003.png": 394520,
	"./spei12_10_2004.png": 210944,
	"./spei12_10_2005.png": 450020,
	"./spei12_10_2006.png": 329748,
	"./spei12_10_2007.png": 170504,
	"./spei12_10_2008.png": 867759,
	"./spei12_10_2009.png": 772068,
	"./spei12_10_2010.png": 615024,
	"./spei12_10_2011.png": 268436,
	"./spei12_10_2012.png": 916356,
	"./spei12_10_2013.png": 638468,
	"./spei12_10_2014.png": 853824,
	"./spei12_10_2015.png": 271432,
	"./spei12_10_2016.png": 514052,
	"./spei12_10_2017.png": 380092,
	"./spei12_10_2018.png": 876712,
	"./spei12_10_2019.png": 618668,
	"./spei12_10_2020.png": 142832,
	"./spei12_10_2021.png": 710376,
	"./spei12_10_2022.png": 669492,
	"./spei12_10_2023.png": 351460,
	"./spei12_11_1950.png": 86980,
	"./spei12_11_1951.png": 94948,
	"./spei12_11_1952.png": 245288,
	"./spei12_11_1953.png": 729728,
	"./spei12_11_1954.png": 291672,
	"./spei12_11_1955.png": 648368,
	"./spei12_11_1956.png": 8284,
	"./spei12_11_1957.png": 96672,
	"./spei12_11_1958.png": 984848,
	"./spei12_11_1959.png": 305424,
	"./spei12_11_1960.png": 263620,
	"./spei12_11_1961.png": 255984,
	"./spei12_11_1962.png": 387912,
	"./spei12_11_1963.png": 667175,
	"./spei12_11_1964.png": 45388,
	"./spei12_11_1965.png": 683280,
	"./spei12_11_1966.png": 918132,
	"./spei12_11_1967.png": 502432,
	"./spei12_11_1968.png": 547612,
	"./spei12_11_1969.png": 62549,
	"./spei12_11_1970.png": 859712,
	"./spei12_11_1971.png": 910372,
	"./spei12_11_1972.png": 118788,
	"./spei12_11_1973.png": 364916,
	"./spei12_11_1974.png": 644768,
	"./spei12_11_1975.png": 187724,
	"./spei12_11_1976.png": 835644,
	"./spei12_11_1977.png": 834696,
	"./spei12_11_1978.png": 597607,
	"./spei12_11_1979.png": 850816,
	"./spei12_11_1980.png": 145080,
	"./spei12_11_1981.png": 101080,
	"./spei12_11_1982.png": 31688,
	"./spei12_11_1983.png": 503884,
	"./spei12_11_1984.png": 174072,
	"./spei12_11_1985.png": 848860,
	"./spei12_11_1986.png": 114832,
	"./spei12_11_1987.png": 770412,
	"./spei12_11_1988.png": 740188,
	"./spei12_11_1989.png": 339824,
	"./spei12_11_1990.png": 780324,
	"./spei12_11_1991.png": 739776,
	"./spei12_11_1992.png": 140732,
	"./spei12_11_1993.png": 645172,
	"./spei12_11_1994.png": 263547,
	"./spei12_11_1995.png": 838796,
	"./spei12_11_1996.png": 704648,
	"./spei12_11_1997.png": 269180,
	"./spei12_11_1998.png": 755436,
	"./spei12_11_1999.png": 417319,
	"./spei12_11_2000.png": 606104,
	"./spei12_11_2001.png": 984348,
	"./spei12_11_2002.png": 100336,
	"./spei12_11_2003.png": 381068,
	"./spei12_11_2004.png": 300996,
	"./spei12_11_2005.png": 86584,
	"./spei12_11_2006.png": 529684,
	"./spei12_11_2007.png": 666700,
	"./spei12_11_2008.png": 239671,
	"./spei12_11_2009.png": 19040,
	"./spei12_11_2010.png": 723892,
	"./spei12_11_2011.png": 255573,
	"./spei12_11_2012.png": 154840,
	"./spei12_11_2013.png": 676604,
	"./spei12_11_2014.png": 10184,
	"./spei12_11_2015.png": 786828,
	"./spei12_11_2016.png": 189024,
	"./spei12_11_2017.png": 897296,
	"./spei12_11_2018.png": 812672,
	"./spei12_11_2019.png": 656236,
	"./spei12_11_2020.png": 458421,
	"./spei12_11_2021.png": 224588,
	"./spei12_11_2022.png": 419812,
	"./spei12_11_2023.png": 405848,
	"./spei12_12_1950.png": 193596,
	"./spei12_12_1951.png": 343344,
	"./spei12_12_1952.png": 551228,
	"./spei12_12_1953.png": 470344,
	"./spei12_12_1954.png": 628360,
	"./spei12_12_1955.png": 158148,
	"./spei12_12_1956.png": 443676,
	"./spei12_12_1957.png": 790668,
	"./spei12_12_1958.png": 424637,
	"./spei12_12_1959.png": 99716,
	"./spei12_12_1960.png": 697865,
	"./spei12_12_1961.png": 569532,
	"./spei12_12_1962.png": 598076,
	"./spei12_12_1963.png": 400415,
	"./spei12_12_1964.png": 678476,
	"./spei12_12_1965.png": 78455,
	"./spei12_12_1966.png": 366172,
	"./spei12_12_1967.png": 811752,
	"./spei12_12_1968.png": 649116,
	"./spei12_12_1969.png": 148920,
	"./spei12_12_1970.png": 970040,
	"./spei12_12_1971.png": 666940,
	"./spei12_12_1972.png": 848652,
	"./spei12_12_1973.png": 646052,
	"./spei12_12_1974.png": 97468,
	"./spei12_12_1975.png": 240140,
	"./spei12_12_1976.png": 943528,
	"./spei12_12_1977.png": 102028,
	"./spei12_12_1978.png": 414832,
	"./spei12_12_1979.png": 133004,
	"./spei12_12_1980.png": 180392,
	"./spei12_12_1981.png": 195396,
	"./spei12_12_1982.png": 835420,
	"./spei12_12_1983.png": 583412,
	"./spei12_12_1984.png": 252408,
	"./spei12_12_1985.png": 393884,
	"./spei12_12_1986.png": 12236,
	"./spei12_12_1987.png": 115900,
	"./spei12_12_1988.png": 890436,
	"./spei12_12_1989.png": 767188,
	"./spei12_12_1990.png": 956068,
	"./spei12_12_1991.png": 200716,
	"./spei12_12_1992.png": 142004,
	"./spei12_12_1993.png": 282880,
	"./spei12_12_1994.png": 869655,
	"./spei12_12_1995.png": 617660,
	"./spei12_12_1996.png": 395200,
	"./spei12_12_1997.png": 108252,
	"./spei12_12_1998.png": 796096,
	"./spei12_12_1999.png": 588812,
	"./spei12_12_2000.png": 422452,
	"./spei12_12_2001.png": 942788,
	"./spei12_12_2002.png": 725312,
	"./spei12_12_2003.png": 894196,
	"./spei12_12_2004.png": 985648,
	"./spei12_12_2005.png": 371620,
	"./spei12_12_2006.png": 371344,
	"./spei12_12_2007.png": 966444,
	"./spei12_12_2008.png": 64824,
	"./spei12_12_2009.png": 495452,
	"./spei12_12_2010.png": 153548,
	"./spei12_12_2011.png": 557124,
	"./spei12_12_2012.png": 342712,
	"./spei12_12_2013.png": 563431,
	"./spei12_12_2014.png": 816640,
	"./spei12_12_2015.png": 437823,
	"./spei12_12_2016.png": 643632,
	"./spei12_12_2017.png": 128532,
	"./spei12_12_2018.png": 913736,
	"./spei12_12_2019.png": 720416,
	"./spei12_12_2020.png": 669776,
	"./spei12_12_2021.png": 980020,
	"./spei12_12_2022.png": 289320,
	"./spei12_12_2023.png": 633348,
	"./spei12_1_1950.png": 988756,
	"./spei12_1_1951.png": 94581,
	"./spei12_1_1952.png": 836504,
	"./spei12_1_1953.png": 172908,
	"./spei12_1_1954.png": 744744,
	"./spei12_1_1955.png": 142620,
	"./spei12_1_1956.png": 23200,
	"./spei12_1_1957.png": 185228,
	"./spei12_1_1958.png": 41996,
	"./spei12_1_1959.png": 937356,
	"./spei12_1_1960.png": 939084,
	"./spei12_1_1961.png": 226424,
	"./spei12_1_1962.png": 359412,
	"./spei12_1_1963.png": 234340,
	"./spei12_1_1964.png": 307108,
	"./spei12_1_1965.png": 655508,
	"./spei12_1_1966.png": 507868,
	"./spei12_1_1967.png": 698876,
	"./spei12_1_1968.png": 598200,
	"./spei12_1_1969.png": 874300,
	"./spei12_1_1970.png": 876512,
	"./spei12_1_1971.png": 135952,
	"./spei12_1_1972.png": 98132,
	"./spei12_1_1973.png": 192436,
	"./spei12_1_1974.png": 525692,
	"./spei12_1_1975.png": 165672,
	"./spei12_1_1976.png": 282423,
	"./spei12_1_1977.png": 244244,
	"./spei12_1_1978.png": 99755,
	"./spei12_1_1979.png": 378012,
	"./spei12_1_1980.png": 839908,
	"./spei12_1_1981.png": 877853,
	"./spei12_1_1982.png": 486176,
	"./spei12_1_1983.png": 286356,
	"./spei12_1_1984.png": 476155,
	"./spei12_1_1985.png": 679364,
	"./spei12_1_1986.png": 92296,
	"./spei12_1_1987.png": 845000,
	"./spei12_1_1988.png": 736031,
	"./spei12_1_1989.png": 468132,
	"./spei12_1_1990.png": 341464,
	"./spei12_1_1991.png": 660148,
	"./spei12_1_1992.png": 278116,
	"./spei12_1_1993.png": 700280,
	"./spei12_1_1994.png": 427048,
	"./spei12_1_1995.png": 458604,
	"./spei12_1_1996.png": 31248,
	"./spei12_1_1997.png": 940804,
	"./spei12_1_1998.png": 118220,
	"./spei12_1_1999.png": 392836,
	"./spei12_1_2000.png": 812312,
	"./spei12_1_2001.png": 249436,
	"./spei12_1_2002.png": 3060,
	"./spei12_1_2003.png": 103628,
	"./spei12_1_2004.png": 657496,
	"./spei12_1_2005.png": 612940,
	"./spei12_1_2006.png": 414428,
	"./spei12_1_2007.png": 919744,
	"./spei12_1_2008.png": 318684,
	"./spei12_1_2009.png": 872508,
	"./spei12_1_2010.png": 506804,
	"./spei12_1_2011.png": 816104,
	"./spei12_1_2012.png": 994188,
	"./spei12_1_2013.png": 22704,
	"./spei12_1_2014.png": 15476,
	"./spei12_1_2015.png": 42912,
	"./spei12_1_2016.png": 528184,
	"./spei12_1_2017.png": 315408,
	"./spei12_1_2018.png": 810220,
	"./spei12_1_2019.png": 531820,
	"./spei12_1_2020.png": 767868,
	"./spei12_1_2021.png": 360416,
	"./spei12_1_2022.png": 168548,
	"./spei12_1_2023.png": 612056,
	"./spei12_2_1950.png": 561008,
	"./spei12_2_1951.png": 459176,
	"./spei12_2_1952.png": 831112,
	"./spei12_2_1953.png": 547256,
	"./spei12_2_1954.png": 416444,
	"./spei12_2_1955.png": 818640,
	"./spei12_2_1956.png": 864748,
	"./spei12_2_1957.png": 510711,
	"./spei12_2_1958.png": 176600,
	"./spei12_2_1959.png": 97372,
	"./spei12_2_1960.png": 720076,
	"./spei12_2_1961.png": 496325,
	"./spei12_2_1962.png": 299768,
	"./spei12_2_1963.png": 493864,
	"./spei12_2_1964.png": 658156,
	"./spei12_2_1965.png": 896108,
	"./spei12_2_1966.png": 858876,
	"./spei12_2_1967.png": 390612,
	"./spei12_2_1968.png": 157384,
	"./spei12_2_1969.png": 629580,
	"./spei12_2_1970.png": 639152,
	"./spei12_2_1971.png": 482716,
	"./spei12_2_1972.png": 571104,
	"./spei12_2_1973.png": 339032,
	"./spei12_2_1974.png": 779856,
	"./spei12_2_1975.png": 223669,
	"./spei12_2_1976.png": 432552,
	"./spei12_2_1977.png": 988484,
	"./spei12_2_1978.png": 532836,
	"./spei12_2_1979.png": 198725,
	"./spei12_2_1980.png": 141607,
	"./spei12_2_1981.png": 852288,
	"./spei12_2_1982.png": 695852,
	"./spei12_2_1983.png": 552432,
	"./spei12_2_1984.png": 967976,
	"./spei12_2_1985.png": 957128,
	"./spei12_2_1986.png": 538680,
	"./spei12_2_1987.png": 77244,
	"./spei12_2_1988.png": 916652,
	"./spei12_2_1989.png": 784996,
	"./spei12_2_1990.png": 904720,
	"./spei12_2_1991.png": 215360,
	"./spei12_2_1992.png": 773340,
	"./spei12_2_1993.png": 382904,
	"./spei12_2_1994.png": 243936,
	"./spei12_2_1995.png": 208212,
	"./spei12_2_1996.png": 879788,
	"./spei12_2_1997.png": 931056,
	"./spei12_2_1998.png": 54440,
	"./spei12_2_1999.png": 856780,
	"./spei12_2_2000.png": 786268,
	"./spei12_2_2001.png": 74852,
	"./spei12_2_2002.png": 500028,
	"./spei12_2_2003.png": 697492,
	"./spei12_2_2004.png": 543740,
	"./spei12_2_2005.png": 782397,
	"./spei12_2_2006.png": 3628,
	"./spei12_2_2007.png": 350920,
	"./spei12_2_2008.png": 851960,
	"./spei12_2_2009.png": 731936,
	"./spei12_2_2010.png": 835112,
	"./spei12_2_2011.png": 272584,
	"./spei12_2_2012.png": 875204,
	"./spei12_2_2013.png": 710644,
	"./spei12_2_2014.png": 731860,
	"./spei12_2_2015.png": 22948,
	"./spei12_2_2016.png": 96556,
	"./spei12_2_2017.png": 515232,
	"./spei12_2_2018.png": 458156,
	"./spei12_2_2019.png": 783712,
	"./spei12_2_2020.png": 162152,
	"./spei12_2_2021.png": 991160,
	"./spei12_2_2022.png": 637832,
	"./spei12_2_2023.png": 448752,
	"./spei12_3_1950.png": 15348,
	"./spei12_3_1951.png": 324648,
	"./spei12_3_1952.png": 880580,
	"./spei12_3_1953.png": 14896,
	"./spei12_3_1954.png": 301640,
	"./spei12_3_1955.png": 551456,
	"./spei12_3_1956.png": 176032,
	"./spei12_3_1957.png": 894332,
	"./spei12_3_1958.png": 802412,
	"./spei12_3_1959.png": 40364,
	"./spei12_3_1960.png": 16700,
	"./spei12_3_1961.png": 251632,
	"./spei12_3_1962.png": 421396,
	"./spei12_3_1963.png": 69316,
	"./spei12_3_1964.png": 569048,
	"./spei12_3_1965.png": 74984,
	"./spei12_3_1966.png": 315864,
	"./spei12_3_1967.png": 166080,
	"./spei12_3_1968.png": 524388,
	"./spei12_3_1969.png": 348544,
	"./spei12_3_1970.png": 74864,
	"./spei12_3_1971.png": 712788,
	"./spei12_3_1972.png": 601524,
	"./spei12_3_1973.png": 283493,
	"./spei12_3_1974.png": 377295,
	"./spei12_3_1975.png": 56477,
	"./spei12_3_1976.png": 69180,
	"./spei12_3_1977.png": 846640,
	"./spei12_3_1978.png": 217320,
	"./spei12_3_1979.png": 280456,
	"./spei12_3_1980.png": 344276,
	"./spei12_3_1981.png": 111048,
	"./spei12_3_1982.png": 692600,
	"./spei12_3_1983.png": 231164,
	"./spei12_3_1984.png": 517908,
	"./spei12_3_1985.png": 6208,
	"./spei12_3_1986.png": 849772,
	"./spei12_3_1987.png": 328892,
	"./spei12_3_1988.png": 236972,
	"./spei12_3_1989.png": 673740,
	"./spei12_3_1990.png": 902944,
	"./spei12_3_1991.png": 993668,
	"./spei12_3_1992.png": 526840,
	"./spei12_3_1993.png": 51560,
	"./spei12_3_1994.png": 52352,
	"./spei12_3_1995.png": 874368,
	"./spei12_3_1996.png": 879344,
	"./spei12_3_1997.png": 464660,
	"./spei12_3_1998.png": 35972,
	"./spei12_3_1999.png": 758084,
	"./spei12_3_2000.png": 439224,
	"./spei12_3_2001.png": 957124,
	"./spei12_3_2002.png": 380949,
	"./spei12_3_2003.png": 363132,
	"./spei12_3_2004.png": 480612,
	"./spei12_3_2005.png": 413100,
	"./spei12_3_2006.png": 588784,
	"./spei12_3_2007.png": 720880,
	"./spei12_3_2008.png": 574608,
	"./spei12_3_2009.png": 743280,
	"./spei12_3_2010.png": 833108,
	"./spei12_3_2011.png": 90020,
	"./spei12_3_2012.png": 398720,
	"./spei12_3_2013.png": 934573,
	"./spei12_3_2014.png": 197627,
	"./spei12_3_2015.png": 130996,
	"./spei12_3_2016.png": 277784,
	"./spei12_3_2017.png": 886444,
	"./spei12_3_2018.png": 163168,
	"./spei12_3_2019.png": 249556,
	"./spei12_3_2020.png": 455268,
	"./spei12_3_2021.png": 794268,
	"./spei12_3_2022.png": 158256,
	"./spei12_3_2023.png": 628812,
	"./spei12_4_1950.png": 642632,
	"./spei12_4_1951.png": 144864,
	"./spei12_4_1952.png": 465439,
	"./spei12_4_1953.png": 265360,
	"./spei12_4_1954.png": 334792,
	"./spei12_4_1955.png": 320084,
	"./spei12_4_1956.png": 683672,
	"./spei12_4_1957.png": 578268,
	"./spei12_4_1958.png": 719008,
	"./spei12_4_1959.png": 981572,
	"./spei12_4_1960.png": 3044,
	"./spei12_4_1961.png": 801852,
	"./spei12_4_1962.png": 981668,
	"./spei12_4_1963.png": 250156,
	"./spei12_4_1964.png": 754148,
	"./spei12_4_1965.png": 683972,
	"./spei12_4_1966.png": 87752,
	"./spei12_4_1967.png": 642016,
	"./spei12_4_1968.png": 517520,
	"./spei12_4_1969.png": 708916,
	"./spei12_4_1970.png": 705640,
	"./spei12_4_1971.png": 542792,
	"./spei12_4_1972.png": 972344,
	"./spei12_4_1973.png": 592528,
	"./spei12_4_1974.png": 362920,
	"./spei12_4_1975.png": 821183,
	"./spei12_4_1976.png": 159552,
	"./spei12_4_1977.png": 260060,
	"./spei12_4_1978.png": 116556,
	"./spei12_4_1979.png": 518752,
	"./spei12_4_1980.png": 591452,
	"./spei12_4_1981.png": 505863,
	"./spei12_4_1982.png": 945152,
	"./spei12_4_1983.png": 955160,
	"./spei12_4_1984.png": 849756,
	"./spei12_4_1985.png": 965744,
	"./spei12_4_1986.png": 826324,
	"./spei12_4_1987.png": 266820,
	"./spei12_4_1988.png": 799992,
	"./spei12_4_1989.png": 805404,
	"./spei12_4_1990.png": 913504,
	"./spei12_4_1991.png": 538080,
	"./spei12_4_1992.png": 997124,
	"./spei12_4_1993.png": 366920,
	"./spei12_4_1994.png": 399680,
	"./spei12_4_1995.png": 319608,
	"./spei12_4_1996.png": 81904,
	"./spei12_4_1997.png": 875592,
	"./spei12_4_1998.png": 947348,
	"./spei12_4_1999.png": 684084,
	"./spei12_4_2000.png": 491672,
	"./spei12_4_2001.png": 766240,
	"./spei12_4_2002.png": 941924,
	"./spei12_4_2003.png": 652988,
	"./spei12_4_2004.png": 40708,
	"./spei12_4_2005.png": 696888,
	"./spei12_4_2006.png": 91144,
	"./spei12_4_2007.png": 188452,
	"./spei12_4_2008.png": 511504,
	"./spei12_4_2009.png": 391768,
	"./spei12_4_2010.png": 760492,
	"./spei12_4_2011.png": 274624,
	"./spei12_4_2012.png": 312444,
	"./spei12_4_2013.png": 914568,
	"./spei12_4_2014.png": 577356,
	"./spei12_4_2015.png": 904888,
	"./spei12_4_2016.png": 119784,
	"./spei12_4_2017.png": 444788,
	"./spei12_4_2018.png": 151416,
	"./spei12_4_2019.png": 506872,
	"./spei12_4_2020.png": 42160,
	"./spei12_4_2021.png": 163620,
	"./spei12_4_2022.png": 386368,
	"./spei12_4_2023.png": 234892,
	"./spei12_5_1950.png": 475824,
	"./spei12_5_1951.png": 557428,
	"./spei12_5_1952.png": 721532,
	"./spei12_5_1953.png": 620668,
	"./spei12_5_1954.png": 982068,
	"./spei12_5_1955.png": 358488,
	"./spei12_5_1956.png": 56724,
	"./spei12_5_1957.png": 171908,
	"./spei12_5_1958.png": 253864,
	"./spei12_5_1959.png": 900343,
	"./spei12_5_1960.png": 599852,
	"./spei12_5_1961.png": 291324,
	"./spei12_5_1962.png": 883872,
	"./spei12_5_1963.png": 904892,
	"./spei12_5_1964.png": 527604,
	"./spei12_5_1965.png": 297900,
	"./spei12_5_1966.png": 791688,
	"./spei12_5_1967.png": 826760,
	"./spei12_5_1968.png": 133728,
	"./spei12_5_1969.png": 713828,
	"./spei12_5_1970.png": 47124,
	"./spei12_5_1971.png": 217984,
	"./spei12_5_1972.png": 982972,
	"./spei12_5_1973.png": 75692,
	"./spei12_5_1974.png": 222808,
	"./spei12_5_1975.png": 795036,
	"./spei12_5_1976.png": 675812,
	"./spei12_5_1977.png": 168356,
	"./spei12_5_1978.png": 491764,
	"./spei12_5_1979.png": 136724,
	"./spei12_5_1980.png": 117444,
	"./spei12_5_1981.png": 113428,
	"./spei12_5_1982.png": 259760,
	"./spei12_5_1983.png": 141020,
	"./spei12_5_1984.png": 644932,
	"./spei12_5_1985.png": 48695,
	"./spei12_5_1986.png": 695368,
	"./spei12_5_1987.png": 506288,
	"./spei12_5_1988.png": 379664,
	"./spei12_5_1989.png": 117956,
	"./spei12_5_1990.png": 879384,
	"./spei12_5_1991.png": 103344,
	"./spei12_5_1992.png": 557612,
	"./spei12_5_1993.png": 259228,
	"./spei12_5_1994.png": 533403,
	"./spei12_5_1995.png": 165112,
	"./spei12_5_1996.png": 276392,
	"./spei12_5_1997.png": 936424,
	"./spei12_5_1998.png": 818804,
	"./spei12_5_1999.png": 317188,
	"./spei12_5_2000.png": 123348,
	"./spei12_5_2001.png": 637824,
	"./spei12_5_2002.png": 516356,
	"./spei12_5_2003.png": 87356,
	"./spei12_5_2004.png": 949716,
	"./spei12_5_2005.png": 835336,
	"./spei12_5_2006.png": 737708,
	"./spei12_5_2007.png": 836604,
	"./spei12_5_2008.png": 768684,
	"./spei12_5_2009.png": 474999,
	"./spei12_5_2010.png": 359632,
	"./spei12_5_2011.png": 881664,
	"./spei12_5_2012.png": 608284,
	"./spei12_5_2013.png": 261112,
	"./spei12_5_2014.png": 532780,
	"./spei12_5_2015.png": 417044,
	"./spei12_5_2016.png": 490888,
	"./spei12_5_2017.png": 455324,
	"./spei12_5_2018.png": 40892,
	"./spei12_5_2019.png": 393760,
	"./spei12_5_2020.png": 959392,
	"./spei12_5_2021.png": 516396,
	"./spei12_5_2022.png": 260460,
	"./spei12_5_2023.png": 675116,
	"./spei12_6_1950.png": 460652,
	"./spei12_6_1951.png": 318968,
	"./spei12_6_1952.png": 497348,
	"./spei12_6_1953.png": 721928,
	"./spei12_6_1954.png": 194124,
	"./spei12_6_1955.png": 444319,
	"./spei12_6_1956.png": 298845,
	"./spei12_6_1957.png": 213256,
	"./spei12_6_1958.png": 228584,
	"./spei12_6_1959.png": 229375,
	"./spei12_6_1960.png": 263552,
	"./spei12_6_1961.png": 754984,
	"./spei12_6_1962.png": 107852,
	"./spei12_6_1963.png": 689404,
	"./spei12_6_1964.png": 54588,
	"./spei12_6_1965.png": 94100,
	"./spei12_6_1966.png": 213308,
	"./spei12_6_1967.png": 48197,
	"./spei12_6_1968.png": 594308,
	"./spei12_6_1969.png": 649760,
	"./spei12_6_1970.png": 302300,
	"./spei12_6_1971.png": 298628,
	"./spei12_6_1972.png": 262036,
	"./spei12_6_1973.png": 652812,
	"./spei12_6_1974.png": 520256,
	"./spei12_6_1975.png": 160240,
	"./spei12_6_1976.png": 639060,
	"./spei12_6_1977.png": 933864,
	"./spei12_6_1978.png": 399452,
	"./spei12_6_1979.png": 218992,
	"./spei12_6_1980.png": 228472,
	"./spei12_6_1981.png": 767036,
	"./spei12_6_1982.png": 169232,
	"./spei12_6_1983.png": 672812,
	"./spei12_6_1984.png": 895480,
	"./spei12_6_1985.png": 103896,
	"./spei12_6_1986.png": 833672,
	"./spei12_6_1987.png": 852256,
	"./spei12_6_1988.png": 434236,
	"./spei12_6_1989.png": 552136,
	"./spei12_6_1990.png": 632684,
	"./spei12_6_1991.png": 854861,
	"./spei12_6_1992.png": 459676,
	"./spei12_6_1993.png": 600232,
	"./spei12_6_1994.png": 260896,
	"./spei12_6_1995.png": 129240,
	"./spei12_6_1996.png": 107172,
	"./spei12_6_1997.png": 631892,
	"./spei12_6_1998.png": 299976,
	"./spei12_6_1999.png": 579240,
	"./spei12_6_2000.png": 885692,
	"./spei12_6_2001.png": 287888,
	"./spei12_6_2002.png": 337140,
	"./spei12_6_2003.png": 354340,
	"./spei12_6_2004.png": 30256,
	"./spei12_6_2005.png": 998804,
	"./spei12_6_2006.png": 734796,
	"./spei12_6_2007.png": 16504,
	"./spei12_6_2008.png": 260580,
	"./spei12_6_2009.png": 172020,
	"./spei12_6_2010.png": 155976,
	"./spei12_6_2011.png": 232720,
	"./spei12_6_2012.png": 64156,
	"./spei12_6_2013.png": 722064,
	"./spei12_6_2014.png": 341624,
	"./spei12_6_2015.png": 653020,
	"./spei12_6_2016.png": 647212,
	"./spei12_6_2017.png": 942348,
	"./spei12_6_2018.png": 257148,
	"./spei12_6_2019.png": 952868,
	"./spei12_6_2020.png": 317453,
	"./spei12_6_2021.png": 428040,
	"./spei12_6_2022.png": 866216,
	"./spei12_6_2023.png": 637116,
	"./spei12_7_1950.png": 182628,
	"./spei12_7_1951.png": 671564,
	"./spei12_7_1952.png": 992508,
	"./spei12_7_1953.png": 954420,
	"./spei12_7_1954.png": 41256,
	"./spei12_7_1955.png": 843596,
	"./spei12_7_1956.png": 482356,
	"./spei12_7_1957.png": 790332,
	"./spei12_7_1958.png": 230752,
	"./spei12_7_1959.png": 195028,
	"./spei12_7_1960.png": 996856,
	"./spei12_7_1961.png": 632708,
	"./spei12_7_1962.png": 552840,
	"./spei12_7_1963.png": 329484,
	"./spei12_7_1964.png": 951780,
	"./spei12_7_1965.png": 680208,
	"./spei12_7_1966.png": 223164,
	"./spei12_7_1967.png": 183117,
	"./spei12_7_1968.png": 279740,
	"./spei12_7_1969.png": 17116,
	"./spei12_7_1970.png": 813748,
	"./spei12_7_1971.png": 93600,
	"./spei12_7_1972.png": 636556,
	"./spei12_7_1973.png": 268700,
	"./spei12_7_1974.png": 405492,
	"./spei12_7_1975.png": 714792,
	"./spei12_7_1976.png": 371141,
	"./spei12_7_1977.png": 527004,
	"./spei12_7_1978.png": 254476,
	"./spei12_7_1979.png": 446660,
	"./spei12_7_1980.png": 880464,
	"./spei12_7_1981.png": 201040,
	"./spei12_7_1982.png": 277184,
	"./spei12_7_1983.png": 267492,
	"./spei12_7_1984.png": 994992,
	"./spei12_7_1985.png": 993576,
	"./spei12_7_1986.png": 465928,
	"./spei12_7_1987.png": 929656,
	"./spei12_7_1988.png": 455768,
	"./spei12_7_1989.png": 956388,
	"./spei12_7_1990.png": 37244,
	"./spei12_7_1991.png": 592324,
	"./spei12_7_1992.png": 891412,
	"./spei12_7_1993.png": 163928,
	"./spei12_7_1994.png": 938564,
	"./spei12_7_1995.png": 943527,
	"./spei12_7_1996.png": 881668,
	"./spei12_7_1997.png": 59776,
	"./spei12_7_1998.png": 815204,
	"./spei12_7_1999.png": 493592,
	"./spei12_7_2000.png": 140324,
	"./spei12_7_2001.png": 143008,
	"./spei12_7_2002.png": 191432,
	"./spei12_7_2003.png": 702732,
	"./spei12_7_2004.png": 943288,
	"./spei12_7_2005.png": 946520,
	"./spei12_7_2006.png": 53764,
	"./spei12_7_2007.png": 151536,
	"./spei12_7_2008.png": 916936,
	"./spei12_7_2009.png": 920280,
	"./spei12_7_2010.png": 670072,
	"./spei12_7_2011.png": 892700,
	"./spei12_7_2012.png": 89388,
	"./spei12_7_2013.png": 200668,
	"./spei12_7_2014.png": 767352,
	"./spei12_7_2015.png": 122168,
	"./spei12_7_2016.png": 135920,
	"./spei12_7_2017.png": 76588,
	"./spei12_7_2018.png": 273668,
	"./spei12_7_2019.png": 706868,
	"./spei12_7_2020.png": 501192,
	"./spei12_7_2021.png": 467932,
	"./spei12_7_2022.png": 259084,
	"./spei12_7_2023.png": 716128,
	"./spei12_8_1950.png": 449044,
	"./spei12_8_1951.png": 402160,
	"./spei12_8_1952.png": 282740,
	"./spei12_8_1953.png": 150796,
	"./spei12_8_1954.png": 731944,
	"./spei12_8_1955.png": 959732,
	"./spei12_8_1956.png": 540804,
	"./spei12_8_1957.png": 916096,
	"./spei12_8_1958.png": 637580,
	"./spei12_8_1959.png": 841660,
	"./spei12_8_1960.png": 953380,
	"./spei12_8_1961.png": 989016,
	"./spei12_8_1962.png": 495056,
	"./spei12_8_1963.png": 556772,
	"./spei12_8_1964.png": 324980,
	"./spei12_8_1965.png": 355280,
	"./spei12_8_1966.png": 433364,
	"./spei12_8_1967.png": 63084,
	"./spei12_8_1968.png": 816156,
	"./spei12_8_1969.png": 822884,
	"./spei12_8_1970.png": 609412,
	"./spei12_8_1971.png": 652908,
	"./spei12_8_1972.png": 49484,
	"./spei12_8_1973.png": 795816,
	"./spei12_8_1974.png": 263432,
	"./spei12_8_1975.png": 124764,
	"./spei12_8_1976.png": 45308,
	"./spei12_8_1977.png": 950596,
	"./spei12_8_1978.png": 326452,
	"./spei12_8_1979.png": 83788,
	"./spei12_8_1980.png": 642752,
	"./spei12_8_1981.png": 64596,
	"./spei12_8_1982.png": 73364,
	"./spei12_8_1983.png": 167668,
	"./spei12_8_1984.png": 29636,
	"./spei12_8_1985.png": 495644,
	"./spei12_8_1986.png": 480036,
	"./spei12_8_1987.png": 420864,
	"./spei12_8_1988.png": 235064,
	"./spei12_8_1989.png": 531328,
	"./spei12_8_1990.png": 870800,
	"./spei12_8_1991.png": 482476,
	"./spei12_8_1992.png": 63280,
	"./spei12_8_1993.png": 191972,
	"./spei12_8_1994.png": 772120,
	"./spei12_8_1995.png": 577440,
	"./spei12_8_1996.png": 31108,
	"./spei12_8_1997.png": 274928,
	"./spei12_8_1998.png": 871140,
	"./spei12_8_1999.png": 658768,
	"./spei12_8_2000.png": 504304,
	"./spei12_8_2001.png": 448284,
	"./spei12_8_2002.png": 536672,
	"./spei12_8_2003.png": 526980,
	"./spei12_8_2004.png": 967804,
	"./spei12_8_2005.png": 966856,
	"./spei12_8_2006.png": 246120,
	"./spei12_8_2007.png": 54468,
	"./spei12_8_2008.png": 498404,
	"./spei12_8_2009.png": 941912,
	"./spei12_8_2010.png": 259176,
	"./spei12_8_2011.png": 817856,
	"./spei12_8_2012.png": 661420,
	"./spei12_8_2013.png": 518000,
	"./spei12_8_2014.png": 672276,
	"./spei12_8_2015.png": 145077,
	"./spei12_8_2016.png": 574628,
	"./spei12_8_2017.png": 972432,
	"./spei12_8_2018.png": 176192,
	"./spei12_8_2019.png": 680184,
	"./spei12_8_2020.png": 808596,
	"./spei12_8_2021.png": 173780,
	"./spei12_8_2022.png": 622976,
	"./spei12_8_2023.png": 566740,
	"./spei12_9_1950.png": 888008,
	"./spei12_9_1951.png": 864816,
	"./spei12_9_1952.png": 929164,
	"./spei12_9_1953.png": 436420,
	"./spei12_9_1954.png": 456888,
	"./spei12_9_1955.png": 768284,
	"./spei12_9_1956.png": 931780,
	"./spei12_9_1957.png": 987232,
	"./spei12_9_1958.png": 865316,
	"./spei12_9_1959.png": 845751,
	"./spei12_9_1960.png": 145520,
	"./spei12_9_1961.png": 408040,
	"./spei12_9_1962.png": 516040,
	"./spei12_9_1963.png": 202148,
	"./spei12_9_1964.png": 501533,
	"./spei12_9_1965.png": 473532,
	"./spei12_9_1966.png": 449260,
	"./spei12_9_1967.png": 247224,
	"./spei12_9_1968.png": 660696,
	"./spei12_9_1969.png": 182461,
	"./spei12_9_1970.png": 759020,
	"./spei12_9_1971.png": 981196,
	"./spei12_9_1972.png": 975516,
	"./spei12_9_1973.png": 127124,
	"./spei12_9_1974.png": 234208,
	"./spei12_9_1975.png": 496772,
	"./spei12_9_1976.png": 36280,
	"./spei12_9_1977.png": 300756,
	"./spei12_9_1978.png": 333640,
	"./spei12_9_1979.png": 835284,
	"./spei12_9_1980.png": 931512,
	"./spei12_9_1981.png": 317052,
	"./spei12_9_1982.png": 719248,
	"./spei12_9_1983.png": 765356,
	"./spei12_9_1984.png": 269349,
	"./spei12_9_1985.png": 682820,
	"./spei12_9_1986.png": 502536,
	"./spei12_9_1987.png": 415404,
	"./spei12_9_1988.png": 32720,
	"./spei12_9_1989.png": 102152,
	"./spei12_9_1990.png": 291220,
	"./spei12_9_1991.png": 57992,
	"./spei12_9_1992.png": 193572,
	"./spei12_9_1993.png": 107728,
	"./spei12_9_1994.png": 878120,
	"./spei12_9_1995.png": 558764,
	"./spei12_9_1996.png": 158400,
	"./spei12_9_1997.png": 552880,
	"./spei12_9_1998.png": 409376,
	"./spei12_9_1999.png": 33952,
	"./spei12_9_2000.png": 662036,
	"./spei12_9_2001.png": 973872,
	"./spei12_9_2002.png": 704519,
	"./spei12_9_2003.png": 311332,
	"./spei12_9_2004.png": 283691,
	"./spei12_9_2005.png": 108340,
	"./spei12_9_2006.png": 17572,
	"./spei12_9_2007.png": 430636,
	"./spei12_9_2008.png": 639248,
	"./spei12_9_2009.png": 12728,
	"./spei12_9_2010.png": 423719,
	"./spei12_9_2011.png": 239543,
	"./spei12_9_2012.png": 881236,
	"./spei12_9_2013.png": 152983,
	"./spei12_9_2014.png": 956892,
	"./spei12_9_2015.png": 299688,
	"./spei12_9_2016.png": 804260,
	"./spei12_9_2017.png": 29384,
	"./spei12_9_2018.png": 103988,
	"./spei12_9_2019.png": 981580,
	"./spei12_9_2020.png": 693892,
	"./spei12_9_2021.png": 872000,
	"./spei12_9_2022.png": 528408,
	"./spei12_9_2023.png": 755752,
	"./spei3_10_1950.png": 880020,
	"./spei3_10_1951.png": 258876,
	"./spei3_10_1952.png": 410404,
	"./spei3_10_1953.png": 812656,
	"./spei3_10_1954.png": 464092,
	"./spei3_10_1955.png": 278828,
	"./spei3_10_1956.png": 824560,
	"./spei3_10_1957.png": 503888,
	"./spei3_10_1958.png": 908348,
	"./spei3_10_1959.png": 432508,
	"./spei3_10_1960.png": 258648,
	"./spei3_10_1961.png": 811105,
	"./spei3_10_1962.png": 865640,
	"./spei3_10_1963.png": 90312,
	"./spei3_10_1964.png": 702380,
	"./spei3_10_1965.png": 909664,
	"./spei3_10_1966.png": 692008,
	"./spei3_10_1967.png": 393681,
	"./spei3_10_1968.png": 373372,
	"./spei3_10_1969.png": 166264,
	"./spei3_10_1970.png": 843493,
	"./spei3_10_1971.png": 324304,
	"./spei3_10_1972.png": 423513,
	"./spei3_10_1973.png": 572956,
	"./spei3_10_1974.png": 65444,
	"./spei3_10_1975.png": 391264,
	"./spei3_10_1976.png": 819484,
	"./spei3_10_1977.png": 677940,
	"./spei3_10_1978.png": 202520,
	"./spei3_10_1979.png": 227944,
	"./spei3_10_1980.png": 530303,
	"./spei3_10_1981.png": 611000,
	"./spei3_10_1982.png": 408476,
	"./spei3_10_1983.png": 913543,
	"./spei3_10_1984.png": 415776,
	"./spei3_10_1985.png": 736351,
	"./spei3_10_1986.png": 991532,
	"./spei3_10_1987.png": 727668,
	"./spei3_10_1988.png": 36968,
	"./spei3_10_1989.png": 743788,
	"./spei3_10_1990.png": 406516,
	"./spei3_10_1991.png": 856736,
	"./spei3_10_1992.png": 501120,
	"./spei3_10_1993.png": 987640,
	"./spei3_10_1994.png": 476496,
	"./spei3_10_1995.png": 681460,
	"./spei3_10_1996.png": 600140,
	"./spei3_10_1997.png": 247272,
	"./spei3_10_1998.png": 439324,
	"./spei3_10_1999.png": 474888,
	"./spei3_10_2000.png": 211132,
	"./spei3_10_2001.png": 73492,
	"./spei3_10_2002.png": 328940,
	"./spei3_10_2003.png": 645220,
	"./spei3_10_2004.png": 890000,
	"./spei3_10_2005.png": 432956,
	"./spei3_10_2006.png": 895476,
	"./spei3_10_2007.png": 912677,
	"./spei3_10_2008.png": 326148,
	"./spei3_10_2009.png": 519344,
	"./spei3_10_2010.png": 521448,
	"./spei3_10_2011.png": 399132,
	"./spei3_10_2012.png": 717464,
	"./spei3_10_2013.png": 677280,
	"./spei3_10_2014.png": 864168,
	"./spei3_10_2015.png": 260772,
	"./spei3_10_2016.png": 801728,
	"./spei3_10_2017.png": 979712,
	"./spei3_10_2018.png": 555280,
	"./spei3_10_2019.png": 142436,
	"./spei3_10_2020.png": 765268,
	"./spei3_10_2021.png": 588996,
	"./spei3_10_2022.png": 788700,
	"./spei3_10_2023.png": 904688,
	"./spei3_11_1950.png": 217608,
	"./spei3_11_1951.png": 749288,
	"./spei3_11_1952.png": 834700,
	"./spei3_11_1953.png": 186095,
	"./spei3_11_1954.png": 848244,
	"./spei3_11_1955.png": 432544,
	"./spei3_11_1956.png": 639991,
	"./spei3_11_1957.png": 184349,
	"./spei3_11_1958.png": 634956,
	"./spei3_11_1959.png": 372332,
	"./spei3_11_1960.png": 911788,
	"./spei3_11_1961.png": 770104,
	"./spei3_11_1962.png": 551805,
	"./spei3_11_1963.png": 295028,
	"./spei3_11_1964.png": 574880,
	"./spei3_11_1965.png": 117836,
	"./spei3_11_1966.png": 150636,
	"./spei3_11_1967.png": 664392,
	"./spei3_11_1968.png": 266452,
	"./spei3_11_1969.png": 780928,
	"./spei3_11_1970.png": 579372,
	"./spei3_11_1971.png": 551732,
	"./spei3_11_1972.png": 238220,
	"./spei3_11_1973.png": 914944,
	"./spei3_11_1974.png": 354100,
	"./spei3_11_1975.png": 352792,
	"./spei3_11_1976.png": 577756,
	"./spei3_11_1977.png": 575728,
	"./spei3_11_1978.png": 229140,
	"./spei3_11_1979.png": 612424,
	"./spei3_11_1980.png": 802068,
	"./spei3_11_1981.png": 657652,
	"./spei3_11_1982.png": 836679,
	"./spei3_11_1983.png": 314576,
	"./spei3_11_1984.png": 307348,
	"./spei3_11_1985.png": 338176,
	"./spei3_11_1986.png": 216708,
	"./spei3_11_1987.png": 681520,
	"./spei3_11_1988.png": 132128,
	"./spei3_11_1989.png": 604704,
	"./spei3_11_1990.png": 860252,
	"./spei3_11_1991.png": 764560,
	"./spei3_11_1992.png": 853308,
	"./spei3_11_1993.png": 934512,
	"./spei3_11_1994.png": 666040,
	"./spei3_11_1995.png": 958524,
	"./spei3_11_1996.png": 436364,
	"./spei3_11_1997.png": 9632,
	"./spei3_11_1998.png": 791236,
	"./spei3_11_1999.png": 759428,
	"./spei3_11_2000.png": 102192,
	"./spei3_11_2001.png": 960844,
	"./spei3_11_2002.png": 319552,
	"./spei3_11_2003.png": 837452,
	"./spei3_11_2004.png": 916996,
	"./spei3_11_2005.png": 970885,
	"./spei3_11_2006.png": 349728,
	"./spei3_11_2007.png": 776188,
	"./spei3_11_2008.png": 736600,
	"./spei3_11_2009.png": 73004,
	"./spei3_11_2010.png": 111092,
	"./spei3_11_2011.png": 496828,
	"./spei3_11_2012.png": 274760,
	"./spei3_11_2013.png": 757412,
	"./spei3_11_2014.png": 82924,
	"./spei3_11_2015.png": 895264,
	"./spei3_11_2016.png": 366944,
	"./spei3_11_2017.png": 174356,
	"./spei3_11_2018.png": 43484,
	"./spei3_11_2019.png": 398276,
	"./spei3_11_2020.png": 94232,
	"./spei3_11_2021.png": 249567,
	"./spei3_11_2022.png": 298404,
	"./spei3_11_2023.png": 678844,
	"./spei3_12_1950.png": 764644,
	"./spei3_12_1951.png": 208152,
	"./spei3_12_1952.png": 141584,
	"./spei3_12_1953.png": 26892,
	"./spei3_12_1954.png": 649188,
	"./spei3_12_1955.png": 893968,
	"./spei3_12_1956.png": 699156,
	"./spei3_12_1957.png": 396876,
	"./spei3_12_1958.png": 977149,
	"./spei3_12_1959.png": 714524,
	"./spei3_12_1960.png": 146593,
	"./spei3_12_1961.png": 825404,
	"./spei3_12_1962.png": 868136,
	"./spei3_12_1963.png": 604872,
	"./spei3_12_1964.png": 81860,
	"./spei3_12_1965.png": 300592,
	"./spei3_12_1966.png": 595796,
	"./spei3_12_1967.png": 84096,
	"./spei3_12_1968.png": 623940,
	"./spei3_12_1969.png": 94152,
	"./spei3_12_1970.png": 345183,
	"./spei3_12_1971.png": 849176,
	"./spei3_12_1972.png": 141756,
	"./spei3_12_1973.png": 129448,
	"./spei3_12_1974.png": 352620,
	"./spei3_12_1975.png": 952256,
	"./spei3_12_1976.png": 277816,
	"./spei3_12_1977.png": 600128,
	"./spei3_12_1978.png": 514768,
	"./spei3_12_1979.png": 182220,
	"./spei3_12_1980.png": 276444,
	"./spei3_12_1981.png": 107508,
	"./spei3_12_1982.png": 640924,
	"./spei3_12_1983.png": 170328,
	"./spei3_12_1984.png": 84500,
	"./spei3_12_1985.png": 925256,
	"./spei3_12_1986.png": 753736,
	"./spei3_12_1987.png": 994644,
	"./spei3_12_1988.png": 121672,
	"./spei3_12_1989.png": 787588,
	"./spei3_12_1990.png": 163836,
	"./spei3_12_1991.png": 281736,
	"./spei3_12_1992.png": 494016,
	"./spei3_12_1993.png": 935064,
	"./spei3_12_1994.png": 250224,
	"./spei3_12_1995.png": 610140,
	"./spei3_12_1996.png": 696444,
	"./spei3_12_1997.png": 418564,
	"./spei3_12_1998.png": 461236,
	"./spei3_12_1999.png": 548072,
	"./spei3_12_2000.png": 433332,
	"./spei3_12_2001.png": 274088,
	"./spei3_12_2002.png": 659988,
	"./spei3_12_2003.png": 614772,
	"./spei3_12_2004.png": 986960,
	"./spei3_12_2005.png": 991436,
	"./spei3_12_2006.png": 611268,
	"./spei3_12_2007.png": 296780,
	"./spei3_12_2008.png": 252715,
	"./spei3_12_2009.png": 775168,
	"./spei3_12_2010.png": 177088,
	"./spei3_12_2011.png": 50192,
	"./spei3_12_2012.png": 595692,
	"./spei3_12_2013.png": 946940,
	"./spei3_12_2014.png": 968356,
	"./spei3_12_2015.png": 424364,
	"./spei3_12_2016.png": 252376,
	"./spei3_12_2017.png": 88312,
	"./spei3_12_2018.png": 719044,
	"./spei3_12_2019.png": 2600,
	"./spei3_12_2020.png": 789664,
	"./spei3_12_2021.png": 779972,
	"./spei3_12_2022.png": 934813,
	"./spei3_12_2023.png": 8660,
	"./spei3_1_1950.png": 783988,
	"./spei3_1_1951.png": 721292,
	"./spei3_1_1952.png": 832580,
	"./spei3_1_1953.png": 534624,
	"./spei3_1_1954.png": 633856,
	"./spei3_1_1955.png": 483516,
	"./spei3_1_1956.png": 413412,
	"./spei3_1_1957.png": 97820,
	"./spei3_1_1958.png": 154336,
	"./spei3_1_1959.png": 833228,
	"./spei3_1_1960.png": 80504,
	"./spei3_1_1961.png": 675604,
	"./spei3_1_1962.png": 43340,
	"./spei3_1_1963.png": 547332,
	"./spei3_1_1964.png": 533424,
	"./spei3_1_1965.png": 18324,
	"./spei3_1_1966.png": 812620,
	"./spei3_1_1967.png": 549996,
	"./spei3_1_1968.png": 153164,
	"./spei3_1_1969.png": 362013,
	"./spei3_1_1970.png": 76252,
	"./spei3_1_1971.png": 716336,
	"./spei3_1_1972.png": 762712,
	"./spei3_1_1973.png": 622112,
	"./spei3_1_1974.png": 163784,
	"./spei3_1_1975.png": 629948,
	"./spei3_1_1976.png": 817112,
	"./spei3_1_1977.png": 179112,
	"./spei3_1_1978.png": 521989,
	"./spei3_1_1979.png": 313572,
	"./spei3_1_1980.png": 769319,
	"./spei3_1_1981.png": 506176,
	"./spei3_1_1982.png": 643711,
	"./spei3_1_1983.png": 849520,
	"./spei3_1_1984.png": 747688,
	"./spei3_1_1985.png": 603272,
	"./spei3_1_1986.png": 319416,
	"./spei3_1_1987.png": 704956,
	"./spei3_1_1988.png": 621260,
	"./spei3_1_1989.png": 565732,
	"./spei3_1_1990.png": 607976,
	"./spei3_1_1991.png": 628900,
	"./spei3_1_1992.png": 337672,
	"./spei3_1_1993.png": 954388,
	"./spei3_1_1994.png": 252120,
	"./spei3_1_1995.png": 573732,
	"./spei3_1_1996.png": 400692,
	"./spei3_1_1997.png": 42800,
	"./spei3_1_1998.png": 762156,
	"./spei3_1_1999.png": 92759,
	"./spei3_1_2000.png": 457208,
	"./spei3_1_2001.png": 326396,
	"./spei3_1_2002.png": 507176,
	"./spei3_1_2003.png": 552319,
	"./spei3_1_2004.png": 56312,
	"./spei3_1_2005.png": 86552,
	"./spei3_1_2006.png": 19984,
	"./spei3_1_2007.png": 318560,
	"./spei3_1_2008.png": 42064,
	"./spei3_1_2009.png": 111496,
	"./spei3_1_2010.png": 784604,
	"./spei3_1_2011.png": 321944,
	"./spei3_1_2012.png": 568108,
	"./spei3_1_2013.png": 403816,
	"./spei3_1_2014.png": 117072,
	"./spei3_1_2015.png": 442880,
	"./spei3_1_2016.png": 289717,
	"./spei3_1_2017.png": 300564,
	"./spei3_1_2018.png": 603188,
	"./spei3_1_2019.png": 809500,
	"./spei3_1_2020.png": 956900,
	"./spei3_1_2021.png": 816684,
	"./spei3_1_2022.png": 498576,
	"./spei3_1_2023.png": 237512,
	"./spei3_2_1950.png": 899644,
	"./spei3_2_1951.png": 997936,
	"./spei3_2_1952.png": 229824,
	"./spei3_2_1953.png": 900276,
	"./spei3_2_1954.png": 986032,
	"./spei3_2_1955.png": 583780,
	"./spei3_2_1956.png": 654632,
	"./spei3_2_1957.png": 831015,
	"./spei3_2_1958.png": 693880,
	"./spei3_2_1959.png": 89816,
	"./spei3_2_1960.png": 618880,
	"./spei3_2_1961.png": 968772,
	"./spei3_2_1962.png": 444628,
	"./spei3_2_1963.png": 782192,
	"./spei3_2_1964.png": 510332,
	"./spei3_2_1965.png": 461684,
	"./spei3_2_1966.png": 547908,
	"./spei3_2_1967.png": 24348,
	"./spei3_2_1968.png": 50052,
	"./spei3_2_1969.png": 750300,
	"./spei3_2_1970.png": 804320,
	"./spei3_2_1971.png": 11484,
	"./spei3_2_1972.png": 669684,
	"./spei3_2_1973.png": 537740,
	"./spei3_2_1974.png": 367516,
	"./spei3_2_1975.png": 224712,
	"./spei3_2_1976.png": 827332,
	"./spei3_2_1977.png": 146420,
	"./spei3_2_1978.png": 224312,
	"./spei3_2_1979.png": 228604,
	"./spei3_2_1980.png": 242828,
	"./spei3_2_1981.png": 605032,
	"./spei3_2_1982.png": 221732,
	"./spei3_2_1983.png": 414500,
	"./spei3_2_1984.png": 582364,
	"./spei3_2_1985.png": 814004,
	"./spei3_2_1986.png": 410984,
	"./spei3_2_1987.png": 425988,
	"./spei3_2_1988.png": 344629,
	"./spei3_2_1989.png": 2524,
	"./spei3_2_1990.png": 783640,
	"./spei3_2_1991.png": 150216,
	"./spei3_2_1992.png": 653688,
	"./spei3_2_1993.png": 186660,
	"./spei3_2_1994.png": 726228,
	"./spei3_2_1995.png": 202024,
	"./spei3_2_1996.png": 848252,
	"./spei3_2_1997.png": 322628,
	"./spei3_2_1998.png": 923724,
	"./spei3_2_1999.png": 105284,
	"./spei3_2_2000.png": 971468,
	"./spei3_2_2001.png": 268856,
	"./spei3_2_2002.png": 952208,
	"./spei3_2_2003.png": 11516,
	"./spei3_2_2004.png": 760052,
	"./spei3_2_2005.png": 223780,
	"./spei3_2_2006.png": 289116,
	"./spei3_2_2007.png": 652052,
	"./spei3_2_2008.png": 847848,
	"./spei3_2_2009.png": 12140,
	"./spei3_2_2010.png": 663112,
	"./spei3_2_2011.png": 787884,
	"./spei3_2_2012.png": 485920,
	"./spei3_2_2013.png": 285840,
	"./spei3_2_2014.png": 355272,
	"./spei3_2_2015.png": 856916,
	"./spei3_2_2016.png": 220504,
	"./spei3_2_2017.png": 115100,
	"./spei3_2_2018.png": 362028,
	"./spei3_2_2019.png": 518404,
	"./spei3_2_2020.png": 522396,
	"./spei3_2_2021.png": 72008,
	"./spei3_2_2022.png": 87336,
	"./spei3_2_2023.png": 947716,
	"./spei3_3_1950.png": 788608,
	"./spei3_3_1951.png": 616888,
	"./spei3_3_1952.png": 444400,
	"./spei3_3_1953.png": 171848,
	"./spei3_3_1954.png": 421663,
	"./spei3_3_1955.png": 46240,
	"./spei3_3_1956.png": 412228,
	"./spei3_3_1957.png": 763592,
	"./spei3_3_1958.png": 265236,
	"./spei3_3_1959.png": 779712,
	"./spei3_3_1960.png": 578156,
	"./spei3_3_1961.png": 772896,
	"./spei3_3_1962.png": 166624,
	"./spei3_3_1963.png": 813312,
	"./spei3_3_1964.png": 453300,
	"./spei3_3_1965.png": 251160,
	"./spei3_3_1966.png": 576540,
	"./spei3_3_1967.png": 574512,
	"./spei3_3_1968.png": 227924,
	"./spei3_3_1969.png": 611208,
	"./spei3_3_1970.png": 655160,
	"./spei3_3_1971.png": 947644,
	"./spei3_3_1972.png": 688292,
	"./spei3_3_1973.png": 998752,
	"./spei3_3_1974.png": 849372,
	"./spei3_3_1975.png": 753680,
	"./spei3_3_1976.png": 772048,
	"./spei3_3_1977.png": 45596,
	"./spei3_3_1978.png": 747795,
	"./spei3_3_1979.png": 986872,
	"./spei3_3_1980.png": 835436,
	"./spei3_3_1981.png": 30664,
	"./spei3_3_1982.png": 368424,
	"./spei3_3_1983.png": 916944,
	"./spei3_3_1984.png": 151876,
	"./spei3_3_1985.png": 69764,
	"./spei3_3_1986.png": 764464,
	"./spei3_3_1987.png": 766540,
	"./spei3_3_1988.png": 871244,
	"./spei3_3_1989.png": 170060,
	"./spei3_3_1990.png": 607784,
	"./spei3_3_1991.png": 344519,
	"./spei3_3_1992.png": 886240,
	"./spei3_3_1993.png": 494672,
	"./spei3_3_1994.png": 239728,
	"./spei3_3_1995.png": 41636,
	"./spei3_3_1996.png": 699544,
	"./spei3_3_1997.png": 162204,
	"./spei3_3_1998.png": 218488,
	"./spei3_3_1999.png": 426736,
	"./spei3_3_2000.png": 290900,
	"./spei3_3_2001.png": 749164,
	"./spei3_3_2002.png": 209028,
	"./spei3_3_2003.png": 965660,
	"./spei3_3_2004.png": 633621,
	"./spei3_3_2005.png": 370356,
	"./spei3_3_2006.png": 467316,
	"./spei3_3_2007.png": 781776,
	"./spei3_3_2008.png": 85952,
	"./spei3_3_2009.png": 489528,
	"./spei3_3_2010.png": 794109,
	"./spei3_3_2011.png": 112236,
	"./spei3_3_2012.png": 137956,
	"./spei3_3_2013.png": 228196,
	"./spei3_3_2014.png": 89228,
	"./spei3_3_2015.png": 458696,
	"./spei3_3_2016.png": 509556,
	"./spei3_3_2017.png": 705968,
	"./spei3_3_2018.png": 655112,
	"./spei3_3_2019.png": 682712,
	"./spei3_3_2020.png": 78476,
	"./spei3_3_2021.png": 469964,
	"./spei3_3_2022.png": 234061,
	"./spei3_3_2023.png": 959308,
	"./spei3_4_1950.png": 72364,
	"./spei3_4_1951.png": 62284,
	"./spei3_4_1952.png": 163892,
	"./spei3_4_1953.png": 191532,
	"./spei3_4_1954.png": 883440,
	"./spei3_4_1955.png": 859292,
	"./spei3_4_1956.png": 663236,
	"./spei3_4_1957.png": 513672,
	"./spei3_4_1958.png": 386644,
	"./spei3_4_1959.png": 145736,
	"./spei3_4_1960.png": 4684,
	"./spei3_4_1961.png": 730976,
	"./spei3_4_1962.png": 268536,
	"./spei3_4_1963.png": 10492,
	"./spei3_4_1964.png": 20624,
	"./spei3_4_1965.png": 658972,
	"./spei3_4_1966.png": 333040,
	"./spei3_4_1967.png": 790352,
	"./spei3_4_1968.png": 969484,
	"./spei3_4_1969.png": 85640,
	"./spei3_4_1970.png": 313416,
	"./spei3_4_1971.png": 872108,
	"./spei3_4_1972.png": 905724,
	"./spei3_4_1973.png": 465000,
	"./spei3_4_1974.png": 276244,
	"./spei3_4_1975.png": 199536,
	"./spei3_4_1976.png": 222980,
	"./spei3_4_1977.png": 824836,
	"./spei3_4_1978.png": 876108,
	"./spei3_4_1979.png": 484620,
	"./spei3_4_1980.png": 150336,
	"./spei3_4_1981.png": 287871,
	"./spei3_4_1982.png": 366832,
	"./spei3_4_1983.png": 4756,
	"./spei3_4_1984.png": 334220,
	"./spei3_4_1985.png": 404440,
	"./spei3_4_1986.png": 843532,
	"./spei3_4_1987.png": 956007,
	"./spei3_4_1988.png": 485236,
	"./spei3_4_1989.png": 794536,
	"./spei3_4_1990.png": 53592,
	"./spei3_4_1991.png": 807788,
	"./spei3_4_1992.png": 874479,
	"./spei3_4_1993.png": 253296,
	"./spei3_4_1994.png": 602628,
	"./spei3_4_1995.png": 46696,
	"./spei3_4_1996.png": 253748,
	"./spei3_4_1997.png": 616380,
	"./spei3_4_1998.png": 186848,
	"./spei3_4_1999.png": 632584,
	"./spei3_4_2000.png": 733976,
	"./spei3_4_2001.png": 704948,
	"./spei3_4_2002.png": 571399,
	"./spei3_4_2003.png": 311988,
	"./spei3_4_2004.png": 647748,
	"./spei3_4_2005.png": 668216,
	"./spei3_4_2006.png": 76144,
	"./spei3_4_2007.png": 70112,
	"./spei3_4_2008.png": 625820,
	"./spei3_4_2009.png": 347476,
	"./spei3_4_2010.png": 656720,
	"./spei3_4_2011.png": 448108,
	"./spei3_4_2012.png": 849916,
	"./spei3_4_2013.png": 956140,
	"./spei3_4_2014.png": 7192,
	"./spei3_4_2015.png": 328804,
	"./spei3_4_2016.png": 366692,
	"./spei3_4_2017.png": 612824,
	"./spei3_4_2018.png": 679508,
	"./spei3_4_2019.png": 868100,
	"./spei3_4_2020.png": 512244,
	"./spei3_4_2021.png": 934232,
	"./spei3_4_2022.png": 276560,
	"./spei3_4_2023.png": 54020,
	"./spei3_5_1950.png": 516720,
	"./spei3_5_1951.png": 144592,
	"./spei3_5_1952.png": 843068,
	"./spei3_5_1953.png": 192476,
	"./spei3_5_1954.png": 552364,
	"./spei3_5_1955.png": 992448,
	"./spei3_5_1956.png": 718212,
	"./spei3_5_1957.png": 971732,
	"./spei3_5_1958.png": 273092,
	"./spei3_5_1959.png": 571692,
	"./spei3_5_1960.png": 257200,
	"./spei3_5_1961.png": 329100,
	"./spei3_5_1962.png": 151016,
	"./spei3_5_1963.png": 358068,
	"./spei3_5_1964.png": 650320,
	"./spei3_5_1965.png": 933476,
	"./spei3_5_1966.png": 152364,
	"./spei3_5_1967.png": 27592,
	"./spei3_5_1968.png": 655208,
	"./spei3_5_1969.png": 424652,
	"./spei3_5_1970.png": 630724,
	"./spei3_5_1971.png": 170232,
	"./spei3_5_1972.png": 526960,
	"./spei3_5_1973.png": 254656,
	"./spei3_5_1974.png": 147224,
	"./spei3_5_1975.png": 361967,
	"./spei3_5_1976.png": 531528,
	"./spei3_5_1977.png": 368160,
	"./spei3_5_1978.png": 404328,
	"./spei3_5_1979.png": 757196,
	"./spei3_5_1980.png": 195600,
	"./spei3_5_1981.png": 68912,
	"./spei3_5_1982.png": 365552,
	"./spei3_5_1983.png": 284348,
	"./spei3_5_1984.png": 389564,
	"./spei3_5_1985.png": 167460,
	"./spei3_5_1986.png": 440672,
	"./spei3_5_1987.png": 867404,
	"./spei3_5_1988.png": 968087,
	"./spei3_5_1989.png": 516248,
	"./spei3_5_1990.png": 490100,
	"./spei3_5_1991.png": 932980,
	"./spei3_5_1992.png": 614260,
	"./spei3_5_1993.png": 501628,
	"./spei3_5_1994.png": 425368,
	"./spei3_5_1995.png": 158252,
	"./spei3_5_1996.png": 764636,
	"./spei3_5_1997.png": 374200,
	"./spei3_5_1998.png": 401732,
	"./spei3_5_1999.png": 363680,
	"./spei3_5_2000.png": 893440,
	"./spei3_5_2001.png": 120796,
	"./spei3_5_2002.png": 293013,
	"./spei3_5_2003.png": 293804,
	"./spei3_5_2004.png": 55460,
	"./spei3_5_2005.png": 783888,
	"./spei3_5_2006.png": 119380,
	"./spei3_5_2007.png": 491316,
	"./spei3_5_2008.png": 117016,
	"./spei3_5_2009.png": 47624,
	"./spei3_5_2010.png": 66356,
	"./spei3_5_2011.png": 377296,
	"./spei3_5_2012.png": 917784,
	"./spei3_5_2013.png": 63600,
	"./spei3_5_2014.png": 880680,
	"./spei3_5_2015.png": 620052,
	"./spei3_5_2016.png": 496020,
	"./spei3_5_2017.png": 656812,
	"./spei3_5_2018.png": 633804,
	"./spei3_5_2019.png": 797288,
	"./spei3_5_2020.png": 855744,
	"./spei3_5_2021.png": 215660,
	"./spei3_5_2022.png": 98672,
	"./spei3_5_2023.png": 97256,
	"./spei3_6_1950.png": 69132,
	"./spei3_6_1951.png": 277744,
	"./spei3_6_1952.png": 481164,
	"./spei3_6_1953.png": 51368,
	"./spei3_6_1954.png": 903453,
	"./spei3_6_1955.png": 246028,
	"./spei3_6_1956.png": 601892,
	"./spei3_6_1957.png": 770316,
	"./spei3_6_1958.png": 445400,
	"./spei3_6_1959.png": 21492,
	"./spei3_6_1960.png": 917748,
	"./spei3_6_1961.png": 860892,
	"./spei3_6_1962.png": 790748,
	"./spei3_6_1963.png": 296656,
	"./spei3_6_1964.png": 599756,
	"./spei3_6_1965.png": 546736,
	"./spei3_6_1966.png": 220780,
	"./spei3_6_1967.png": 92236,
	"./spei3_6_1968.png": 843376,
	"./spei3_6_1969.png": 645284,
	"./spei3_6_1970.png": 469232,
	"./spei3_6_1971.png": 137192,
	"./spei3_6_1972.png": 781535,
	"./spei3_6_1973.png": 261925,
	"./spei3_6_1974.png": 94460,
	"./spei3_6_1975.png": 551261,
	"./spei3_6_1976.png": 63732,
	"./spei3_6_1977.png": 928932,
	"./spei3_6_1978.png": 914968,
	"./spei3_6_1979.png": 809564,
	"./spei3_6_1980.png": 475744,
	"./spei3_6_1981.png": 728636,
	"./spei3_6_1982.png": 47136,
	"./spei3_6_1983.png": 777384,
	"./spei3_6_1984.png": 576420,
	"./spei3_6_1985.png": 132152,
	"./spei3_6_1986.png": 982404,
	"./spei3_6_1987.png": 848376,
	"./spei3_6_1988.png": 379384,
	"./spei3_6_1989.png": 103984,
	"./spei3_6_1990.png": 245728,
	"./spei3_6_1991.png": 266072,
	"./spei3_6_1992.png": 558652,
	"./spei3_6_1993.png": 546344,
	"./spei3_6_1994.png": 253164,
	"./spei3_6_1995.png": 491116,
	"./spei3_6_1996.png": 694712,
	"./spei3_6_1997.png": 443092,
	"./spei3_6_1998.png": 328712,
	"./spei3_6_1999.png": 882976,
	"./spei3_6_2000.png": 474116,
	"./spei3_6_2001.png": 542724,
	"./spei3_6_2002.png": 628068,
	"./spei3_6_2003.png": 796492,
	"./spei3_6_2004.png": 663936,
	"./spei3_6_2005.png": 903012,
	"./spei3_6_2006.png": 867073,
	"./spei3_6_2007.png": 147924,
	"./spei3_6_2008.png": 320751,
	"./spei3_6_2009.png": 225060,
	"./spei3_6_2010.png": 68016,
	"./spei3_6_2011.png": 499048,
	"./spei3_6_2012.png": 235844,
	"./spei3_6_2013.png": 91460,
	"./spei3_6_2014.png": 306816,
	"./spei3_6_2015.png": 624007,
	"./spei3_6_2016.png": 62184,
	"./spei3_6_2017.png": 833084,
	"./spei3_6_2018.png": 400084,
	"./spei3_6_2019.png": 588012,
	"./spei3_6_2020.png": 357620,
	"./spei3_6_2021.png": 243037,
	"./spei3_6_2022.png": 492256,
	"./spei3_6_2023.png": 790212,
	"./spei3_7_1950.png": 752116,
	"./spei3_7_1951.png": 592872,
	"./spei3_7_1952.png": 945740,
	"./spei3_7_1953.png": 33972,
	"./spei3_7_1954.png": 305744,
	"./spei3_7_1955.png": 310220,
	"./spei3_7_1956.png": 464464,
	"./spei3_7_1957.png": 837944,
	"./spei3_7_1958.png": 310232,
	"./spei3_7_1959.png": 610304,
	"./spei3_7_1960.png": 660224,
	"./spei3_7_1961.png": 4856,
	"./spei3_7_1962.png": 213272,
	"./spei3_7_1963.png": 459399,
	"./spei3_7_1964.png": 67821,
	"./spei3_7_1965.png": 540397,
	"./spei3_7_1966.png": 636156,
	"./spei3_7_1967.png": 151560,
	"./spei3_7_1968.png": 136852,
	"./spei3_7_1969.png": 167680,
	"./spei3_7_1970.png": 793128,
	"./spei3_7_1971.png": 407264,
	"./spei3_7_1972.png": 11848,
	"./spei3_7_1973.png": 576380,
	"./spei3_7_1974.png": 865143,
	"./spei3_7_1975.png": 46976,
	"./spei3_7_1976.png": 377552,
	"./spei3_7_1977.png": 729992,
	"./spei3_7_1978.png": 373136,
	"./spei3_7_1979.png": 517708,
	"./spei3_7_1980.png": 895144,
	"./spei3_7_1981.png": 148352,
	"./spei3_7_1982.png": 769536,
	"./spei3_7_1983.png": 97308,
	"./spei3_7_1984.png": 389864,
	"./spei3_7_1985.png": 467828,
	"./spei3_7_1986.png": 961592,
	"./spei3_7_1987.png": 347132,
	"./spei3_7_1988.png": 263437,
	"./spei3_7_1989.png": 207908,
	"./spei3_7_1990.png": 131427,
	"./spei3_7_1991.png": 392192,
	"./spei3_7_1992.png": 40112,
	"./spei3_7_1993.png": 842020,
	"./spei3_7_1994.png": 491148,
	"./spei3_7_1995.png": 857192,
	"./spei3_7_1996.png": 410944,
	"./spei3_7_1997.png": 227120,
	"./spei3_7_1998.png": 773800,
	"./spei3_7_1999.png": 610316,
	"./spei3_7_2000.png": 976983,
	"./spei3_7_2001.png": 956220,
	"./spei3_7_2002.png": 850484,
	"./spei3_7_2003.png": 382165,
	"./spei3_7_2004.png": 11168,
	"./spei3_7_2005.png": 659088,
	"./spei3_7_2006.png": 136776,
	"./spei3_7_2007.png": 608972,
	"./spei3_7_2008.png": 732080,
	"./spei3_7_2009.png": 147623,
	"./spei3_7_2010.png": 629456,
	"./spei3_7_2011.png": 146640,
	"./spei3_7_2012.png": 740180,
	"./spei3_7_2013.png": 789008,
	"./spei3_7_2014.png": 988248,
	"./spei3_7_2015.png": 464148,
	"./spei3_7_2016.png": 557452,
	"./spei3_7_2017.png": 1216,
	"./spei3_7_2018.png": 289916,
	"./spei3_7_2019.png": 37912,
	"./spei3_7_2020.png": 756820,
	"./spei3_7_2021.png": 893836,
	"./spei3_7_2022.png": 618236,
	"./spei3_7_2023.png": 437952,
	"./spei3_8_1950.png": 755884,
	"./spei3_8_1951.png": 613972,
	"./spei3_8_1952.png": 502088,
	"./spei3_8_1953.png": 559196,
	"./spei3_8_1954.png": 794128,
	"./spei3_8_1955.png": 104768,
	"./spei3_8_1956.png": 288860,
	"./spei3_8_1957.png": 788664,
	"./spei3_8_1958.png": 14840,
	"./spei3_8_1959.png": 467968,
	"./spei3_8_1960.png": 236304,
	"./spei3_8_1961.png": 609784,
	"./spei3_8_1962.png": 215416,
	"./spei3_8_1963.png": 488396,
	"./spei3_8_1964.png": 879884,
	"./spei3_8_1965.png": 737212,
	"./spei3_8_1966.png": 741772,
	"./spei3_8_1967.png": 957653,
	"./spei3_8_1968.png": 259092,
	"./spei3_8_1969.png": 54576,
	"./spei3_8_1970.png": 786639,
	"./spei3_8_1971.png": 449440,
	"./spei3_8_1972.png": 359567,
	"./spei3_8_1973.png": 47544,
	"./spei3_8_1974.png": 173108,
	"./spei3_8_1975.png": 259944,
	"./spei3_8_1976.png": 459668,
	"./spei3_8_1977.png": 478664,
	"./spei3_8_1978.png": 110088,
	"./spei3_8_1979.png": 401316,
	"./spei3_8_1980.png": 56040,
	"./spei3_8_1981.png": 73904,
	"./spei3_8_1982.png": 366268,
	"./spei3_8_1983.png": 927716,
	"./spei3_8_1984.png": 383724,
	"./spei3_8_1985.png": 602760,
	"./spei3_8_1986.png": 796300,
	"./spei3_8_1987.png": 47020,
	"./spei3_8_1988.png": 310236,
	"./spei3_8_1989.png": 406732,
	"./spei3_8_1990.png": 129416,
	"./spei3_8_1991.png": 420644,
	"./spei3_8_1992.png": 427644,
	"./spei3_8_1993.png": 834544,
	"./spei3_8_1994.png": 991748,
	"./spei3_8_1995.png": 203648,
	"./spei3_8_1996.png": 931244,
	"./spei3_8_1997.png": 746132,
	"./spei3_8_1998.png": 28348,
	"./spei3_8_1999.png": 468768,
	"./spei3_8_2000.png": 756236,
	"./spei3_8_2001.png": 984672,
	"./spei3_8_2002.png": 163248,
	"./spei3_8_2003.png": 249581,
	"./spei3_8_2004.png": 368936,
	"./spei3_8_2005.png": 779244,
	"./spei3_8_2006.png": 52892,
	"./spei3_8_2007.png": 287824,
	"./spei3_8_2008.png": 598464,
	"./spei3_8_2009.png": 37620,
	"./spei3_8_2010.png": 103480,
	"./spei3_8_2011.png": 311727,
	"./spei3_8_2012.png": 982092,
	"./spei3_8_2013.png": 373580,
	"./spei3_8_2014.png": 199092,
	"./spei3_8_2015.png": 625885,
	"./spei3_8_2016.png": 575756,
	"./spei3_8_2017.png": 784605,
	"./spei3_8_2018.png": 683488,
	"./spei3_8_2019.png": 759064,
	"./spei3_8_2020.png": 765228,
	"./spei3_8_2021.png": 987896,
	"./spei3_8_2022.png": 859452,
	"./spei3_8_2023.png": 261648,
	"./spei3_9_1950.png": 260024,
	"./spei3_9_1951.png": 804100,
	"./spei3_9_1952.png": 309992,
	"./spei3_9_1953.png": 57084,
	"./spei3_9_1954.png": 223479,
	"./spei3_9_1955.png": 397428,
	"./spei3_9_1956.png": 822799,
	"./spei3_9_1957.png": 838128,
	"./spei3_9_1958.png": 915260,
	"./spei3_9_1959.png": 47728,
	"./spei3_9_1960.png": 206632,
	"./spei3_9_1961.png": 644104,
	"./spei3_9_1962.png": 246724,
	"./spei3_9_1963.png": 82164,
	"./spei3_9_1964.png": 103380,
	"./spei3_9_1965.png": 394468,
	"./spei3_9_1966.png": 245696,
	"./spei3_9_1967.png": 509292,
	"./spei3_9_1968.png": 829676,
	"./spei3_9_1969.png": 155232,
	"./spei3_9_1970.png": 309680,
	"./spei3_9_1971.png": 806412,
	"./spei3_9_1972.png": 796124,
	"./spei3_9_1973.png": 916752,
	"./spei3_9_1974.png": 156960,
	"./spei3_9_1975.png": 362680,
	"./spei3_9_1976.png": 9352,
	"./spei3_9_1977.png": 42652,
	"./spei3_9_1978.png": 692808,
	"./spei3_9_1979.png": 685484,
	"./spei3_9_1980.png": 849004,
	"./spei3_9_1981.png": 174560,
	"./spei3_9_1982.png": 631644,
	"./spei3_9_1983.png": 368332,
	"./spei3_9_1984.png": 909216,
	"./spei3_9_1985.png": 446484,
	"./spei3_9_1986.png": 284057,
	"./spei3_9_1987.png": 277956,
	"./spei3_9_1988.png": 225960,
	"./spei3_9_1989.png": 785396,
	"./spei3_9_1990.png": 934516,
	"./spei3_9_1991.png": 404892,
	"./spei3_9_1992.png": 420980,
	"./spei3_9_1993.png": 978928,
	"./spei3_9_1994.png": 490412,
	"./spei3_9_1995.png": 956132,
	"./spei3_9_1996.png": 844812,
	"./spei3_9_1997.png": 511464,
	"./spei3_9_1998.png": 329008,
	"./spei3_9_1999.png": 825740,
	"./spei3_9_2000.png": 263040,
	"./spei3_9_2001.png": 552,
	"./spei3_9_2002.png": 352276,
	"./spei3_9_2003.png": 418620,
	"./spei3_9_2004.png": 679248,
	"./spei3_9_2005.png": 789140,
	"./spei3_9_2006.png": 337732,
	"./spei3_9_2007.png": 836292,
	"./spei3_9_2008.png": 591064,
	"./spei3_9_2009.png": 872652,
	"./spei3_9_2010.png": 448740,
	"./spei3_9_2011.png": 429176,
	"./spei3_9_2012.png": 732760,
	"./spei3_9_2013.png": 780600,
	"./spei3_9_2014.png": 559968,
	"./spei3_9_2015.png": 776656,
	"./spei3_9_2016.png": 76076,
	"./spei3_9_2017.png": 192232,
	"./spei3_9_2018.png": 593396,
	"./spei3_9_2019.png": 964592,
	"./spei3_9_2020.png": 755448,
	"./spei3_9_2021.png": 108159,
	"./spei3_9_2022.png": 988448,
	"./spei3_9_2023.png": 113972,
	"./spei6_10_1950.png": 344572,
	"./spei6_10_1951.png": 891181,
	"./spei6_10_1952.png": 833916,
	"./spei6_10_1953.png": 383096,
	"./spei6_10_1954.png": 508660,
	"./spei6_10_1955.png": 373116,
	"./spei6_10_1956.png": 397836,
	"./spei6_10_1957.png": 814216,
	"./spei6_10_1958.png": 445640,
	"./spei6_10_1959.png": 736868,
	"./spei6_10_1960.png": 292656,
	"./spei6_10_1961.png": 38823,
	"./spei6_10_1962.png": 410464,
	"./spei6_10_1963.png": 762552,
	"./spei6_10_1964.png": 925712,
	"./spei6_10_1965.png": 550288,
	"./spei6_10_1966.png": 377160,
	"./spei6_10_1967.png": 878008,
	"./spei6_10_1968.png": 807832,
	"./spei6_10_1969.png": 813244,
	"./spei6_10_1970.png": 864992,
	"./spei6_10_1971.png": 5592,
	"./spei6_10_1972.png": 602620,
	"./spei6_10_1973.png": 931540,
	"./spei6_10_1974.png": 389804,
	"./spei6_10_1975.png": 611980,
	"./spei6_10_1976.png": 448484,
	"./spei6_10_1977.png": 122260,
	"./spei6_10_1978.png": 111413,
	"./spei6_10_1979.png": 361228,
	"./spei6_10_1980.png": 432644,
	"./spei6_10_1981.png": 972152,
	"./spei6_10_1982.png": 862248,
	"./spei6_10_1983.png": 572928,
	"./spei6_10_1984.png": 171525,
	"./spei6_10_1985.png": 163888,
	"./spei6_10_1986.png": 502256,
	"./spei6_10_1987.png": 240460,
	"./spei6_10_1988.png": 482960,
	"./spei6_10_1989.png": 107536,
	"./spei6_10_1990.png": 743548,
	"./spei6_10_1991.png": 742600,
	"./spei6_10_1992.png": 21864,
	"./spei6_10_1993.png": 830212,
	"./spei6_10_1994.png": 280047,
	"./spei6_10_1995.png": 102064,
	"./spei6_10_1996.png": 382796,
	"./spei6_10_1997.png": 302724,
	"./spei6_10_1998.png": 643552,
	"./spei6_10_1999.png": 957500,
	"./spei6_10_2000.png": 578759,
	"./spei6_10_2001.png": 713736,
	"./spei6_10_2002.png": 17320,
	"./spei6_10_2003.png": 228660,
	"./spei6_10_2004.png": 377476,
	"./spei6_10_2005.png": 147852,
	"./spei6_10_2006.png": 447536,
	"./spei6_10_2007.png": 675576,
	"./spei6_10_2008.png": 884940,
	"./spei6_10_2009.png": 328704,
	"./spei6_10_2010.png": 849856,
	"./spei6_10_2011.png": 250812,
	"./spei6_10_2012.png": 323232,
	"./spei6_10_2013.png": 596008,
	"./spei6_10_2014.png": 852516,
	"./spei6_10_2015.png": 530904,
	"./spei6_10_2016.png": 136536,
	"./spei6_10_2017.png": 890404,
	"./spei6_10_2018.png": 653080,
	"./spei6_10_2019.png": 132840,
	"./spei6_10_2020.png": 521824,
	"./spei6_10_2021.png": 936388,
	"./spei6_10_2022.png": 824720,
	"./spei6_10_2023.png": 588372,
	"./spei6_11_1950.png": 737724,
	"./spei6_11_1951.png": 736776,
	"./spei6_11_1952.png": 168040,
	"./spei6_11_1953.png": 723972,
	"./spei6_11_1954.png": 152259,
	"./spei6_11_1955.png": 995823,
	"./spei6_11_1956.png": 929132,
	"./spei6_11_1957.png": 296900,
	"./spei6_11_1958.png": 82488,
	"./spei6_11_1959.png": 951676,
	"./spei6_11_1960.png": 963992,
	"./spei6_11_1961.png": 128052,
	"./spei6_11_1962.png": 652140,
	"./spei6_11_1963.png": 520484,
	"./spei6_11_1964.png": 409552,
	"./spei6_11_1965.png": 597832,
	"./spei6_11_1966.png": 712352,
	"./spei6_11_1967.png": 255308,
	"./spei6_11_1968.png": 431340,
	"./spei6_11_1969.png": 287920,
	"./spei6_11_1970.png": 567548,
	"./spei6_11_1971.png": 592268,
	"./spei6_11_1972.png": 8648,
	"./spei6_11_1973.png": 539004,
	"./spei6_11_1974.png": 414948,
	"./spei6_11_1975.png": 797696,
	"./spei6_11_1976.png": 741180,
	"./spei6_11_1977.png": 703092,
	"./spei6_11_1978.png": 123856,
	"./spei6_11_1979.png": 950848,
	"./spei6_11_1980.png": 566032,
	"./spei6_11_1981.png": 939512,
	"./spei6_11_1982.png": 370140,
	"./spei6_11_1983.png": 818124,
	"./spei6_11_1984.png": 209612,
	"./spei6_11_1985.png": 208469,
	"./spei6_11_1986.png": 846468,
	"./spei6_11_1987.png": 145853,
	"./spei6_11_1988.png": 588820,
	"./spei6_11_1989.png": 384304,
	"./spei6_11_1990.png": 666680,
	"./spei6_11_1991.png": 997060,
	"./spei6_11_1992.png": 927668,
	"./spei6_11_1993.png": 177484,
	"./spei6_11_1994.png": 502836,
	"./spei6_11_1995.png": 589672,
	"./spei6_11_1996.png": 10812,
	"./spei6_11_1997.png": 322048,
	"./spei6_11_1998.png": 439816,
	"./spei6_11_1999.png": 731044,
	"./spei6_11_2000.png": 301500,
	"./spei6_11_2001.png": 94448,
	"./spei6_11_2002.png": 702180,
	"./spei6_11_2003.png": 810368,
	"./spei6_11_2004.png": 788692,
	"./spei6_11_2005.png": 313404,
	"./spei6_11_2006.png": 516344,
	"./spei6_11_2007.png": 576772,
	"./spei6_11_2008.png": 127868,
	"./spei6_11_2009.png": 841684,
	"./spei6_11_2010.png": 969573,
	"./spei6_11_2011.png": 871292,
	"./spei6_11_2012.png": 86380,
	"./spei6_11_2013.png": 264020,
	"./spei6_11_2014.png": 676200,
	"./spei6_11_2015.png": 657028,
	"./spei6_11_2016.png": 110388,
	"./spei6_11_2017.png": 700700,
	"./spei6_11_2018.png": 936076,
	"./spei6_11_2019.png": 94508,
	"./spei6_11_2020.png": 467908,
	"./spei6_11_2021.png": 370168,
	"./spei6_11_2022.png": 536692,
	"./spei6_11_2023.png": 194588,
	"./spei6_12_1950.png": 191180,
	"./spei6_12_1951.png": 989144,
	"./spei6_12_1952.png": 967076,
	"./spei6_12_1953.png": 339796,
	"./spei6_12_1954.png": 370624,
	"./spei6_12_1955.png": 214188,
	"./spei6_12_1956.png": 197616,
	"./spei6_12_1957.png": 682516,
	"./spei6_12_1958.png": 790517,
	"./spei6_12_1959.png": 344780,
	"./spei6_12_1960.png": 294140,
	"./spei6_12_1961.png": 534004,
	"./spei6_12_1962.png": 843304,
	"./spei6_12_1963.png": 187332,
	"./spei6_12_1964.png": 380528,
	"./spei6_12_1965.png": 1712,
	"./spei6_12_1966.png": 392492,
	"./spei6_12_1967.png": 426904,
	"./spei6_12_1968.png": 158756,
	"./spei6_12_1969.png": 556560,
	"./spei6_12_1970.png": 964320,
	"./spei6_12_1971.png": 507276,
	"./spei6_12_1972.png": 932815,
	"./spei6_12_1973.png": 154248,
	"./spei6_12_1974.png": 662912,
	"./spei6_12_1975.png": 229924,
	"./spei6_12_1976.png": 215960,
	"./spei6_12_1977.png": 684468,
	"./spei6_12_1978.png": 411880,
	"./spei6_12_1979.png": 489844,
	"./spei6_12_1980.png": 65324,
	"./spei6_12_1981.png": 727208,
	"./spei6_12_1982.png": 655340,
	"./spei6_12_1983.png": 471516,
	"./spei6_12_1984.png": 375824,
	"./spei6_12_1985.png": 414208,
	"./spei6_12_1986.png": 961712,
	"./spei6_12_1987.png": 793656,
	"./spei6_12_1988.png": 90212,
	"./spei6_12_1989.png": 49664,
	"./spei6_12_1990.png": 792204,
	"./spei6_12_1991.png": 816,
	"./spei6_12_1992.png": 880544,
	"./spei6_12_1993.png": 622439,
	"./spei6_12_1994.png": 642300,
	"./spei6_12_1995.png": 191480,
	"./spei6_12_1996.png": 19228,
	"./spei6_12_1997.png": 493388,
	"./spei6_12_1998.png": 168472,
	"./spei6_12_1999.png": 522184,
	"./spei6_12_2000.png": 135112,
	"./spei6_12_2001.png": 123660,
	"./spei6_12_2002.png": 9504,
	"./spei6_12_2003.png": 505424,
	"./spei6_12_2004.png": 976448,
	"./spei6_12_2005.png": 509495,
	"./spei6_12_2006.png": 872872,
	"./spei6_12_2007.png": 229980,
	"./spei6_12_2008.png": 697804,
	"./spei6_12_2009.png": 768024,
	"./spei6_12_2010.png": 429896,
	"./spei6_12_2011.png": 279556,
	"./spei6_12_2012.png": 36936,
	"./spei6_12_2013.png": 324728,
	"./spei6_12_2014.png": 972600,
	"./spei6_12_2015.png": 975832,
	"./spei6_12_2016.png": 374496,
	"./spei6_12_2017.png": 713384,
	"./spei6_12_2018.png": 966212,
	"./spei6_12_2019.png": 410280,
	"./spei6_12_2020.png": 535924,
	"./spei6_12_2021.png": 570484,
	"./spei6_12_2022.png": 752492,
	"./spei6_12_2023.png": 102724,
	"./spei6_1_1950.png": 346096,
	"./spei6_1_1951.png": 381191,
	"./spei6_1_1952.png": 776612,
	"./spei6_1_1953.png": 232620,
	"./spei6_1_1954.png": 673620,
	"./spei6_1_1955.png": 56904,
	"./spei6_1_1956.png": 609400,
	"./spei6_1_1957.png": 810856,
	"./spei6_1_1958.png": 160264,
	"./spei6_1_1959.png": 280920,
	"./spei6_1_1960.png": 304024,
	"./spei6_1_1961.png": 604096,
	"./spei6_1_1962.png": 359524,
	"./spei6_1_1963.png": 239252,
	"./spei6_1_1964.png": 80008,
	"./spei6_1_1965.png": 549413,
	"./spei6_1_1966.png": 997396,
	"./spei6_1_1967.png": 792880,
	"./spei6_1_1968.png": 39880,
	"./spei6_1_1969.png": 103016,
	"./spei6_1_1970.png": 773244,
	"./spei6_1_1971.png": 524528,
	"./spei6_1_1972.png": 955559,
	"./spei6_1_1973.png": 825860,
	"./spei6_1_1974.png": 547972,
	"./spei6_1_1975.png": 831528,
	"./spei6_1_1976.png": 488344,
	"./spei6_1_1977.png": 700244,
	"./spei6_1_1978.png": 797284,
	"./spei6_1_1979.png": 475672,
	"./spei6_1_1980.png": 313264,
	"./spei6_1_1981.png": 483028,
	"./spei6_1_1982.png": 130948,
	"./spei6_1_1983.png": 731096,
	"./spei6_1_1984.png": 275020,
	"./spei6_1_1985.png": 607988,
	"./spei6_1_1986.png": 90328,
	"./spei6_1_1987.png": 78332,
	"./spei6_1_1988.png": 161684,
	"./spei6_1_1989.png": 610880,
	"./spei6_1_1990.png": 479388,
	"./spei6_1_1991.png": 995348,
	"./spei6_1_1992.png": 245768,
	"./spei6_1_1993.png": 675319,
	"./spei6_1_1994.png": 866461,
	"./spei6_1_1995.png": 616079,
	"./spei6_1_1996.png": 149696,
	"./spei6_1_1997.png": 646328,
	"./spei6_1_1998.png": 824708,
	"./spei6_1_1999.png": 475376,
	"./spei6_1_2000.png": 72288,
	"./spei6_1_2001.png": 840216,
	"./spei6_1_2002.png": 554212,
	"./spei6_1_2003.png": 220904,
	"./spei6_1_2004.png": 705344,
	"./spei6_1_2005.png": 43712,
	"./spei6_1_2006.png": 48688,
	"./spei6_1_2007.png": 47272,
	"./spei6_1_2008.png": 641588,
	"./spei6_1_2009.png": 709536,
	"./spei6_1_2010.png": 937628,
	"./spei6_1_2011.png": 53616,
	"./spei6_1_2012.png": 791820,
	"./spei6_1_2013.png": 862040,
	"./spei6_1_2014.png": 713500,
	"./spei6_1_2015.png": 585909,
	"./spei6_1_2016.png": 865172,
	"./spei6_1_2017.png": 16856,
	"./spei6_1_2018.png": 342520,
	"./spei6_1_2019.png": 814871,
	"./spei6_1_2020.png": 243029,
	"./spei6_1_2021.png": 727468,
	"./spei6_1_2022.png": 949645,
	"./spei6_1_2023.png": 70812,
	"./spei6_2_1950.png": 389812,
	"./spei6_2_1951.png": 921492,
	"./spei6_2_1952.png": 133080,
	"./spei6_2_1953.png": 805296,
	"./spei6_2_1954.png": 798068,
	"./spei6_2_1955.png": 77920,
	"./spei6_2_1956.png": 620876,
	"./spei6_2_1957.png": 198416,
	"./spei6_2_1958.png": 54912,
	"./spei6_2_1959.png": 192448,
	"./spei6_2_1960.png": 759541,
	"./spei6_2_1961.png": 313804,
	"./spei6_2_1962.png": 203556,
	"./spei6_2_1963.png": 617028,
	"./spei6_2_1964.png": 723836,
	"./spei6_2_1965.png": 61248,
	"./spei6_2_1966.png": 936100,
	"./spei6_2_1967.png": 180880,
	"./spei6_2_1968.png": 676556,
	"./spei6_2_1969.png": 958168,
	"./spei6_2_1970.png": 166948,
	"./spei6_2_1971.png": 33344,
	"./spei6_2_1972.png": 754448,
	"./spei6_2_1973.png": 938740,
	"./spei6_2_1974.png": 25576,
	"./spei6_2_1975.png": 827916,
	"./spei6_2_1976.png": 244296,
	"./spei6_2_1977.png": 552272,
	"./spei6_2_1978.png": 215072,
	"./spei6_2_1979.png": 179348,
	"./spei6_2_1980.png": 870740,
	"./spei6_2_1981.png": 607476,
	"./spei6_2_1982.png": 67064,
	"./spei6_2_1983.png": 605628,
	"./spei6_2_1984.png": 669992,
	"./spei6_2_1985.png": 380672,
	"./spei6_2_1986.png": 1856,
	"./spei6_2_1987.png": 719132,
	"./spei6_2_1988.png": 575628,
	"./spei6_2_1989.png": 977824,
	"./spei6_2_1990.png": 611752,
	"./spei6_2_1991.png": 145968,
	"./spei6_2_1992.png": 98996,
	"./spei6_2_1993.png": 261048,
	"./spei6_2_1994.png": 678168,
	"./spei6_2_1995.png": 280436,
	"./spei6_2_1996.png": 450936,
	"./spei6_2_1997.png": 380351,
	"./spei6_2_1998.png": 382300,
	"./spei6_2_1999.png": 184824,
	"./spei6_2_2000.png": 159356,
	"./spei6_2_2001.png": 793608,
	"./spei6_2_2002.png": 295252,
	"./spei6_2_2003.png": 446936,
	"./spei6_2_2004.png": 884060,
	"./spei6_2_2005.png": 605660,
	"./spei6_2_2006.png": 151520,
	"./spei6_2_2007.png": 930436,
	"./spei6_2_2008.png": 469944,
	"./spei6_2_2009.png": 8508,
	"./spei6_2_2010.png": 452076,
	"./spei6_2_2011.png": 150112,
	"./spei6_2_2012.png": 950032,
	"./spei6_2_2013.png": 141428,
	"./spei6_2_2014.png": 166444,
	"./spei6_2_2015.png": 763492,
	"./spei6_2_2016.png": 597528,
	"./spei6_2_2017.png": 327304,
	"./spei6_2_2018.png": 641448,
	"./spei6_2_2019.png": 749448,
	"./spei6_2_2020.png": 824352,
	"./spei6_2_2021.png": 331156,
	"./spei6_2_2022.png": 36908,
	"./spei6_2_2023.png": 853084,
	"./spei6_3_1950.png": 752240,
	"./spei6_3_1951.png": 656547,
	"./spei6_3_1952.png": 39276,
	"./spei6_3_1953.png": 565232,
	"./spei6_3_1954.png": 850788,
	"./spei6_3_1955.png": 72892,
	"./spei6_3_1956.png": 223231,
	"./spei6_3_1957.png": 124000,
	"./spei6_3_1958.png": 421956,
	"./spei6_3_1959.png": 651416,
	"./spei6_3_1960.png": 774112,
	"./spei6_3_1961.png": 224928,
	"./spei6_3_1962.png": 625884,
	"./spei6_3_1963.png": 383648,
	"./spei6_3_1964.png": 347924,
	"./spei6_3_1965.png": 19500,
	"./spei6_3_1966.png": 293148,
	"./spei6_3_1967.png": 528080,
	"./spei6_3_1968.png": 461261,
	"./spei6_3_1969.png": 571848,
	"./spei6_3_1970.png": 343736,
	"./spei6_3_1971.png": 774364,
	"./spei6_3_1972.png": 999967,
	"./spei6_3_1973.png": 391456,
	"./spei6_3_1974.png": 439348,
	"./spei6_3_1975.png": 811536,
	"./spei6_3_1976.png": 593632,
	"./spei6_3_1977.png": 40636,
	"./spei6_3_1978.png": 923744,
	"./spei6_3_1979.png": 221700,
	"./spei6_3_1980.png": 991808,
	"./spei6_3_1981.png": 331164,
	"./spei6_3_1982.png": 930800,
	"./spei6_3_1983.png": 727884,
	"./spei6_3_1984.png": 9496,
	"./spei6_3_1985.png": 987428,
	"./spei6_3_1986.png": 360148,
	"./spei6_3_1987.png": 390976,
	"./spei6_3_1988.png": 574896,
	"./spei6_3_1989.png": 142440,
	"./spei6_3_1990.png": 554356,
	"./spei6_3_1991.png": 863656,
	"./spei6_3_1992.png": 207684,
	"./spei6_3_1993.png": 400880,
	"./spei6_3_1994.png": 63028,
	"./spei6_3_1995.png": 394912,
	"./spei6_3_1996.png": 125676,
	"./spei6_3_1997.png": 314492,
	"./spei6_3_1998.png": 765100,
	"./spei6_3_1999.png": 364736,
	"./spei6_3_2000.png": 766444,
	"./spei6_3_2001.png": 141112,
	"./spei6_3_2002.png": 97112,
	"./spei6_3_2003.png": 27720,
	"./spei6_3_2004.png": 499916,
	"./spei6_3_2005.png": 972492,
	"./spei6_3_2006.png": 550032,
	"./spei6_3_2007.png": 519048,
	"./spei6_3_2008.png": 50728,
	"./spei6_3_2009.png": 273900,
	"./spei6_3_2010.png": 285952,
	"./spei6_3_2011.png": 738520,
	"./spei6_3_2012.png": 406387,
	"./spei6_3_2013.png": 950380,
	"./spei6_3_2014.png": 208004,
	"./spei6_3_2015.png": 973071,
	"./spei6_3_2016.png": 207448,
	"./spei6_3_2017.png": 725108,
	"./spei6_3_2018.png": 101736,
	"./spei6_3_2019.png": 687928,
	"./spei6_3_2020.png": 176236,
	"./spei6_3_2021.png": 370976,
	"./spei6_3_2022.png": 97764,
	"./spei6_3_2023.png": 803516,
	"./spei6_4_1950.png": 135132,
	"./spei6_4_1951.png": 190420,
	"./spei6_4_1952.png": 961392,
	"./spei6_4_1953.png": 237572,
	"./spei6_4_1954.png": 664320,
	"./spei6_4_1955.png": 401832,
	"./spei6_4_1956.png": 531176,
	"./spei6_4_1957.png": 819900,
	"./spei6_4_1958.png": 768328,
	"./spei6_4_1959.png": 472824,
	"./spei6_4_1960.png": 266084,
	"./spei6_4_1961.png": 823072,
	"./spei6_4_1962.png": 733152,
	"./spei6_4_1963.png": 602220,
	"./spei6_4_1964.png": 971688,
	"./spei6_4_1965.png": 808204,
	"./spei6_4_1966.png": 143068,
	"./spei6_4_1967.png": 754940,
	"./spei6_4_1968.png": 794452,
	"./spei6_4_1969.png": 55080,
	"./spei6_4_1970.png": 415900,
	"./spei6_4_1971.png": 97827,
	"./spei6_4_1972.png": 393180,
	"./spei6_4_1973.png": 612124,
	"./spei6_4_1974.png": 444069,
	"./spei6_4_1975.png": 997820,
	"./spei6_4_1976.png": 32440,
	"./spei6_4_1977.png": 565280,
	"./spei6_4_1978.png": 346884,
	"./spei6_4_1979.png": 193112,
	"./spei6_4_1980.png": 894636,
	"./spei6_4_1981.png": 365220,
	"./spei6_4_1982.png": 837540,
	"./spei6_4_1983.png": 501228,
	"./spei6_4_1984.png": 393796,
	"./spei6_4_1985.png": 192604,
	"./spei6_4_1986.png": 240200,
	"./spei6_4_1987.png": 824416,
	"./spei6_4_1988.png": 511676,
	"./spei6_4_1989.png": 913872,
	"./spei6_4_1990.png": 447436,
	"./spei6_4_1991.png": 746252,
	"./spei6_4_1992.png": 510348,
	"./spei6_4_1993.png": 318240,
	"./spei6_4_1994.png": 282516,
	"./spei6_4_1995.png": 731712,
	"./spei6_4_1996.png": 768980,
	"./spei6_4_1997.png": 756644,
	"./spei6_4_1998.png": 411628,
	"./spei6_4_1999.png": 606856,
	"./spei6_4_2000.png": 786740,
	"./spei6_4_2001.png": 213532,
	"./spei6_4_2002.png": 163404,
	"./spei6_4_2003.png": 372252,
	"./spei6_4_2004.png": 691128,
	"./spei6_4_2005.png": 899376,
	"./spei6_4_2006.png": 569740,
	"./spei6_4_2007.png": 961228,
	"./spei6_4_2008.png": 712368,
	"./spei6_4_2009.png": 997924,
	"./spei6_4_2010.png": 447100,
	"./spei6_4_2011.png": 849296,
	"./spei6_4_2012.png": 352876,
	"./spei6_4_2013.png": 177232,
	"./spei6_4_2014.png": 28477,
	"./spei6_4_2015.png": 560212,
	"./spei6_4_2016.png": 326984,
	"./spei6_4_2017.png": 908536,
	"./spei6_4_2018.png": 126436,
	"./spei6_4_2019.png": 559040,
	"./spei6_4_2020.png": 274640,
	"./spei6_4_2021.png": 595844,
	"./spei6_4_2022.png": 879400,
	"./spei6_4_2023.png": 820704,
	"./spei6_5_1950.png": 582588,
	"./spei6_5_1951.png": 825732,
	"./spei6_5_1952.png": 492180,
	"./spei6_5_1953.png": 960500,
	"./spei6_5_1954.png": 769104,
	"./spei6_5_1955.png": 121184,
	"./spei6_5_1956.png": 718988,
	"./spei6_5_1957.png": 246792,
	"./spei6_5_1958.png": 257640,
	"./spei6_5_1959.png": 842096,
	"./spei6_5_1960.png": 892292,
	"./spei6_5_1961.png": 812424,
	"./spei6_5_1962.png": 752448,
	"./spei6_5_1963.png": 256440,
	"./spei6_5_1964.png": 215888,
	"./spei6_5_1965.png": 526132,
	"./spei6_5_1966.png": 518688,
	"./spei6_5_1967.png": 61644,
	"./spei6_5_1968.png": 221900,
	"./spei6_5_1969.png": 94256,
	"./spei6_5_1970.png": 449624,
	"./spei6_5_1971.png": 543988,
	"./spei6_5_1972.png": 569412,
	"./spei6_5_1973.png": 14332,
	"./spei6_5_1974.png": 294624,
	"./spei6_5_1975.png": 99884,
	"./spei6_5_1976.png": 858752,
	"./spei6_5_1977.png": 853848,
	"./spei6_5_1978.png": 407860,
	"./spei6_5_1979.png": 561021,
	"./spei6_5_1980.png": 971460,
	"./spei6_5_1981.png": 693572,
	"./spei6_5_1982.png": 977128,
	"./spei6_5_1983.png": 856324,
	"./spei6_5_1984.png": 68224,
	"./spei6_5_1985.png": 942884,
	"./spei6_5_1986.png": 610708,
	"./spei6_5_1987.png": 993992,
	"./spei6_5_1988.png": 463772,
	"./spei6_5_1989.png": 476323,
	"./spei6_5_1990.png": 814076,
	"./spei6_5_1991.png": 988101,
	"./spei6_5_1992.png": 121352,
	"./spei6_5_1993.png": 281037,
	"./spei6_5_1994.png": 9368,
	"./spei6_5_1995.png": 163140,
	"./spei6_5_1996.png": 962216,
	"./spei6_5_1997.png": 107888,
	"./spei6_5_1998.png": 273804,
	"./spei6_5_1999.png": 141212,
	"./spei6_5_2000.png": 188388,
	"./spei6_5_2001.png": 254028,
	"./spei6_5_2002.png": 326416,
	"./spei6_5_2003.png": 53236,
	"./spei6_5_2004.png": 893992,
	"./spei6_5_2005.png": 730508,
	"./spei6_5_2006.png": 112712,
	"./spei6_5_2007.png": 454864,
	"./spei6_5_2008.png": 540960,
	"./spei6_5_2009.png": 47764,
	"./spei6_5_2010.png": 588260,
	"./spei6_5_2011.png": 415220,
	"./spei6_5_2012.png": 780284,
	"./spei6_5_2013.png": 470503,
	"./spei6_5_2014.png": 435308,
	"./spei6_5_2015.png": 860216,
	"./spei6_5_2016.png": 842740,
	"./spei6_5_2017.png": 266648,
	"./spei6_5_2018.png": 591564,
	"./spei6_5_2019.png": 378672,
	"./spei6_5_2020.png": 517736,
	"./spei6_5_2021.png": 21916,
	"./spei6_5_2022.png": 187080,
	"./spei6_5_2023.png": 282104,
	"./spei6_6_1950.png": 327128,
	"./spei6_6_1951.png": 546164,
	"./spei6_6_1952.png": 780132,
	"./spei6_6_1953.png": 752269,
	"./spei6_6_1954.png": 929064,
	"./spei6_6_1955.png": 786640,
	"./spei6_6_1956.png": 16912,
	"./spei6_6_1957.png": 155836,
	"./spei6_6_1958.png": 549856,
	"./spei6_6_1959.png": 808439,
	"./spei6_6_1960.png": 411476,
	"./spei6_6_1961.png": 224400,
	"./spei6_6_1962.png": 798164,
	"./spei6_6_1963.png": 503916,
	"./spei6_6_1964.png": 429888,
	"./spei6_6_1965.png": 467156,
	"./spei6_6_1966.png": 480908,
	"./spei6_6_1967.png": 924672,
	"./spei6_6_1968.png": 583568,
	"./spei6_6_1969.png": 787896,
	"./spei6_6_1970.png": 226104,
	"./spei6_6_1971.png": 126872,
	"./spei6_6_1972.png": 732504,
	"./spei6_6_1973.png": 486372,
	"./spei6_6_1974.png": 445824,
	"./spei6_6_1975.png": 776400,
	"./spei6_6_1976.png": 853440,
	"./spei6_6_1977.png": 191976,
	"./spei6_6_1978.png": 670524,
	"./spei6_6_1979.png": 447984,
	"./spei6_6_1980.png": 149167,
	"./spei6_6_1981.png": 487536,
	"./spei6_6_1982.png": 125735,
	"./spei6_6_1983.png": 566232,
	"./spei6_6_1984.png": 58640,
	"./spei6_6_1985.png": 128072,
	"./spei6_6_1986.png": 588908,
	"./spei6_6_1987.png": 993304,
	"./spei6_6_1988.png": 72888,
	"./spei6_6_1989.png": 225092,
	"./spei6_6_1990.png": 420392,
	"./spei6_6_1991.png": 584684,
	"./spei6_6_1992.png": 338520,
	"./spei6_6_1993.png": 578800,
	"./spei6_6_1994.png": 246760,
	"./spei6_6_1995.png": 83912,
	"./spei6_6_1996.png": 459455,
	"./spei6_6_1997.png": 133648,
	"./spei6_6_1998.png": 43436,
	"./spei6_6_1999.png": 63780,
	"./spei6_6_2000.png": 472500,
	"./spei6_6_2001.png": 507060,
	"./spei6_6_2002.png": 929048,
	"./spei6_6_2003.png": 677640,
	"./spei6_6_2004.png": 271216,
	"./spei6_6_2005.png": 819212,
	"./spei6_6_2006.png": 326468,
	"./spei6_6_2007.png": 346936,
	"./spei6_6_2008.png": 104720,
	"./spei6_6_2009.png": 414964,
	"./spei6_6_2010.png": 521216,
	"./spei6_6_2011.png": 906396,
	"./spei6_6_2012.png": 910260,
	"./spei6_6_2013.png": 267368,
	"./spei6_6_2014.png": 523876,
	"./spei6_6_2015.png": 202264,
	"./spei6_6_2016.png": 682568,
	"./spei6_6_2017.png": 561764,
	"./spei6_6_2018.png": 546820,
	"./spei6_6_2019.png": 26580,
	"./spei6_6_2020.png": 484776,
	"./spei6_6_2021.png": 649068,
	"./spei6_6_2022.png": 487236,
	"./spei6_6_2023.png": 290680,
	"./spei6_7_1950.png": 309944,
	"./spei6_7_1951.png": 609500,
	"./spei6_7_1952.png": 437228,
	"./spei6_7_1953.png": 21436,
	"./spei6_7_1954.png": 85928,
	"./spei6_7_1955.png": 838124,
	"./spei6_7_1956.png": 3764,
	"./spei6_7_1957.png": 366984,
	"./spei6_7_1958.png": 803276,
	"./spei6_7_1959.png": 407076,
	"./spei6_7_1960.png": 852607,
	"./spei6_7_1961.png": 837356,
	"./spei6_7_1962.png": 730780,
	"./spei6_7_1963.png": 467468,
	"./spei6_7_1964.png": 808460,
	"./spei6_7_1965.png": 632040,
	"./spei6_7_1966.png": 313836,
	"./spei6_7_1967.png": 834564,
	"./spei6_7_1968.png": 359272,
	"./spei6_7_1969.png": 331528,
	"./spei6_7_1970.png": 380808,
	"./spei6_7_1971.png": 410628,
	"./spei6_7_1972.png": 997900,
	"./spei6_7_1973.png": 205184,
	"./spei6_7_1974.png": 111861,
	"./spei6_7_1975.png": 534440,
	"./spei6_7_1976.png": 471544,
	"./spei6_7_1977.png": 921632,
	"./spei6_7_1978.png": 813932,
	"./spei6_7_1979.png": 455560,
	"./spei6_7_1980.png": 987856,
	"./spei6_7_1981.png": 262716,
	"./spei6_7_1982.png": 388416,
	"./spei6_7_1983.png": 18441,
	"./spei6_7_1984.png": 266588,
	"./spei6_7_1985.png": 479564,
	"./spei6_7_1986.png": 370004,
	"./spei6_7_1987.png": 211988,
	"./spei6_7_1988.png": 852472,
	"./spei6_7_1989.png": 370372,
	"./spei6_7_1990.png": 401248,
	"./spei6_7_1991.png": 919148,
	"./spei6_7_1992.png": 975440,
	"./spei6_7_1993.png": 138540,
	"./spei6_7_1994.png": 256684,
	"./spei6_7_1995.png": 857884,
	"./spei6_7_1996.png": 738660,
	"./spei6_7_1997.png": 160824,
	"./spei6_7_1998.png": 231816,
	"./spei6_7_1999.png": 199572,
	"./spei6_7_2000.png": 572,
	"./spei6_7_2001.png": 811240,
	"./spei6_7_2002.png": 354200,
	"./spei6_7_2003.png": 234355,
	"./spei6_7_2004.png": 747124,
	"./spei6_7_2005.png": 591912,
	"./spei6_7_2006.png": 697516,
	"./spei6_7_2007.png": 402876,
	"./spei6_7_2008.png": 968756,
	"./spei6_7_2009.png": 302516,
	"./spei6_7_2010.png": 538904,
	"./spei6_7_2011.png": 35852,
	"./spei6_7_2012.png": 989156,
	"./spei6_7_2013.png": 629840,
	"./spei6_7_2014.png": 965976,
	"./spei6_7_2015.png": 814500,
	"./spei6_7_2016.png": 238792,
	"./spei6_7_2017.png": 272092,
	"./spei6_7_2018.png": 145468,
	"./spei6_7_2019.png": 914924,
	"./spei6_7_2020.png": 478096,
	"./spei6_7_2021.png": 546352,
	"./spei6_7_2022.png": 101036,
	"./spei6_7_2023.png": 25033,
	"./spei6_8_1950.png": 888017,
	"./spei6_8_1951.png": 823696,
	"./spei6_8_1952.png": 453392,
	"./spei6_8_1953.png": 839180,
	"./spei6_8_1954.png": 706612,
	"./spei6_8_1955.png": 912164,
	"./spei6_8_1956.png": 590732,
	"./spei6_8_1957.png": 124152,
	"./spei6_8_1958.png": 791220,
	"./spei6_8_1959.png": 154440,
	"./spei6_8_1960.png": 96812,
	"./spei6_8_1961.png": 488152,
	"./spei6_8_1962.png": 341364,
	"./spei6_8_1963.png": 146728,
	"./spei6_8_1964.png": 109132,
	"./spei6_8_1965.png": 452468,
	"./spei6_8_1966.png": 336796,
	"./spei6_8_1967.png": 973096,
	"./spei6_8_1968.png": 254924,
	"./spei6_8_1969.png": 518236,
	"./spei6_8_1970.png": 13944,
	"./spei6_8_1971.png": 267909,
	"./spei6_8_1972.png": 146555,
	"./spei6_8_1973.png": 811056,
	"./spei6_8_1974.png": 468600,
	"./spei6_8_1975.png": 139820,
	"./spei6_8_1976.png": 93124,
	"./spei6_8_1977.png": 53212,
	"./spei6_8_1978.png": 784976,
	"./spei6_8_1979.png": 853232,
	"./spei6_8_1980.png": 291756,
	"./spei6_8_1981.png": 931840,
	"./spei6_8_1982.png": 173352,
	"./spei6_8_1983.png": 313400,
	"./spei6_8_1984.png": 188676,
	"./spei6_8_1985.png": 84976,
	"./spei6_8_1986.png": 417364,
	"./spei6_8_1987.png": 772560,
	"./spei6_8_1988.png": 222740,
	"./spei6_8_1989.png": 237448,
	"./spei6_8_1990.png": 743840,
	"./spei6_8_1991.png": 340652,
	"./spei6_8_1992.png": 459820,
	"./spei6_8_1993.png": 915828,
	"./spei6_8_1994.png": 611228,
	"./spei6_8_1995.png": 739236,
	"./spei6_8_1996.png": 834384,
	"./spei6_8_1997.png": 377340,
	"./spei6_8_1998.png": 897672,
	"./spei6_8_1999.png": 52396,
	"./spei6_8_2000.png": 60944,
	"./spei6_8_2001.png": 371188,
	"./spei6_8_2002.png": 680488,
	"./spei6_8_2003.png": 902552,
	"./spei6_8_2004.png": 339676,
	"./spei6_8_2005.png": 561852,
	"./spei6_8_2006.png": 971488,
	"./spei6_8_2007.png": 264088,
	"./spei6_8_2008.png": 995940,
	"./spei6_8_2009.png": 393744,
	"./spei6_8_2010.png": 649504,
	"./spei6_8_2011.png": 757728,
	"./spei6_8_2012.png": 476028,
	"./spei6_8_2013.png": 991432,
	"./spei6_8_2014.png": 500096,
	"./spei6_8_2015.png": 996728,
	"./spei6_8_2016.png": 175108,
	"./spei6_8_2017.png": 883336,
	"./spei6_8_2018.png": 249064,
	"./spei6_8_2019.png": 327028,
	"./spei6_8_2020.png": 455764,
	"./spei6_8_2021.png": 716392,
	"./spei6_8_2022.png": 492524,
	"./spei6_8_2023.png": 109352,
	"./spei6_9_1950.png": 130396,
	"./spei6_9_1951.png": 34704,
	"./spei6_9_1952.png": 417424,
	"./spei6_9_1953.png": 842972,
	"./spei6_9_1954.png": 674916,
	"./spei6_9_1955.png": 228668,
	"./spei6_9_1956.png": 222860,
	"./spei6_9_1957.png": 796128,
	"./spei6_9_1958.png": 577732,
	"./spei6_9_1959.png": 545924,
	"./spei6_9_1960.png": 274552,
	"./spei6_9_1961.png": 53920,
	"./spei6_9_1962.png": 812000,
	"./spei6_9_1963.png": 711104,
	"./spei6_9_1964.png": 202536,
	"./spei6_9_1965.png": 39052,
	"./spei6_9_1966.png": 857564,
	"./spei6_9_1967.png": 985788,
	"./spei6_9_1968.png": 25300,
	"./spei6_9_1969.png": 356308,
	"./spei6_9_1970.png": 567716,
	"./spei6_9_1971.png": 421268,
	"./spei6_9_1972.png": 969860,
	"./spei6_9_1973.png": 197900,
	"./spei6_9_1974.png": 113060,
	"./spei6_9_1975.png": 510864,
	"./spei6_9_1976.png": 610024,
	"./spei6_9_1977.png": 365056,
	"./spei6_9_1978.png": 818480,
	"./spei6_9_1979.png": 956015,
	"./spei6_9_1980.png": 181932,
	"./spei6_9_1981.png": 626980,
	"./spei6_9_1982.png": 715760,
	"./spei6_9_1983.png": 565172,
	"./spei6_9_1984.png": 845024,
	"./spei6_9_1985.png": 387980,
	"./spei6_9_1986.png": 643160,
	"./spei6_9_1987.png": 34952,
	"./spei6_9_1988.png": 536596,
	"./spei6_9_1989.png": 673613,
	"./spei6_9_1990.png": 174844,
	"./spei6_9_1991.png": 809096,
	"./spei6_9_1992.png": 727404,
	"./spei6_9_1993.png": 584388,
	"./spei6_9_1994.png": 261232,
	"./spei6_9_1995.png": 398768,
	"./spei6_9_1996.png": 223804,
	"./spei6_9_1997.png": 945924,
	"./spei6_9_1998.png": 485432,
	"./spei6_9_1999.png": 23996,
	"./spei6_9_2000.png": 914260,
	"./spei6_9_2001.png": 543980,
	"./spei6_9_2002.png": 683912,
	"./spei6_9_2003.png": 906556,
	"./spei6_9_2004.png": 984240,
	"./spei6_9_2005.png": 683376,
	"./spei6_9_2006.png": 434276,
	"./spei6_9_2007.png": 43548,
	"./spei6_9_2008.png": 923264,
	"./spei6_9_2009.png": 180364,
	"./spei6_9_2010.png": 891603,
	"./spei6_9_2011.png": 535828,
	"./spei6_9_2012.png": 923596,
	"./spei6_9_2013.png": 376092,
	"./spei6_9_2014.png": 500868,
	"./spei6_9_2015.png": 229684,
	"./spei6_9_2016.png": 103268,
	"./spei6_9_2017.png": 14060,
	"./spei6_9_2018.png": 293028,
	"./spei6_9_2019.png": 2560,
	"./spei6_9_2020.png": 247420,
	"./spei6_9_2021.png": 736504,
	"./spei6_9_2022.png": 637296,
	"./spei6_9_2023.png": 980160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942611;